
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fHbvp", function(module, exports) {

$parcel$export(module.exports, "AnalyticsBrowser", function () { return $b6d3cbf1ee84eef6$export$f483b44f21cbe352; });

var $l73V3 = parcelRequire("l73V3");

var $jRETX = parcelRequire("jRETX");

var $9yWXi = parcelRequire("9yWXi");

var $llDp8 = parcelRequire("llDp8");

var $5Z7ek = parcelRequire("5Z7ek");

var $4r2Y5 = parcelRequire("4r2Y5");

var $2maFQ = parcelRequire("2maFQ");

var $31dco = parcelRequire("31dco");

var $dHQJ4 = parcelRequire("dHQJ4");

var $6N780 = parcelRequire("6N780");

var $4pRMy = parcelRequire("4pRMy");

var $l6Or6 = parcelRequire("l6Or6");

var $dSmJd = parcelRequire("dSmJd");

var $80xCC = parcelRequire("80xCC");

var $IQ4PO = parcelRequire("IQ4PO");
function $b6d3cbf1ee84eef6$export$ea4eec5233d33a41(writeKey, cdnURL) {
    var baseUrl = cdnURL !== null && cdnURL !== void 0 ? cdnURL : (0, $9yWXi.getCDN)();
    return (0, $llDp8.fetch)("".concat(baseUrl, "/v1/projects/").concat(writeKey, "/settings")).then(function(res) {
        if (!res.ok) return res.text().then(function(errorResponseMessage) {
            throw new Error(errorResponseMessage);
        });
        return res.json();
    }).catch(function(err) {
        console.error(err.message);
        throw err;
    });
}
function $b6d3cbf1ee84eef6$var$hasLegacyDestinations(settings) {
    return (0, $jRETX.getProcessEnv)().NODE_ENV !== 'test' && // just one integration means customerio
    Object.keys(settings.integrations).length > 1;
}
function $b6d3cbf1ee84eef6$var$hasTsubMiddleware(settings) {
    var _a, _b, _c;
    return (0, $jRETX.getProcessEnv)().NODE_ENV !== 'test' && ((_c = (_b = (_a = settings.middlewareSettings) === null || _a === void 0 ? void 0 : _a.routingRules) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
}
/**
 * With AJS classic, we allow users to call setAnonymousId before the library initialization.
 * This is important because some of the destinations will use the anonymousId during the initialization,
 * and if we set anonId afterwards, that wouldn’t impact the destination.
 *
 * Also Ensures events can be registered before library initialization.
 * This is important so users can register to 'initialize' and any events that may fire early during setup.
 */ function $b6d3cbf1ee84eef6$var$flushPreBuffer(analytics, buffer) {
    buffer.push.apply(buffer, (0, $dSmJd.popSnippetWindowBuffer)());
    (0, $l6Or6.flushSetAnonymousID)(analytics, buffer);
    (0, $l6Or6.flushOn)(analytics, buffer);
}
/**
 * Finish flushing buffer and cleanup.
 */ function $b6d3cbf1ee84eef6$var$flushFinalBuffer(analytics, buffer) {
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        return (0, $l73V3.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    // Call popSnippetWindowBuffer before each flush task since there may be
                    // analytics calls during async function calls.
                    buffer.push.apply(buffer, (0, $dSmJd.popSnippetWindowBuffer)());
                    return [
                        4 /*yield*/ ,
                        (0, $l6Or6.flushAddSourceMiddleware)(analytics, buffer)
                    ];
                case 1:
                    _a.sent();
                    buffer.push.apply(buffer, (0, $dSmJd.popSnippetWindowBuffer)());
                    (0, $l6Or6.flushAnalyticsCallsInNewTask)(analytics, buffer);
                    // Clear buffer, just in case analytics is loaded twice; we don't want to fire events off again.
                    buffer.clear();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}






function $b6d3cbf1ee84eef6$var$registerPlugins(legacySettings, analytics, opts, options, plugins, legacyIntegrationSources) {
    var _a, _b, _c, _d;
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var tsubMiddleware, _e, legacyDestinations, _f, schemaFilter, _g, mergedSettings, remotePlugins, inAppPlugin, _h, toRegister, shouldIgnore, ctx;
        var _this = this;
        return (0, $l73V3.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    if (!$b6d3cbf1ee84eef6$var$hasTsubMiddleware(legacySettings)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("eT0KK")).then(function(mod) {
                            return mod.tsubMiddleware(legacySettings.middlewareSettings.routingRules);
                        })
                    ];
                case 1:
                    _e = _j.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    _e = undefined;
                    _j.label = 3;
                case 3:
                    tsubMiddleware = _e;
                    if (!($b6d3cbf1ee84eef6$var$hasLegacyDestinations(legacySettings) || legacyIntegrationSources.length > 0)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("jyswI")).then(function(mod) {
                            return mod.ajsDestinations(legacySettings, analytics.integrations, opts, tsubMiddleware, legacyIntegrationSources);
                        })
                    ];
                case 4:
                    _f = _j.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    _f = [];
                    _j.label = 6;
                case 6:
                    legacyDestinations = _f;
                    if (!legacySettings.legacyVideoPluginsEnabled) return [
                        3 /*break*/ ,
                        8
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("4dLY2")).then(function(mod) {
                            return mod.loadLegacyVideoPlugins(analytics);
                        })
                    ];
                case 7:
                    _j.sent();
                    _j.label = 8;
                case 8:
                    if (!((_a = opts.plan) === null || _a === void 0 ? void 0 : _a.track)) return [
                        3 /*break*/ ,
                        10
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("65aNf")).then(function(mod) {
                            var _a;
                            return mod.schemaFilter((_a = opts.plan) === null || _a === void 0 ? void 0 : _a.track, legacySettings);
                        })
                    ];
                case 9:
                    _g = _j.sent();
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    _g = undefined;
                    _j.label = 11;
                case 11:
                    schemaFilter = _g;
                    mergedSettings = (0, $4r2Y5.mergedOptions)(legacySettings, options);
                    return [
                        4 /*yield*/ ,
                        (0, $dHQJ4.remoteLoader)(legacySettings, analytics.integrations, mergedSettings, options.obfuscate, tsubMiddleware).catch(function() {
                            return [];
                        })
                    ];
                case 12:
                    remotePlugins = _j.sent();
                    if (!((_b = options.integrations) === null || _b === void 0 ? void 0 : _b['Customer.io In-App Plugin'])) return [
                        3 /*break*/ ,
                        14
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("9uxFj")).then(function(mod) {
                            var _a;
                            return mod.InAppPlugin((_a = options.integrations) === null || _a === void 0 ? void 0 : _a['Customer.io In-App Plugin']);
                        })
                    ];
                case 13:
                    _h = _j.sent();
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    _h = undefined;
                    _j.label = 15;
                case 15:
                    inAppPlugin = _h;
                    toRegister = (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([
                        (0, $4pRMy.validation),
                        (0, $31dco.pageEnrichment)
                    ], plugins, true), legacyDestinations, true), remotePlugins, true);
                    if (schemaFilter) toRegister.push(schemaFilter);
                    if (inAppPlugin) toRegister.push(inAppPlugin);
                    shouldIgnore = ((_c = opts.integrations) === null || _c === void 0 ? void 0 : _c.All) === false && !opts.integrations['Customer.io Data Pipelines'] || opts.integrations && opts.integrations['Customer.io Data Pipelines'] === false;
                    if (!shouldIgnore) toRegister.push((0, $6N780.customerio)(analytics, mergedSettings['Customer.io Data Pipelines'], legacySettings.integrations));
                    return [
                        4 /*yield*/ ,
                        analytics.register.apply(analytics, toRegister)
                    ];
                case 16:
                    ctx = _j.sent();
                    if (!Object.entries((_d = legacySettings.enabledMiddleware) !== null && _d !== void 0 ? _d : {}).some(function(_a) {
                        var enabled = _a[1];
                        return enabled;
                    })) return [
                        3 /*break*/ ,
                        18
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("il4VX")).then(function(_a) {
                            var remoteMiddlewares = _a.remoteMiddlewares;
                            return (0, $l73V3.__awaiter)(_this, void 0, void 0, function() {
                                var middleware, promises;
                                return (0, $l73V3.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                remoteMiddlewares(ctx, legacySettings, options.obfuscate)
                                            ];
                                        case 1:
                                            middleware = _b.sent();
                                            promises = middleware.map(function(mdw) {
                                                return analytics.addSourceMiddleware(mdw);
                                            });
                                            return [
                                                2 /*return*/ ,
                                                Promise.all(promises)
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 17:
                    _j.sent();
                    _j.label = 18;
                case 18:
                    return [
                        2 /*return*/ ,
                        ctx
                    ];
            }
        });
    });
}
function $b6d3cbf1ee84eef6$var$loadAnalytics(settings, options, preInitBuffer) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (options === void 0) options = {};
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var legacySettings, _h, retryQueue, opts, analytics, plugins, classicIntegrations, ctx, search, hash, term;
        return (0, $l73V3.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    // this is an ugly side-effect, but it's for the benefits of the plugins that get their cdn via getCDN()
                    if (settings.cdnURL) (0, $9yWXi.setGlobalCDNUrl)(settings.cdnURL);
                    if (!((_a = settings.cdnSettings) !== null && _a !== void 0)) return [
                        3 /*break*/ ,
                        1
                    ];
                    _h = _a;
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        $b6d3cbf1ee84eef6$export$ea4eec5233d33a41(settings.writeKey, settings.cdnURL)
                    ];
                case 2:
                    _h = _j.sent();
                    _j.label = 3;
                case 3:
                    legacySettings = _h;
                    retryQueue = (_c = (_b = legacySettings.integrations['Customer.io Data Pipelines']) === null || _b === void 0 ? void 0 : _b.retryQueue) !== null && _c !== void 0 ? _c : true;
                    opts = (0, $l73V3.__assign)({
                        retryQueue: retryQueue
                    }, options);
                    analytics = new (0, $5Z7ek.Analytics)(settings, opts);
                    (0, $80xCC.attachInspector)(analytics);
                    plugins = (_d = settings.plugins) !== null && _d !== void 0 ? _d : [];
                    classicIntegrations = (_e = settings.classicIntegrations) !== null && _e !== void 0 ? _e : [];
                    (0, $IQ4PO.Stats).initRemoteMetrics(legacySettings.metrics);
                    // needs to be flushed before plugins are registered
                    $b6d3cbf1ee84eef6$var$flushPreBuffer(analytics, preInitBuffer);
                    return [
                        4 /*yield*/ ,
                        $b6d3cbf1ee84eef6$var$registerPlugins(legacySettings, analytics, opts, options, plugins, classicIntegrations)
                    ];
                case 4:
                    ctx = _j.sent();
                    search = (_f = window.location.search) !== null && _f !== void 0 ? _f : '';
                    hash = (_g = window.location.hash) !== null && _g !== void 0 ? _g : '';
                    term = search.length ? search : hash.replace(/(?=#).*(?=\?)/, '');
                    if (!term.includes('ajs_')) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        analytics.queryString(term).catch(console.error)
                    ];
                case 5:
                    _j.sent();
                    _j.label = 6;
                case 6:
                    analytics.initialized = true;
                    analytics.emit('initialize', settings, options);
                    if (options.initialPageview) analytics.page().catch(console.error);
                    return [
                        4 /*yield*/ ,
                        $b6d3cbf1ee84eef6$var$flushFinalBuffer(analytics, preInitBuffer)
                    ];
                case 7:
                    _j.sent();
                    return [
                        2 /*return*/ ,
                        [
                            analytics,
                            ctx
                        ]
                    ];
            }
        });
    });
}
/**
 * The public browser interface for Customer.io Data Pipelines
 *
 * @example
 * ```ts
 *  export const analytics = new AnalyticsBrowser()
 *  analytics.load({ writeKey: 'foo' })
 */ var $b6d3cbf1ee84eef6$export$f483b44f21cbe352 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(AnalyticsBrowser, _super);
    function AnalyticsBrowser() {
        var _this = this;
        var _a = (0, $2maFQ.createDeferred)(), loadStart = _a.promise, resolveLoadStart = _a.resolve;
        _this = _super.call(this, function(buffer) {
            return loadStart.then(function(_a) {
                var settings = _a[0], options = _a[1];
                return $b6d3cbf1ee84eef6$var$loadAnalytics(settings, options, buffer);
            });
        }) || this;
        _this._resolveLoadStart = function(settings, options) {
            return resolveLoadStart([
                settings,
                options
            ]);
        };
        return _this;
    }
    /**
     * Fully initialize an analytics instance, including:
     *
     * * Fetching settings from the CDN (by default).
     * * Fetching all remote destinations configured by the user (if applicable).
     * * Flushing buffered analytics events.
     * * Loading all middleware.
     *
     * Note:️  This method should only be called *once* in your application.
     *
     * @example
     * ```ts
     * export const analytics = new AnalyticsBrowser()
     * analytics.load({ writeKey: 'foo' })
     * ```
     */ AnalyticsBrowser.prototype.load = function(settings, options) {
        if (options === void 0) options = {};
        this._resolveLoadStart(settings, options);
        return this;
    };
    /**
     * Instantiates an object exposing Analytics methods.
     *
     * @example
     * ```ts
     * const ajs = AnalyticsBrowser.load({ writeKey: '<YOUR_WRITE_KEY>' })
     *
     * ajs.track("foo")
     * ...
     * ```
     */ AnalyticsBrowser.load = function(settings, options) {
        if (options === void 0) options = {};
        return new AnalyticsBrowser().load(settings, options);
    };
    AnalyticsBrowser.standalone = function(writeKey, options) {
        return AnalyticsBrowser.load({
            writeKey: writeKey
        }, options).then(function(res) {
            return res[0];
        });
    };
    return AnalyticsBrowser;
}((0, $l6Or6.AnalyticsBuffered));

});
parcelRegister("jRETX", function(module, exports) {

$parcel$export(module.exports, "getProcessEnv", function () { return $e762b1bb5b2aadd8$export$e1e87d6eac79027a; });
/**
 * Returns `process.env` if it is available in the environment.
 * Always returns an object make it similarly easy to use as `process.env`.
 */ function $e762b1bb5b2aadd8$export$e1e87d6eac79027a() {
    return {};
}

});

parcelRegister("9yWXi", function(module, exports) {

$parcel$export(module.exports, "setGlobalCDNUrl", function () { return $6f65055e93d33b39$export$8c3cf5ba89c382a1; });
$parcel$export(module.exports, "getCDN", function () { return $6f65055e93d33b39$export$1fe1fc84344b4e12; });
$parcel$export(module.exports, "getNextIntegrationsURL", function () { return $6f65055e93d33b39$export$b8f04fc655d78840; });

var $ciOr6 = parcelRequire("ciOr6");
var $6f65055e93d33b39$var$analyticsScriptRegex = /(https:\/\/[\w.-]+)\/(?:analytics\.js\/v1|v1\/analytics-js\/snippet)\/[\w-]+\/(analytics\.(?:min)\.js)/;
var $6f65055e93d33b39$var$getCDNUrlFromScriptTag = function() {
    var cdn;
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    scripts.forEach(function(s) {
        var _a;
        var src = (_a = s.getAttribute('src')) !== null && _a !== void 0 ? _a : '';
        var result = $6f65055e93d33b39$var$analyticsScriptRegex.exec(src);
        if (result && result[1]) cdn = result[1];
    });
    return cdn;
};
var $6f65055e93d33b39$var$_globalCDN; // set globalCDN as in-memory singleton
var $6f65055e93d33b39$var$getGlobalCDNUrl = function() {
    var _a;
    var result = $6f65055e93d33b39$var$_globalCDN !== null && $6f65055e93d33b39$var$_globalCDN !== void 0 ? $6f65055e93d33b39$var$_globalCDN : (_a = window.analytics) === null || _a === void 0 ? void 0 : _a._cdn;
    return result;
};
var $6f65055e93d33b39$export$8c3cf5ba89c382a1 = function(cdn) {
    if (window.analytics) window.analytics._cdn = cdn;
    $6f65055e93d33b39$var$_globalCDN = cdn;
};
var $6f65055e93d33b39$export$1fe1fc84344b4e12 = function() {
    var globalCdnUrl = $6f65055e93d33b39$var$getGlobalCDNUrl();
    if (globalCdnUrl) return globalCdnUrl;
    var cdnFromScriptTag = $6f65055e93d33b39$var$getCDNUrlFromScriptTag();
    if (cdnFromScriptTag) return cdnFromScriptTag;
    else // it's possible that the CDN is not found in the page because:
    // - the script is loaded through a proxy
    // - the script is removed after execution
    // in this case, we fall back to the default CDN
    return "https://cdp.customer.io";
};
var $6f65055e93d33b39$export$b8f04fc655d78840 = function() {
    var cdn = $6f65055e93d33b39$export$1fe1fc84344b4e12();
    return "".concat(cdn, "/v1/analytics-js/actions");
};
function $6f65055e93d33b39$export$f2d5df4d4ab71c34() {
    var _a, _b;
    var writeKey = (_a = (0, $ciOr6.embeddedWriteKey)()) !== null && _a !== void 0 ? _a : window.analytics._writeKey;
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    var path = undefined;
    for(var _i = 0, scripts_1 = scripts; _i < scripts_1.length; _i++){
        var s = scripts_1[_i];
        var src = (_b = s.getAttribute('src')) !== null && _b !== void 0 ? _b : '';
        var result = $6f65055e93d33b39$var$analyticsScriptRegex.exec(src);
        if (result && result[1]) {
            path = src;
            break;
        }
    }
    if (path) return path.replace('analytics.min.js', 'analytics.classic.js');
    return "https://cdp.customer.io/analytics.js/v1/".concat(writeKey, "/analytics.classic.js");
}

});
parcelRegister("ciOr6", function(module, exports) {

$parcel$export(module.exports, "embeddedWriteKey", function () { return $8f4e4a07c39c3edb$export$9f3c28337f274a2b; });
// This variable is used as an optional fallback for when customers
// host or proxy their own analytics.js.
try {
    window.analyticsWriteKey = '__WRITE_KEY__';
} catch (_) {
// @ eslint-disable-next-line
}
function $8f4e4a07c39c3edb$export$9f3c28337f274a2b() {
    if (window.analyticsWriteKey === undefined) return undefined;
    // this is done so that we don't accidentally override every reference to __write_key__
    return window.analyticsWriteKey !== [
        '__',
        'WRITE',
        '_',
        'KEY',
        '__'
    ].join('') ? window.analyticsWriteKey : undefined;
}

});


parcelRegister("llDp8", function(module, exports) {

$parcel$export(module.exports, "fetch", function () { return $f8aa200a76227379$export$e7aa7bc5c1b3cfb3; });

var $dHHUN = parcelRequire("dHHUN");

var $7IbEO = parcelRequire("7IbEO");
var $f8aa200a76227379$export$e7aa7bc5c1b3cfb3 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var global = (0, $7IbEO.getGlobal)();
    return (global && global.fetch || (0, $dHHUN.default)).apply(void 0, args);
};

});
parcelRegister("dHHUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa15b283ed4abe9$export$2e2bcd8739ae039; });
function $9fa15b283ed4abe9$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("7IbEO", function(module, exports) {

$parcel$export(module.exports, "getGlobal", function () { return $59d5af5e7b573f1c$export$a4e55266d2135a7f; });
// This an imperfect polyfill for globalThis
var $59d5af5e7b573f1c$export$a4e55266d2135a7f = function() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return null;
};

});


parcelRegister("5Z7ek", function(module, exports) {

$parcel$export(module.exports, "Analytics", function () { return $45b84205439412c9$export$2b3af6baec22bd98; });

var $l73V3 = parcelRequire("l73V3");

var $dZ4qf = parcelRequire("dZ4qf");

var $hs2LY = parcelRequire("hs2LY");

var $jVL2A = parcelRequire("jVL2A");

var $jgE2t = parcelRequire("jgE2t");
var $j90yV = parcelRequire("j90yV");

var $j5aZf = parcelRequire("j5aZf");

var $iKTLf = parcelRequire("iKTLf");

var $YZAcZ = parcelRequire("YZAcZ");

var $kcMVt = parcelRequire("kcMVt");

var $3r7RW = parcelRequire("3r7RW");

var $iZQWy = parcelRequire("iZQWy");

var $2H1l5 = parcelRequire("2H1l5");

var $7IbEO = parcelRequire("7IbEO");
var $45b84205439412c9$var$deprecationWarning = 'This is being deprecated and will be not be available in future releases of Analytics JS';
// reference any pre-existing "analytics" object so a user can restore the reference
var $45b84205439412c9$var$global = (0, $7IbEO.getGlobal)();
var $45b84205439412c9$var$_analytics = $45b84205439412c9$var$global === null || $45b84205439412c9$var$global === void 0 ? void 0 : $45b84205439412c9$var$global.analytics;
function $45b84205439412c9$var$createDefaultQueue(retryQueue, disablePersistance) {
    if (retryQueue === void 0) retryQueue = false;
    if (disablePersistance === void 0) disablePersistance = false;
    var maxAttempts = retryQueue ? 4 : 1;
    var priorityQueue = disablePersistance ? new (0, $2H1l5.PriorityQueue)(maxAttempts, []) : new (0, $3r7RW.PersistedPriorityQueue)(maxAttempts, 'event-queue');
    return new (0, $iKTLf.EventQueue)(priorityQueue);
}
/* analytics-classic stubs */ function $45b84205439412c9$var$_stub() {
    console.warn($45b84205439412c9$var$deprecationWarning);
}






var $45b84205439412c9$export$2b3af6baec22bd98 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Analytics, _super);
    function Analytics(settings, options, queue, user, group) {
        var _this = this;
        var _a, _b, _c;
        _this = _super.call(this) || this;
        _this._debug = false;
        _this.initialized = false;
        _this.user = function() {
            return _this._user;
        };
        _this.init = _this.initialize.bind(_this);
        _this.log = $45b84205439412c9$var$_stub;
        _this.addIntegrationMiddleware = $45b84205439412c9$var$_stub;
        _this.listeners = $45b84205439412c9$var$_stub;
        _this.addEventListener = $45b84205439412c9$var$_stub;
        _this.removeAllListeners = $45b84205439412c9$var$_stub;
        _this.removeListener = $45b84205439412c9$var$_stub;
        _this.removeEventListener = $45b84205439412c9$var$_stub;
        _this.hasListeners = $45b84205439412c9$var$_stub;
        _this.add = $45b84205439412c9$var$_stub;
        _this.addIntegration = $45b84205439412c9$var$_stub;
        var cookieOptions = options === null || options === void 0 ? void 0 : options.cookie;
        var disablePersistance = (_a = options === null || options === void 0 ? void 0 : options.disableClientPersistence) !== null && _a !== void 0 ? _a : false;
        _this.settings = settings;
        _this.settings.timeout = (_b = _this.settings.timeout) !== null && _b !== void 0 ? _b : 300;
        _this.queue = queue !== null && queue !== void 0 ? queue : $45b84205439412c9$var$createDefaultQueue(options === null || options === void 0 ? void 0 : options.retryQueue, disablePersistance);
        _this._universalStorage = new (0, $YZAcZ.UniversalStorage)(disablePersistance ? [
            'memory'
        ] : [
            'localStorage',
            'cookie',
            'memory'
        ], (0, $YZAcZ.getAvailableStorageOptions)(cookieOptions));
        _this._user = user !== null && user !== void 0 ? user : new (0, $YZAcZ.User)(disablePersistance ? (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options === null || options === void 0 ? void 0 : options.user), {
            persist: false
        }) : options === null || options === void 0 ? void 0 : options.user, cookieOptions).load();
        _this._group = group !== null && group !== void 0 ? group : new (0, $YZAcZ.Group)(disablePersistance ? (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options === null || options === void 0 ? void 0 : options.group), {
            persist: false
        }) : options === null || options === void 0 ? void 0 : options.group, cookieOptions).load();
        _this.eventFactory = new (0, $j5aZf.EventFactory)(_this._user);
        _this.integrations = (_c = options === null || options === void 0 ? void 0 : options.integrations) !== null && _c !== void 0 ? _c : {};
        _this.options = options !== null && options !== void 0 ? options : {};
        (0, $kcMVt.default)(_this);
        return _this;
    }
    Object.defineProperty(Analytics.prototype, "storage", {
        get: function() {
            return this._universalStorage;
        },
        enumerable: false,
        configurable: true
    });
    Analytics.prototype.track = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _a, name, data, opts, cb, CustomerioEvent;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_b) {
                _a = (0, $dZ4qf.resolveArguments).apply(void 0, args), name = _a[0], data = _a[1], opts = _a[2], cb = _a[3];
                CustomerioEvent = this.eventFactory.track(name, data, opts, this.integrations);
                return [
                    2 /*return*/ ,
                    this._dispatch(CustomerioEvent, cb).then(function(ctx) {
                        _this.emit('track', name, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })
                ];
            });
        });
    };
    Analytics.prototype.page = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _a, category, page, properties, options, callback, CustomerioEvent;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_b) {
                _a = (0, $dZ4qf.resolvePageArguments).apply(void 0, args), category = _a[0], page = _a[1], properties = _a[2], options = _a[3], callback = _a[4];
                CustomerioEvent = this.eventFactory.page(category, page, properties, options, this.integrations);
                return [
                    2 /*return*/ ,
                    this._dispatch(CustomerioEvent, callback).then(function(ctx) {
                        _this.emit('page', category, page, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })
                ];
            });
        });
    };
    Analytics.prototype.identify = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _a, id, _traits, options, callback, CustomerioEvent;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_b) {
                _a = (0, $dZ4qf.resolveUserArguments)(this._user).apply(void 0, args), id = _a[0], _traits = _a[1], options = _a[2], callback = _a[3];
                this._user.identify(id, _traits);
                CustomerioEvent = this.eventFactory.identify(this._user.id(), this._user.traits(), options, this.integrations);
                return [
                    2 /*return*/ ,
                    this._dispatch(CustomerioEvent, callback).then(function(ctx) {
                        _this.emit('identify', ctx.event.userId, ctx.event.traits, ctx.event.options);
                        return ctx;
                    })
                ];
            });
        });
    };
    Analytics.prototype.group = function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length === 0) return this._group;
        var _a = (0, $dZ4qf.resolveUserArguments)(this._group).apply(void 0, args), id = _a[0], _traits = _a[1], options = _a[2], callback = _a[3];
        this._group.identify(id, _traits);
        var groupId = this._group.id();
        var groupTraits = this._group.traits();
        var CustomerioEvent = this.eventFactory.group(groupId, groupTraits, options, this.integrations);
        return this._dispatch(CustomerioEvent, callback).then(function(ctx) {
            _this.emit('group', ctx.event.groupId, ctx.event.traits, ctx.event.options);
            return ctx;
        });
    };
    Analytics.prototype.alias = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _a, to, from, options, callback, CustomerioEvent;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_b) {
                _a = (0, $dZ4qf.resolveAliasArguments).apply(void 0, args), to = _a[0], from = _a[1], options = _a[2], callback = _a[3];
                CustomerioEvent = this.eventFactory.alias(to, from, options, this.integrations);
                return [
                    2 /*return*/ ,
                    this._dispatch(CustomerioEvent, callback).then(function(ctx) {
                        _this.emit('alias', to, from, ctx.event.options);
                        return ctx;
                    })
                ];
            });
        });
    };
    Analytics.prototype.screen = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _a, category, page, properties, options, callback, CustomerioEvent;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_b) {
                _a = (0, $dZ4qf.resolvePageArguments).apply(void 0, args), category = _a[0], page = _a[1], properties = _a[2], options = _a[3], callback = _a[4];
                CustomerioEvent = this.eventFactory.screen(category, page, properties, options, this.integrations);
                return [
                    2 /*return*/ ,
                    this._dispatch(CustomerioEvent, callback).then(function(ctx) {
                        _this.emit('screen', category, page, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })
                ];
            });
        });
    };
    Analytics.prototype.trackClick = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var autotrack;
            var _a;
            return (0, $l73V3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (parcelRequire("6vhvp"))
                        ];
                    case 1:
                        autotrack = _b.sent();
                        return [
                            2 /*return*/ ,
                            (_a = autotrack.link).call.apply(_a, (0, $l73V3.__spreadArray)([
                                this
                            ], args, false))
                        ];
                }
            });
        });
    };
    Analytics.prototype.trackLink = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var autotrack;
            var _a;
            return (0, $l73V3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (parcelRequire("6vhvp"))
                        ];
                    case 1:
                        autotrack = _b.sent();
                        return [
                            2 /*return*/ ,
                            (_a = autotrack.link).call.apply(_a, (0, $l73V3.__spreadArray)([
                                this
                            ], args, false))
                        ];
                }
            });
        });
    };
    Analytics.prototype.trackSubmit = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var autotrack;
            var _a;
            return (0, $l73V3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (parcelRequire("6vhvp"))
                        ];
                    case 1:
                        autotrack = _b.sent();
                        return [
                            2 /*return*/ ,
                            (_a = autotrack.form).call.apply(_a, (0, $l73V3.__spreadArray)([
                                this
                            ], args, false))
                        ];
                }
            });
        });
    };
    Analytics.prototype.trackForm = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var autotrack;
            var _a;
            return (0, $l73V3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (parcelRequire("6vhvp"))
                        ];
                    case 1:
                        autotrack = _b.sent();
                        return [
                            2 /*return*/ ,
                            (_a = autotrack.form).call.apply(_a, (0, $l73V3.__spreadArray)([
                                this
                            ], args, false))
                        ];
                }
            });
        });
    };
    Analytics.prototype.register = function() {
        var plugins = [];
        for(var _i = 0; _i < arguments.length; _i++)plugins[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var ctx, registrations;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ctx = (0, $jVL2A.Context).system();
                        registrations = plugins.map(function(xt) {
                            return _this.queue.register(ctx, xt, _this);
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(registrations)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            ctx
                        ];
                }
            });
        });
    };
    Analytics.prototype.deregister = function() {
        var plugins = [];
        for(var _i = 0; _i < arguments.length; _i++)plugins[_i] = arguments[_i];
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var ctx, deregistrations;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ctx = (0, $jVL2A.Context).system();
                        deregistrations = plugins.map(function(pl) {
                            var plugin = _this.queue.plugins.find(function(p) {
                                return p.name === pl;
                            });
                            if (plugin) return _this.queue.deregister(ctx, plugin, _this);
                            else ctx.log('warn', "plugin ".concat(pl, " not found"));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(deregistrations)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            ctx
                        ];
                }
            });
        });
    };
    Analytics.prototype.debug = function(toggle) {
        // Make sure legacy ajs debug gets turned off if it was enabled before upgrading.
        if (toggle === false && localStorage.getItem('debug')) localStorage.removeItem('debug');
        this._debug = toggle;
        return this;
    };
    Analytics.prototype.reset = function() {
        this._user.reset();
        this._group.reset();
        this.emit('reset');
    };
    Analytics.prototype.timeout = function(timeout) {
        this.settings.timeout = timeout;
    };
    Analytics.prototype._dispatch = function(event, callback) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var ctx;
            return (0, $l73V3.__generator)(this, function(_a) {
                ctx = new (0, $jVL2A.Context)(event);
                if ((0, $hs2LY.isOffline)() && !this.options.retryQueue) return [
                    2 /*return*/ ,
                    ctx
                ];
                return [
                    2 /*return*/ ,
                    (0, $jgE2t.dispatch)(ctx, this.queue, this, {
                        callback: callback,
                        debug: this._debug,
                        timeout: this.settings.timeout
                    })
                ];
            });
        });
    };
    Analytics.prototype.addSourceMiddleware = function(fn) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.queue.criticalTasks.run(function() {
                                return (0, $l73V3.__awaiter)(_this, void 0, void 0, function() {
                                    var sourceMiddlewarePlugin, integrations, plugin;
                                    return (0, $l73V3.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    Promise.resolve((parcelRequire("5Z7Ne")))
                                                ];
                                            case 1:
                                                sourceMiddlewarePlugin = _a.sent().sourceMiddlewarePlugin;
                                                integrations = {};
                                                this.queue.plugins.forEach(function(plugin) {
                                                    if (plugin.type === 'destination') return integrations[plugin.name] = true;
                                                });
                                                plugin = sourceMiddlewarePlugin(fn, integrations);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.register(plugin)
                                                ];
                                            case 2:
                                                _a.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this
                        ];
                }
            });
        });
    };
    /* TODO: This does not have to return a promise? */ Analytics.prototype.addDestinationMiddleware = function(integrationName) {
        var middlewares = [];
        for(var _i = 1; _i < arguments.length; _i++)middlewares[_i - 1] = arguments[_i];
        var legacyDestinations = this.queue.plugins.filter(function(xt) {
            return xt.name.toLowerCase() === integrationName.toLowerCase();
        });
        legacyDestinations.forEach(function(destination) {
            destination.addMiddleware.apply(destination, middlewares);
        });
        return Promise.resolve(this);
    };
    Analytics.prototype.setAnonymousId = function(id) {
        return this._user.anonymousId(id);
    };
    Analytics.prototype.queryString = function(query) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var queryString;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.options.useQueryString === false) return [
                            2 /*return*/ ,
                            []
                        ];
                        return [
                            4 /*yield*/ ,
                            (parcelRequire("6YNh1"))
                        ];
                    case 1:
                        queryString = _a.sent().queryString;
                        return [
                            2 /*return*/ ,
                            queryString(this, query)
                        ];
                }
            });
        });
    };
    /**
     * @deprecated This function does not register a destination plugin.
     *
     * Instantiates a legacy Analytics.js destination.
     *
     * This function does not register the destination as an Analytics.JS plugin,
     * all the it does it to invoke the factory function back.
     */ Analytics.prototype.use = function(legacyPluginFactory) {
        legacyPluginFactory(this);
        return this;
    };
    Analytics.prototype.ready = function(callback) {
        if (callback === void 0) callback = function(res) {
            return res;
        };
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            return (0, $l73V3.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.queue.plugins.map(function(i) {
                        return i.ready ? i.ready() : Promise.resolve();
                    })).then(function(res) {
                        callback(res);
                        return res;
                    })
                ];
            });
        });
    };
    // analytics-classic api
    Analytics.prototype.noConflict = function() {
        console.warn($45b84205439412c9$var$deprecationWarning);
        window.analytics = $45b84205439412c9$var$_analytics !== null && $45b84205439412c9$var$_analytics !== void 0 ? $45b84205439412c9$var$_analytics : this;
        return this;
    };
    Analytics.prototype.normalize = function(msg) {
        console.warn($45b84205439412c9$var$deprecationWarning);
        return this.eventFactory.normalize(msg);
    };
    Object.defineProperty(Analytics.prototype, "failedInitializations", {
        get: function() {
            console.warn($45b84205439412c9$var$deprecationWarning);
            return this.queue.failedInitializations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Analytics.prototype, "VERSION", {
        get: function() {
            return 0, $iZQWy.version;
        },
        enumerable: false,
        configurable: true
    });
    /* @deprecated - noop */ Analytics.prototype.initialize = function(_settings, _options) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            return (0, $l73V3.__generator)(this, function(_a) {
                console.warn($45b84205439412c9$var$deprecationWarning);
                return [
                    2 /*return*/ ,
                    Promise.resolve(this)
                ];
            });
        });
    };
    Analytics.prototype.pageview = function(url) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        console.warn($45b84205439412c9$var$deprecationWarning);
                        return [
                            4 /*yield*/ ,
                            this.page({
                                path: url
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this
                        ];
                }
            });
        });
    };
    Object.defineProperty(Analytics.prototype, "plugins", {
        get: function() {
            var _a;
            console.warn($45b84205439412c9$var$deprecationWarning);
            // @ts-expect-error
            return (_a = this._plugins) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Analytics.prototype, "Integrations", {
        get: function() {
            console.warn($45b84205439412c9$var$deprecationWarning);
            var integrations = this.queue.plugins.filter(function(plugin) {
                return plugin.type === 'destination';
            }).reduce(function(acc, plugin) {
                var name = "".concat(plugin.name.toLowerCase().replace('.', '').split(' ').join('-'), "Integration");
                // @ts-expect-error
                var integration = window[name];
                if (!integration) return acc;
                var nested = integration.Integration; // hack - Google Analytics function resides in the "Integration" field
                if (nested) {
                    acc[plugin.name] = nested;
                    return acc;
                }
                acc[plugin.name] = integration;
                return acc;
            }, {});
            return integrations;
        },
        enumerable: false,
        configurable: true
    });
    // snippet function
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Analytics.prototype.push = function(args) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var an = this;
        var method = args.shift();
        if (method) {
            if (!an[method]) return;
        }
        an[method].apply(this, args);
    };
    return Analytics;
}((0, $j90yV.Emitter));

});
parcelRegister("dZ4qf", function(module, exports) {

$parcel$export(module.exports, "resolveArguments", function () { return $a2e4671204eae98a$export$3ffc407d31dec99a; });
$parcel$export(module.exports, "resolvePageArguments", function () { return $a2e4671204eae98a$export$538f769984a3cda9; });
$parcel$export(module.exports, "resolveUserArguments", function () { return $a2e4671204eae98a$export$2744ec5ed59b44ab; });
$parcel$export(module.exports, "resolveAliasArguments", function () { return $a2e4671204eae98a$export$2092bed85632544e; });

var $4pRMy = parcelRequire("4pRMy");
function $a2e4671204eae98a$export$3ffc407d31dec99a(eventName, properties, options, callback) {
    var _a;
    var args = [
        eventName,
        properties,
        options,
        callback
    ];
    var name = (0, $4pRMy.isPlainObject)(eventName) ? eventName.event : eventName;
    if (!name || !(0, $4pRMy.isString)(name)) throw new Error('Event missing');
    var data = (0, $4pRMy.isPlainObject)(eventName) ? (_a = eventName.properties) !== null && _a !== void 0 ? _a : {} : (0, $4pRMy.isPlainObject)(properties) ? properties : {};
    var opts = {};
    if (!(0, $4pRMy.isFunction)(options)) opts = options !== null && options !== void 0 ? options : {};
    if ((0, $4pRMy.isPlainObject)(eventName) && !(0, $4pRMy.isFunction)(properties)) opts = properties !== null && properties !== void 0 ? properties : {};
    var cb = args.find((0, $4pRMy.isFunction));
    return [
        name,
        data,
        opts,
        cb
    ];
}
function $a2e4671204eae98a$export$538f769984a3cda9(category, name, properties, options, callback) {
    var _a, _b;
    var resolvedCategory = null;
    var resolvedName = null;
    var args = [
        category,
        name,
        properties,
        options,
        callback
    ];
    var strings = args.filter((0, $4pRMy.isString));
    if (strings[0] !== undefined && strings[1] !== undefined) {
        resolvedCategory = strings[0];
        resolvedName = strings[1];
    }
    if (strings.length === 1) {
        resolvedCategory = null;
        resolvedName = strings[0];
    }
    var resolvedCallback = args.find((0, $4pRMy.isFunction));
    var objects = args.filter(function(obj) {
        if (resolvedName === null) return (0, $4pRMy.isPlainObject)(obj);
        return (0, $4pRMy.isPlainObject)(obj) || obj === null;
    });
    var resolvedProperties = (_a = objects[0]) !== null && _a !== void 0 ? _a : {};
    var resolvedOptions = (_b = objects[1]) !== null && _b !== void 0 ? _b : {};
    return [
        resolvedCategory,
        resolvedName,
        resolvedProperties,
        resolvedOptions,
        resolvedCallback
    ];
}
var $a2e4671204eae98a$export$2744ec5ed59b44ab = function(user) {
    return function() {
        var _a, _b, _c, _d, _e;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var id = null;
        id = (_c = (_a = args.find((0, $4pRMy.isString))) !== null && _a !== void 0 ? _a : (_b = args.find((0, $4pRMy.isNumber))) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : user.id();
        var objects = args.filter(function(obj) {
            if (id === null) return (0, $4pRMy.isPlainObject)(obj);
            return (0, $4pRMy.isPlainObject)(obj) || obj === null;
        });
        var traits = (_d = objects[0]) !== null && _d !== void 0 ? _d : {};
        var opts = (_e = objects[1]) !== null && _e !== void 0 ? _e : {};
        var resolvedCallback = args.find((0, $4pRMy.isFunction));
        return [
            id,
            traits,
            opts,
            resolvedCallback
        ];
    };
};
function $a2e4671204eae98a$export$2092bed85632544e(to, from, options, callback) {
    if ((0, $4pRMy.isNumber)(to)) to = to.toString(); // Legacy behaviour - allow integers for alias calls
    if ((0, $4pRMy.isNumber)(from)) from = from.toString();
    var args = [
        to,
        from,
        options,
        callback
    ];
    var _a = args.filter((0, $4pRMy.isString)), _b = _a[0], aliasTo = _b === void 0 ? to : _b, _c = _a[1], aliasFrom = _c === void 0 ? null : _c;
    var _d = args.filter((0, $4pRMy.isPlainObject))[0], opts = _d === void 0 ? {} : _d;
    var resolvedCallback = args.find((0, $4pRMy.isFunction));
    return [
        aliasTo,
        aliasFrom,
        opts,
        resolvedCallback
    ];
}

});
parcelRegister("4pRMy", function(module, exports) {

$parcel$export(module.exports, "isString", function () { return $3373373af8430104$export$844ec244b1367d54; });
$parcel$export(module.exports, "isNumber", function () { return $3373373af8430104$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isFunction", function () { return $3373373af8430104$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isPlainObject", function () { return $3373373af8430104$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "validation", function () { return $3373373af8430104$export$edb889f0799652d1; });

var $l73V3 = parcelRequire("l73V3");
function $3373373af8430104$export$844ec244b1367d54(obj) {
    return typeof obj === 'string';
}
function $3373373af8430104$export$7e4aa119212bc614(obj) {
    return typeof obj === 'number';
}
function $3373373af8430104$export$f6e2535fb5126e54(obj) {
    return typeof obj === 'function';
}
function $3373373af8430104$export$53b83ca8eaab0383(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() === 'object';
}
function $3373373af8430104$var$hasUser(event) {
    var _a, _b, _c;
    var id = (_c = (_b = (_a = event.userId) !== null && _a !== void 0 ? _a : event.anonymousId) !== null && _b !== void 0 ? _b : event.groupId) !== null && _c !== void 0 ? _c : event.previousId;
    return $3373373af8430104$export$844ec244b1367d54(id);
}
var $3373373af8430104$var$ValidationError = /** @class */ function(_super) {
    (0, $l73V3.__extends)(ValidationError, _super);
    function ValidationError(field, message) {
        var _this = _super.call(this, message) || this;
        _this.field = field;
        return _this;
    }
    return ValidationError;
}(Error);
function $3373373af8430104$var$validate(ctx) {
    var _a;
    var eventType = ctx && ctx.event && ctx.event.type;
    var event = ctx.event;
    if (event === undefined) throw new $3373373af8430104$var$ValidationError('event', 'Event is missing');
    if (!$3373373af8430104$export$844ec244b1367d54(eventType)) throw new $3373373af8430104$var$ValidationError('event', 'Event is not a string');
    if (eventType === 'track' && !$3373373af8430104$export$844ec244b1367d54(event.event)) throw new $3373373af8430104$var$ValidationError('event', 'Event is not a string');
    var props = (_a = event.properties) !== null && _a !== void 0 ? _a : event.traits;
    if (eventType !== 'alias' && !$3373373af8430104$export$53b83ca8eaab0383(props)) throw new $3373373af8430104$var$ValidationError('properties', 'properties is not an object');
    if (!$3373373af8430104$var$hasUser(event)) throw new $3373373af8430104$var$ValidationError('userId', 'Missing userId or anonymousId');
    return ctx;
}
var $3373373af8430104$export$edb889f0799652d1 = {
    name: 'Event Validation',
    type: 'before',
    version: '1.0.0',
    isLoaded: function() {
        return true;
    },
    load: function() {
        return Promise.resolve();
    },
    track: $3373373af8430104$var$validate,
    identify: $3373373af8430104$var$validate,
    page: $3373373af8430104$var$validate,
    alias: $3373373af8430104$var$validate,
    group: $3373373af8430104$var$validate,
    screen: $3373373af8430104$var$validate
};

});


parcelRegister("hs2LY", function(module, exports) {

$parcel$export(module.exports, "isOnline", function () { return $cb4733cf8267143c$export$53c2fd0173ad2b80; });
$parcel$export(module.exports, "isOffline", function () { return $cb4733cf8267143c$export$a81aa9769d155ec5; });

var $acTDO = parcelRequire("acTDO");
function $cb4733cf8267143c$export$53c2fd0173ad2b80() {
    if ((0, $acTDO.isBrowser)()) return window.navigator.onLine;
    return true;
}
function $cb4733cf8267143c$export$a81aa9769d155ec5() {
    return !$cb4733cf8267143c$export$53c2fd0173ad2b80();
}

});
parcelRegister("acTDO", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $76e62f8d8f5b405a$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isServer", function () { return $76e62f8d8f5b405a$export$6acf61af03e62db; });
function $76e62f8d8f5b405a$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined';
}
function $76e62f8d8f5b405a$export$6acf61af03e62db() {
    return !$76e62f8d8f5b405a$export$4e09c449d6c407f7();
}

});


parcelRegister("jVL2A", function(module, exports) {

$parcel$export(module.exports, "Context", function () { return $e827d481b421174d$export$841858b892ce1f4c; });

var $l73V3 = parcelRequire("l73V3");

var $bPxZD = parcelRequire("bPxZD");

var $IQ4PO = parcelRequire("IQ4PO");
var $e827d481b421174d$export$841858b892ce1f4c = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Context, _super);
    function Context(event, id) {
        return _super.call(this, event, id, new (0, $IQ4PO.Stats)()) || this;
    }
    Context.system = function() {
        return new this({
            type: 'track',
            event: 'system'
        });
    };
    return Context;
}((0, $bPxZD.CoreContext));

});
parcelRegister("bPxZD", function(module, exports) {

$parcel$export(module.exports, "ContextCancelation", function () { return $89ced3714c4601d4$export$ada441573746c62a; });
$parcel$export(module.exports, "CoreContext", function () { return $89ced3714c4601d4$export$9096b9f34b1136d7; });

var $fMO1n = parcelRequire("fMO1n");

var $7Hnuj = parcelRequire("7Hnuj");

var $ksn67 = parcelRequire("ksn67");

var $9NJkR = parcelRequire("9NJkR");
var $89ced3714c4601d4$export$ada441573746c62a = /** @class */ function() {
    function ContextCancelation(options) {
        var _a, _b, _c;
        this.retry = (_a = options.retry) !== null && _a !== void 0 ? _a : true;
        this.type = (_b = options.type) !== null && _b !== void 0 ? _b : 'plugin Error';
        this.reason = (_c = options.reason) !== null && _c !== void 0 ? _c : '';
    }
    return ContextCancelation;
}();
var $89ced3714c4601d4$export$9096b9f34b1136d7 = /** @class */ function() {
    function CoreContext(event, id, stats, logger) {
        if (id === void 0) id = (0, $fMO1n.v4)();
        if (stats === void 0) stats = new (0, $9NJkR.NullStats)();
        if (logger === void 0) logger = new (0, $ksn67.CoreLogger)();
        this.attempts = 0;
        this.event = event;
        this._id = id;
        this.logger = logger;
        this.stats = stats;
    }
    CoreContext.system = function() {
    // This should be overridden by the subclass to return an instance of the subclass.
    };
    CoreContext.prototype.isSame = function(other) {
        return other.id === this.id;
    };
    CoreContext.prototype.cancel = function(error) {
        if (error) throw error;
        throw new $89ced3714c4601d4$export$ada441573746c62a({
            reason: 'Context Cancel'
        });
    };
    CoreContext.prototype.log = function(level, message, extras) {
        this.logger.log(level, message, extras);
    };
    Object.defineProperty(CoreContext.prototype, "id", {
        get: function() {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    CoreContext.prototype.updateEvent = function(path, val) {
        var _a;
        // Don't allow integrations that are set to false to be overwritten with integration settings.
        if (path.split('.')[0] === 'integrations') {
            var integrationName = path.split('.')[1];
            if (((_a = this.event.integrations) === null || _a === void 0 ? void 0 : _a[integrationName]) === false) return this.event;
        }
        (0, $7Hnuj.dset)(this.event, path, val);
        return this.event;
    };
    CoreContext.prototype.failedDelivery = function() {
        return this._failedDelivery;
    };
    CoreContext.prototype.setFailedDelivery = function(options) {
        this._failedDelivery = options;
    };
    CoreContext.prototype.logs = function() {
        return this.logger.logs;
    };
    CoreContext.prototype.flush = function() {
        this.logger.flush();
        this.stats.flush();
    };
    CoreContext.prototype.toJSON = function() {
        return {
            id: this._id,
            event: this.event,
            logs: this.logger.logs,
            metrics: this.stats.metrics
        };
    };
    return CoreContext;
}();

});
parcelRegister("fMO1n", function(module, exports) {

$parcel$export(module.exports, "v4", function () { return $04dfaca9c0a63517$export$afaf85bc510dd0d6; });
var $04dfaca9c0a63517$var$IDX = 256, $04dfaca9c0a63517$var$HEX = [], $04dfaca9c0a63517$var$BUFFER;
while($04dfaca9c0a63517$var$IDX--)$04dfaca9c0a63517$var$HEX[$04dfaca9c0a63517$var$IDX] = ($04dfaca9c0a63517$var$IDX + 256).toString(16).substring(1);
function $04dfaca9c0a63517$export$afaf85bc510dd0d6() {
    var i = 0, num, out = '';
    if (!$04dfaca9c0a63517$var$BUFFER || $04dfaca9c0a63517$var$IDX + 16 > 256) {
        $04dfaca9c0a63517$var$BUFFER = Array(i = 256);
        while(i--)$04dfaca9c0a63517$var$BUFFER[i] = 256 * Math.random() | 0;
        i = $04dfaca9c0a63517$var$IDX = 0;
    }
    for(; i < 16; i++){
        num = $04dfaca9c0a63517$var$BUFFER[$04dfaca9c0a63517$var$IDX + i];
        if (i == 6) out += $04dfaca9c0a63517$var$HEX[num & 15 | 64];
        else if (i == 8) out += $04dfaca9c0a63517$var$HEX[num & 63 | 128];
        else out += $04dfaca9c0a63517$var$HEX[num];
        if (i & 1 && i > 1 && i < 11) out += '-';
    }
    $04dfaca9c0a63517$var$IDX++;
    return out;
}

});

parcelRegister("7Hnuj", function(module, exports) {

$parcel$export(module.exports, "dset", function () { return $11e01cf2ca78e2d3$export$ee3a4c904b971225; });
function $11e01cf2ca78e2d3$export$ee3a4c904b971225(obj, keys, val) {
    keys.split && (keys = keys.split('.'));
    var i = 0, l = keys.length, t = obj, x, k;
    while(i < l){
        k = '' + keys[i++];
        if (k === '__proto__' || k === 'constructor' || k === 'prototype') break;
        t = t[k] = i === l ? val : typeof (x = t[k]) === typeof keys ? x : keys[i] * 0 !== 0 || !!~('' + keys[i]).indexOf('.') ? {} : [];
    }
}

});

parcelRegister("ksn67", function(module, exports) {

$parcel$export(module.exports, "CoreLogger", function () { return $ee4856e2d1503510$export$4ebcef5958c28ae3; });

var $l73V3 = parcelRequire("l73V3");
var $ee4856e2d1503510$export$4ebcef5958c28ae3 = /** @class */ function() {
    function CoreLogger() {
        this._logs = [];
    }
    CoreLogger.prototype.log = function(level, message, extras) {
        var time = new Date();
        this._logs.push({
            level: level,
            message: message,
            time: time,
            extras: extras
        });
    };
    Object.defineProperty(CoreLogger.prototype, "logs", {
        get: function() {
            return this._logs;
        },
        enumerable: false,
        configurable: true
    });
    CoreLogger.prototype.flush = function() {
        if (this.logs.length > 1) {
            var formatted = this._logs.reduce(function(logs, log) {
                var _a;
                var _b, _c;
                var line = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, log), {
                    json: JSON.stringify(log.extras, null, ' '),
                    extras: log.extras
                });
                delete line['time'];
                var key = (_c = (_b = log.time) === null || _b === void 0 ? void 0 : _b.toISOString()) !== null && _c !== void 0 ? _c : '';
                if (logs[key]) key = "".concat(key, "-").concat(Math.random());
                return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, logs), (_a = {}, _a[key] = line, _a));
            }, {});
            // ie doesn't like console.table
            if (console.table) console.table(formatted);
            else console.log(formatted);
        } else this.logs.forEach(function(logEntry) {
            var level = logEntry.level, message = logEntry.message, extras = logEntry.extras;
            if (level === 'info' || level === 'debug') console.log(message, extras !== null && extras !== void 0 ? extras : '');
            else console[level](message, extras !== null && extras !== void 0 ? extras : '');
        });
        this._logs = [];
    };
    return CoreLogger;
}();

});

parcelRegister("9NJkR", function(module, exports) {

$parcel$export(module.exports, "CoreStats", function () { return $722bdb50782bfc1d$export$3185d45d008181ef; });
$parcel$export(module.exports, "NullStats", function () { return $722bdb50782bfc1d$export$c954f48325143c2b; });

var $l73V3 = parcelRequire("l73V3");
var $722bdb50782bfc1d$var$compactMetricType = function(type) {
    var enums = {
        gauge: 'g',
        counter: 'c'
    };
    return enums[type];
};
var $722bdb50782bfc1d$export$3185d45d008181ef = /** @class */ function() {
    function CoreStats() {
        this.metrics = [];
    }
    CoreStats.prototype.increment = function(metric, by, tags) {
        if (by === void 0) by = 1;
        this.metrics.push({
            metric: metric,
            value: by,
            tags: tags !== null && tags !== void 0 ? tags : [],
            type: 'counter',
            timestamp: Date.now()
        });
    };
    CoreStats.prototype.gauge = function(metric, value, tags) {
        this.metrics.push({
            metric: metric,
            value: value,
            tags: tags !== null && tags !== void 0 ? tags : [],
            type: 'gauge',
            timestamp: Date.now()
        });
    };
    CoreStats.prototype.flush = function() {
        var formatted = this.metrics.map(function(m) {
            return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, m), {
                tags: m.tags.join(',')
            });
        });
        // ie doesn't like console.table
        if (console.table) console.table(formatted);
        else console.log(formatted);
        this.metrics = [];
    };
    /**
     * compact keys for smaller payload
     */ CoreStats.prototype.serialize = function() {
        return this.metrics.map(function(m) {
            return {
                m: m.metric,
                v: m.value,
                t: m.tags,
                k: $722bdb50782bfc1d$var$compactMetricType(m.type),
                e: m.timestamp
            };
        });
    };
    return CoreStats;
}();
var $722bdb50782bfc1d$export$c954f48325143c2b = /** @class */ function(_super) {
    (0, $l73V3.__extends)(NullStats, _super);
    function NullStats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NullStats.prototype.gauge = function() {
        var _args = [];
        for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
    };
    NullStats.prototype.increment = function() {
        var _args = [];
        for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
    };
    NullStats.prototype.flush = function() {
        var _args = [];
        for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
    };
    NullStats.prototype.serialize = function() {
        var _args = [];
        for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
        return [];
    };
    return NullStats;
}($722bdb50782bfc1d$export$3185d45d008181ef);

});


parcelRegister("IQ4PO", function(module, exports) {

$parcel$export(module.exports, "Stats", function () { return $086c8194260d55e7$export$3cdec2bba15e3523; });

var $l73V3 = parcelRequire("l73V3");

var $9NJkR = parcelRequire("9NJkR");

var $3BWbg = parcelRequire("3BWbg");
var $086c8194260d55e7$var$remoteMetrics;
var $086c8194260d55e7$export$3cdec2bba15e3523 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Stats, _super);
    function Stats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Stats.initRemoteMetrics = function(options) {
        $086c8194260d55e7$var$remoteMetrics = new (0, $3BWbg.RemoteMetrics)(options);
    };
    Stats.prototype.increment = function(metric, by, tags) {
        _super.prototype.increment.call(this, metric, by, tags);
        $086c8194260d55e7$var$remoteMetrics === null || $086c8194260d55e7$var$remoteMetrics === void 0 || $086c8194260d55e7$var$remoteMetrics.increment(metric, tags !== null && tags !== void 0 ? tags : []);
    };
    return Stats;
}((0, $9NJkR.CoreStats));

});
parcelRegister("3BWbg", function(module, exports) {

$parcel$export(module.exports, "RemoteMetrics", function () { return $2a11f54b5abd75e0$export$76392d59bdbb51eb; });

var $l73V3 = parcelRequire("l73V3");

var $llDp8 = parcelRequire("llDp8");

var $iZQWy = parcelRequire("iZQWy");

var $eqNzp = parcelRequire("eqNzp");
var $2a11f54b5abd75e0$var$createRemoteMetric = function(metric, tags, versionType) {
    var formattedTags = tags.reduce(function(acc, t) {
        var _a = t.split(':'), k = _a[0], v = _a[1];
        acc[k] = v;
        return acc;
    }, {});
    return {
        type: 'Counter',
        metric: metric,
        value: 1,
        tags: (0, $l73V3.__assign)((0, $l73V3.__assign)({}, formattedTags), {
            library: 'analytics.js',
            library_version: versionType === 'web' ? "next-".concat((0, $iZQWy.version)) : "npm:next-".concat((0, $iZQWy.version))
        })
    };
};
function $2a11f54b5abd75e0$var$logError(err) {
    console.error('Error sending performance metrics', err);
}
var $2a11f54b5abd75e0$export$76392d59bdbb51eb = /** @class */ function() {
    function RemoteMetrics(options) {
        var _this = this;
        var _a, _b, _c, _d;
        this.host = (_a = options === null || options === void 0 ? void 0 : options.host) !== null && _a !== void 0 ? _a : 'cdp.customer.io/v1';
        this.sampleRate = (_b = options === null || options === void 0 ? void 0 : options.sampleRate) !== null && _b !== void 0 ? _b : 1;
        this.flushTimer = (_c = options === null || options === void 0 ? void 0 : options.flushTimer) !== null && _c !== void 0 ? _c : 30000; /* 30s */ 
        this.maxQueueSize = (_d = options === null || options === void 0 ? void 0 : options.maxQueueSize) !== null && _d !== void 0 ? _d : 20;
        this.queue = [];
        if (this.sampleRate > 0) {
            var flushing_1 = false;
            var run_1 = function() {
                if (flushing_1) return;
                flushing_1 = true;
                _this.flush().catch($2a11f54b5abd75e0$var$logError);
                flushing_1 = false;
                setTimeout(run_1, _this.flushTimer);
            };
            run_1();
        }
    }
    RemoteMetrics.prototype.increment = function(metric, tags) {
        // All metrics are part of an allow list in Tracking API
        if (!metric.includes('analytics_js.')) return;
        // /m doesn't like empty tags
        if (tags.length === 0) return;
        if (Math.random() > this.sampleRate) return;
        if (this.queue.length >= this.maxQueueSize) return;
        var remoteMetric = $2a11f54b5abd75e0$var$createRemoteMetric(metric, tags, (0, $eqNzp.getVersionType)());
        this.queue.push(remoteMetric);
        if (metric.includes('error')) this.flush().catch($2a11f54b5abd75e0$var$logError);
    };
    RemoteMetrics.prototype.flush = function() {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.queue.length <= 0) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this.send().catch(function(error) {
                                $2a11f54b5abd75e0$var$logError(error);
                                _this.sampleRate = 0;
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RemoteMetrics.prototype.send = function() {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var payload, headers, url;
            return (0, $l73V3.__generator)(this, function(_a) {
                payload = {
                    series: this.queue
                };
                this.queue = [];
                headers = {
                    'Content-Type': 'text/plain'
                };
                url = "https://".concat(this.host, "/m");
                return [
                    2 /*return*/ ,
                    (0, $llDp8.fetch)(url, {
                        headers: headers,
                        body: JSON.stringify(payload),
                        method: 'POST'
                    })
                ];
            });
        });
    };
    return RemoteMetrics;
}();

});
parcelRegister("iZQWy", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $dd46fdfa4b030e93$export$83d89fbfd8236492; });
// This file is generated.
var $dd46fdfa4b030e93$export$83d89fbfd8236492 = '0.1.2';

});

parcelRegister("eqNzp", function(module, exports) {

$parcel$export(module.exports, "getVersionType", function () { return $02b6188c4c46720b$export$778cfa7727995b22; });
$parcel$export(module.exports, "normalize", function () { return $02b6188c4c46720b$export$a3295358bff77e; });

var $l73V3 = parcelRequire("l73V3");

var $9A1In = parcelRequire("9A1In");

var $dQxuv = parcelRequire("dQxuv");

var $fCRDj = parcelRequire("fCRDj");

var $iZQWy = parcelRequire("iZQWy");

var $YZAcZ = parcelRequire("YZAcZ");
var $02b6188c4c46720b$var$cookieOptions;
function $02b6188c4c46720b$var$getCookieOptions() {
    if ($02b6188c4c46720b$var$cookieOptions) return $02b6188c4c46720b$var$cookieOptions;
    var domain = (0, $fCRDj.tld)(window.location.href);
    $02b6188c4c46720b$var$cookieOptions = {
        expires: 31536000000,
        secure: false,
        path: '/'
    };
    if (domain) $02b6188c4c46720b$var$cookieOptions.domain = domain;
    return $02b6188c4c46720b$var$cookieOptions;
}
// Default value will be updated to 'web' in `bundle-umd.ts` for web build.
var $02b6188c4c46720b$var$_version = 'npm';
function $02b6188c4c46720b$export$d2d99a4565d035a6(version) {
    $02b6188c4c46720b$var$_version = version;
}
function $02b6188c4c46720b$export$778cfa7727995b22() {
    return $02b6188c4c46720b$var$_version;
}
function $02b6188c4c46720b$export$aad693544bd25703() {
    var ampId = (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).get('_ga');
    if (ampId && ampId.startsWith('amp')) return ampId;
}
function $02b6188c4c46720b$export$5181674b30e9c0c3(query) {
    if (query.startsWith('?')) query = query.substring(1);
    query = query.replace(/\?/g, '&');
    return query.split('&').reduce(function(acc, str) {
        var _a = str.split('='), k = _a[0], _b = _a[1], v = _b === void 0 ? '' : _b;
        if (k.includes('utm_') && k.length > 4) {
            var utmParam = k.substr(4);
            if (utmParam === 'campaign') utmParam = 'name';
            acc[utmParam] = (0, $dQxuv.gracefulDecodeURIComponent)(v);
        }
        return acc;
    }, {});
}
function $02b6188c4c46720b$var$ads(query) {
    var queryIds = {
        btid: 'dataxu',
        urid: 'millennial-media'
    };
    if (query.startsWith('?')) query = query.substring(1);
    query = query.replace(/\?/g, '&');
    var parts = query.split('&');
    for(var _i = 0, parts_1 = parts; _i < parts_1.length; _i++){
        var part = parts_1[_i];
        var _a = part.split('='), k = _a[0], v = _a[1];
        if (queryIds[k]) return {
            id: v,
            type: queryIds[k]
        };
    }
}
function $02b6188c4c46720b$var$referrerId(query, ctx, disablePersistance) {
    var storage = new (0, $YZAcZ.UniversalStorage)(disablePersistance ? [] : [
        'cookie'
    ], (0, $YZAcZ.getAvailableStorageOptions)($02b6188c4c46720b$var$getCookieOptions()));
    var stored = storage.get('s:context.referrer');
    var ad = $02b6188c4c46720b$var$ads(query);
    ad = ad !== null && ad !== void 0 ? ad : stored;
    if (!ad) return;
    if (ctx) ctx.referrer = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, ctx.referrer), ad);
    storage.set('s:context.referrer', ad);
}
function $02b6188c4c46720b$export$a3295358bff77e(analytics, json, settings, integrations) {
    var _a, _b, _c, _d;
    var user = analytics.user();
    var query = window.location.search;
    json.context = (_b = (_a = json.context) !== null && _a !== void 0 ? _a : json.options) !== null && _b !== void 0 ? _b : {};
    var ctx = json.context;
    delete json.options;
    json.writeKey = settings === null || settings === void 0 ? void 0 : settings.apiKey;
    ctx.userAgent = window.navigator.userAgent;
    // @ts-ignore
    var locale = navigator.userLanguage || navigator.language;
    if (typeof ctx.locale === 'undefined' && typeof locale !== 'undefined') ctx.locale = locale;
    if (!ctx.library) {
        var type = $02b6188c4c46720b$export$778cfa7727995b22();
        if (type === 'web') ctx.library = {
            name: 'analytics.js',
            version: "next-".concat((0, $iZQWy.version))
        };
        else ctx.library = {
            name: 'analytics.js',
            version: "npm:next-".concat((0, $iZQWy.version))
        };
    }
    if (query && !ctx.campaign) ctx.campaign = $02b6188c4c46720b$export$5181674b30e9c0c3(query);
    $02b6188c4c46720b$var$referrerId(query, ctx, (_c = analytics.options.disableClientPersistence) !== null && _c !== void 0 ? _c : false);
    json.userId = json.userId || user.id();
    json.anonymousId = json.anonymousId || user.anonymousId();
    json.sentAt = new Date();
    var failed = analytics.queue.failedInitializations || [];
    if (failed.length > 0) json._metadata = {
        failedInitializations: failed
    };
    var bundled = [];
    var unbundled = [];
    for(var key in integrations){
        var integration = integrations[key];
        if (key === 'Customer.io Data Pipelines') bundled.push(key);
        if (integration.bundlingStatus === 'bundled') bundled.push(key);
        if (integration.bundlingStatus === 'unbundled') unbundled.push(key);
    }
    // This will make sure that the disabled cloud mode destinations will be
    // included in the unbundled list.
    for(var _i = 0, _e = (settings === null || settings === void 0 ? void 0 : settings.unbundledIntegrations) || []; _i < _e.length; _i++){
        var settingsUnbundled = _e[_i];
        if (!unbundled.includes(settingsUnbundled)) unbundled.push(settingsUnbundled);
    }
    var configIds = (_d = settings === null || settings === void 0 ? void 0 : settings.maybeBundledConfigIds) !== null && _d !== void 0 ? _d : {};
    var bundledConfigIds = [];
    bundled.sort().forEach(function(name) {
        var _a;
        ((_a = configIds[name]) !== null && _a !== void 0 ? _a : []).forEach(function(id) {
            bundledConfigIds.push(id);
        });
    });
    if ((settings === null || settings === void 0 ? void 0 : settings.addBundledMetadata) !== false) json._metadata = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, json._metadata), {
        bundled: bundled.sort(),
        unbundled: unbundled.sort(),
        bundledIds: bundledConfigIds
    });
    var amp = $02b6188c4c46720b$export$aad693544bd25703();
    if (amp) ctx.amp = {
        id: amp
    };
    return json;
}

});
parcelRegister("9A1In", function(module, exports) {
/*! js-cookie v3.0.1 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
        }
        function get(key) {
            if (typeof document === 'undefined' || arguments.length && !key) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var foundKey = decodeURIComponent(parts[0]);
                    jar[foundKey] = converter.read(value, foundKey);
                    if (key === foundKey) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(key, attributes) {
                set(key, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});

});

parcelRegister("dQxuv", function(module, exports) {

$parcel$export(module.exports, "gracefulDecodeURIComponent", function () { return $a14a1c4fe1b631c4$export$4953e4bb74026202; });
/**
 * Tries to gets the unencoded version of an encoded component of a
 * Uniform Resource Identifier (URI). If input string is malformed,
 * returns it back as-is.
 *
 * Note: All occurences of the `+` character become ` ` (spaces).
 **/ function $a14a1c4fe1b631c4$export$4953e4bb74026202(encodedURIComponent) {
    try {
        return decodeURIComponent(encodedURIComponent.replace(/\+/g, ' '));
    } catch (_a) {
        return encodedURIComponent;
    }
}

});

parcelRegister("fCRDj", function(module, exports) {

$parcel$export(module.exports, "tld", function () { return $b60402077f946d47$export$9f929de5da154101; });

var $9A1In = parcelRequire("9A1In");
/**
 * Levels returns all levels of the given url.
 *
 * @param {string} url
 * @return {Array}
 * @api public
 */ function $b60402077f946d47$var$levels(url) {
    var host = url.hostname;
    var parts = host.split('.');
    var last = parts[parts.length - 1];
    var levels = [];
    // Ip address.
    if (parts.length === 4 && parseInt(last, 10) > 0) return levels;
    // Localhost.
    if (parts.length <= 1) return levels;
    // Create levels.
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join('.'));
    return levels;
}
function $b60402077f946d47$var$parseUrl(url) {
    try {
        return new URL(url);
    } catch (_a) {
        return;
    }
}
function $b60402077f946d47$export$9f929de5da154101(url) {
    var parsedUrl = $b60402077f946d47$var$parseUrl(url);
    if (!parsedUrl) return;
    var lvls = $b60402077f946d47$var$levels(parsedUrl);
    // Lookup the real top level one.
    for(var i = 0; i < lvls.length; ++i){
        var cname = '__tld__';
        var domain = lvls[i];
        var opts = {
            domain: '.' + domain
        };
        try {
            // cookie access throw an error if the library is ran inside a sandboxed environment (e.g. sandboxed iframe)
            (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).set(cname, '1', opts);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).get(cname)) {
                (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).remove(cname, opts);
                return domain;
            }
        } catch (_) {
            return;
        }
    }
}

});

parcelRegister("YZAcZ", function(module, exports) {

$parcel$export(module.exports, "UniversalStorage", function () { return $0b755fd053383bf4$export$ded9c57084144144; });
$parcel$export(module.exports, "getAvailableStorageOptions", function () { return $0b755fd053383bf4$export$86660af1c8e5dbfa; });
$parcel$export(module.exports, "User", function () { return $0b755fd053383bf4$export$1f44aaf2ec115b54; });
$parcel$export(module.exports, "Group", function () { return $0b755fd053383bf4$export$eb2fcfdbd7ba97d4; });

var $l73V3 = parcelRequire("l73V3");

var $fMO1n = parcelRequire("fMO1n");

var $9A1In = parcelRequire("9A1In");

var $fCRDj = parcelRequire("fCRDj");

var $kcMVt = parcelRequire("kcMVt");
var $0b755fd053383bf4$var$defaults = {
    persist: true,
    cookie: {
        key: 'ajs_user_id',
        oldKey: 'ajs_user'
    },
    localStorage: {
        key: 'ajs_user_traits'
    }
};
var $0b755fd053383bf4$var$Store = /** @class */ function() {
    function Store() {
        this.cache = {};
    }
    Store.prototype.get = function(key) {
        return this.cache[key];
    };
    Store.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    Store.prototype.remove = function(key) {
        delete this.cache[key];
    };
    Object.defineProperty(Store.prototype, "type", {
        get: function() {
            return 'memory';
        },
        enumerable: false,
        configurable: true
    });
    return Store;
}();
var $0b755fd053383bf4$var$ONE_YEAR = 365;
var $0b755fd053383bf4$export$bd0cf18531183c14 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Cookie, _super);
    function Cookie(options) {
        if (options === void 0) options = Cookie.defaults;
        var _this = _super.call(this) || this;
        _this.options = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, Cookie.defaults), options);
        return _this;
    }
    Cookie.available = function() {
        var cookieEnabled = window.navigator.cookieEnabled;
        if (!cookieEnabled) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).set('ajs:cookies', 'test');
            cookieEnabled = document.cookie.includes('ajs:cookies');
            (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).remove('ajs:cookies');
        }
        return cookieEnabled;
    };
    Object.defineProperty(Cookie, "defaults", {
        get: function() {
            return {
                maxage: $0b755fd053383bf4$var$ONE_YEAR,
                domain: (0, $fCRDj.tld)(window.location.href),
                path: '/',
                sameSite: 'Lax'
            };
        },
        enumerable: false,
        configurable: true
    });
    Cookie.prototype.opts = function() {
        return {
            sameSite: this.options.sameSite,
            expires: this.options.maxage,
            domain: this.options.domain,
            path: this.options.path,
            secure: this.options.secure
        };
    };
    Cookie.prototype.get = function(key) {
        try {
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).get(key);
            if (!value) return null;
            try {
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        } catch (e) {
            return null;
        }
    };
    Cookie.prototype.set = function(key, value) {
        if (typeof value === 'string') (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).set(key, value, this.opts());
        else if (value === null) (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).remove(key, this.opts());
        else (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).set(key, JSON.stringify(value), this.opts());
    };
    Cookie.prototype.remove = function(key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9A1In))).remove(key, this.opts());
    };
    Object.defineProperty(Cookie.prototype, "type", {
        get: function() {
            return 'cookie';
        },
        enumerable: false,
        configurable: true
    });
    return Cookie;
}($0b755fd053383bf4$var$Store);
var $0b755fd053383bf4$var$localStorageWarning = function(key, state) {
    console.warn("Unable to access ".concat(key, ", localStorage may be ").concat(state));
};
var $0b755fd053383bf4$export$19fffca37ef3e106 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(LocalStorage, _super);
    function LocalStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalStorage.available = function() {
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    };
    LocalStorage.prototype.get = function(key) {
        try {
            var val = localStorage.getItem(key);
            if (val === null) return null;
            try {
                return JSON.parse(val);
            } catch (e) {
                return val;
            }
        } catch (err) {
            $0b755fd053383bf4$var$localStorageWarning(key, 'unavailable');
            return null;
        }
    };
    LocalStorage.prototype.set = function(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (_a) {
            $0b755fd053383bf4$var$localStorageWarning(key, 'full');
        }
    };
    LocalStorage.prototype.remove = function(key) {
        try {
            return localStorage.removeItem(key);
        } catch (err) {
            $0b755fd053383bf4$var$localStorageWarning(key, 'unavailable');
        }
    };
    Object.defineProperty(LocalStorage.prototype, "type", {
        get: function() {
            return 'localStorage';
        },
        enumerable: false,
        configurable: true
    });
    return LocalStorage;
}($0b755fd053383bf4$var$Store);
var $0b755fd053383bf4$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(stores, storageOptions) {
        this.storageOptions = storageOptions;
        this.enabledStores = stores;
    }
    UniversalStorage.prototype.getStores = function(storeTypes) {
        var _this = this;
        var stores = [];
        this.enabledStores.filter(function(i) {
            return !storeTypes || (storeTypes === null || storeTypes === void 0 ? void 0 : storeTypes.includes(i));
        }).forEach(function(storeType) {
            var storage = _this.storageOptions[storeType];
            if (storage !== undefined) stores.push(storage);
        });
        return stores;
    };
    /*
      This is to support few scenarios where:
      - value exist in one of the stores ( as a result of other stores being cleared from browser ) and we want to resync them
      - read values in AJS 1.0 format ( for customers after 1.0 --> 2.0 migration ) and then re-write them in AJS 2.0 format
    */ /**
     * get value for the key from the stores. it will pick the first value found in the stores, and then sync the value to all the stores
     * if the found value is a number, it will be converted to a string. this is to support legacy behavior that existed in AJS 1.0
     * @param key key for the value to be retrieved
     * @param storeTypes optional array of store types to be used for performing get and sync
     * @returns value for the key or null if not found
     */ UniversalStorage.prototype.getAndSync = function(key, storeTypes) {
        var val = this.get(key, storeTypes);
        // legacy behavior, getAndSync can change the type of a value from number to string (AJS 1.0 stores numerical values as a number)
        var coercedValue = typeof val === 'number' ? val.toString() : val;
        this.set(key, coercedValue, storeTypes);
        return coercedValue;
    };
    /**
     * get value for the key from the stores. it will return the first value found in the stores
     * @param key key for the value to be retrieved
     * @param storeTypes optional array of store types to be used for retrieving the value
     * @returns value for the key or null if not found
     */ UniversalStorage.prototype.get = function(key, storeTypes) {
        var val = null;
        for(var _i = 0, _a = this.getStores(storeTypes); _i < _a.length; _i++){
            var store = _a[_i];
            val = store.get(key);
            if (val) return val;
        }
        return null;
    };
    /**
     * it will set the value for the key in all the stores
     * @param key key for the value to be stored
     * @param value value to be stored
     * @param storeTypes optional array of store types to be used for storing the value
     * @returns value that was stored
     */ UniversalStorage.prototype.set = function(key, value, storeTypes) {
        for(var _i = 0, _a = this.getStores(storeTypes); _i < _a.length; _i++){
            var store = _a[_i];
            store.set(key, value);
        }
    };
    /**
     * remove the value for the key from all the stores
     * @param key key for the value to be removed
     * @param storeTypes optional array of store types to be used for removing the value
     */ UniversalStorage.prototype.clear = function(key, storeTypes) {
        for(var _i = 0, _a = this.getStores(storeTypes); _i < _a.length; _i++){
            var store = _a[_i];
            store.remove(key);
        }
    };
    return UniversalStorage;
}();
function $0b755fd053383bf4$export$86660af1c8e5dbfa(cookieOptions) {
    return {
        cookie: $0b755fd053383bf4$export$bd0cf18531183c14.available() ? new $0b755fd053383bf4$export$bd0cf18531183c14(cookieOptions) : undefined,
        localStorage: $0b755fd053383bf4$export$19fffca37ef3e106.available() ? new $0b755fd053383bf4$export$19fffca37ef3e106() : undefined,
        memory: new $0b755fd053383bf4$var$Store()
    };
}
var $0b755fd053383bf4$export$1f44aaf2ec115b54 = /** @class */ function() {
    function User(options, cookieOptions) {
        if (options === void 0) options = $0b755fd053383bf4$var$defaults;
        var _this = this;
        var _a, _b, _c, _d;
        this.options = {};
        this.id = function(id) {
            if (_this.options.disable) return null;
            var prevId = _this.identityStore.getAndSync(_this.idKey);
            if (id !== undefined) {
                _this.identityStore.set(_this.idKey, id);
                var changingIdentity = id !== prevId && prevId !== null && id !== null;
                if (changingIdentity) _this.anonymousId(null);
            }
            var retId = _this.identityStore.getAndSync(_this.idKey);
            if (retId) return retId;
            var retLeg = _this.legacyUserStore.get($0b755fd053383bf4$var$defaults.cookie.oldKey);
            return retLeg ? typeof retLeg === 'object' ? retLeg.id : retLeg : null;
        };
        this.anonymousId = function(id) {
            var _a, _b;
            if (_this.options.disable) return null;
            if (id === undefined) {
                var val = (_a = _this.identityStore.getAndSync(_this.anonKey)) !== null && _a !== void 0 ? _a : (_b = _this.legacySIO()) === null || _b === void 0 ? void 0 : _b[0];
                if (val) return val;
            }
            if (id === null) {
                _this.identityStore.set(_this.anonKey, null);
                return _this.identityStore.getAndSync(_this.anonKey);
            }
            _this.identityStore.set(_this.anonKey, id !== null && id !== void 0 ? id : (0, $fMO1n.v4)());
            return _this.identityStore.getAndSync(_this.anonKey);
        };
        this.traits = function(traits) {
            var _a;
            if (_this.options.disable) return;
            if (traits === null) traits = {};
            if (traits) _this.traitsStore.set(_this.traitsKey, traits !== null && traits !== void 0 ? traits : {});
            return (_a = _this.traitsStore.get(_this.traitsKey)) !== null && _a !== void 0 ? _a : {};
        };
        this.options = options;
        this.cookieOptions = cookieOptions;
        this.idKey = (_b = (_a = options.cookie) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : $0b755fd053383bf4$var$defaults.cookie.key;
        this.traitsKey = (_d = (_c = options.localStorage) === null || _c === void 0 ? void 0 : _c.key) !== null && _d !== void 0 ? _d : $0b755fd053383bf4$var$defaults.localStorage.key;
        this.anonKey = 'ajs_anonymous_id';
        var isDisabled = options.disable === true;
        var shouldPersist = options.persist !== false;
        var defaultStorageTargets = isDisabled ? [] : shouldPersist ? [
            'localStorage',
            'cookie',
            'memory'
        ] : [
            'memory'
        ];
        var storageOptions = $0b755fd053383bf4$export$86660af1c8e5dbfa(cookieOptions);
        if (options.localStorageFallbackDisabled) defaultStorageTargets = defaultStorageTargets.filter(function(t) {
            return t !== 'localStorage';
        });
        this.identityStore = new $0b755fd053383bf4$export$ded9c57084144144(defaultStorageTargets, storageOptions);
        // using only cookies for legacy user store
        this.legacyUserStore = new $0b755fd053383bf4$export$ded9c57084144144(defaultStorageTargets.filter(function(t) {
            return t !== 'localStorage' && t !== 'memory';
        }), storageOptions);
        // using only localStorage / memory for traits store
        this.traitsStore = new $0b755fd053383bf4$export$ded9c57084144144(defaultStorageTargets.filter(function(t) {
            return t !== 'cookie';
        }), storageOptions);
        var legacyUser = this.legacyUserStore.get($0b755fd053383bf4$var$defaults.cookie.oldKey);
        if (legacyUser && typeof legacyUser === 'object') {
            legacyUser.id && this.id(legacyUser.id);
            legacyUser.traits && this.traits(legacyUser.traits);
        }
        (0, $kcMVt.default)(this);
    }
    User.prototype.legacySIO = function() {
        var val = this.legacyUserStore.get('_sio');
        if (!val) return null;
        var _a = val.split('----'), anon = _a[0], user = _a[1];
        return [
            anon,
            user
        ];
    };
    User.prototype.identify = function(id, traits) {
        if (this.options.disable) return;
        traits = traits !== null && traits !== void 0 ? traits : {};
        var currentId = this.id();
        if (currentId === null || currentId === id) traits = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.traits()), traits);
        if (id) this.id(id);
        this.traits(traits);
    };
    User.prototype.logout = function() {
        this.anonymousId(null);
        this.id(null);
        this.traits({});
    };
    User.prototype.reset = function() {
        this.logout();
        this.identityStore.clear(this.idKey);
        this.identityStore.clear(this.anonKey);
        this.traitsStore.clear(this.traitsKey);
    };
    User.prototype.load = function() {
        return new User(this.options, this.cookieOptions);
    };
    User.prototype.save = function() {
        return true;
    };
    User.defaults = $0b755fd053383bf4$var$defaults;
    return User;
}();
var $0b755fd053383bf4$var$groupDefaults = {
    persist: true,
    cookie: {
        key: 'ajs_group_id'
    },
    localStorage: {
        key: 'ajs_group_properties'
    }
};
var $0b755fd053383bf4$export$eb2fcfdbd7ba97d4 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Group, _super);
    function Group(options, cookie) {
        if (options === void 0) options = $0b755fd053383bf4$var$groupDefaults;
        var _this = _super.call(this, options, cookie) || this;
        _this.anonymousId = function(_id) {
            return undefined;
        };
        (0, $kcMVt.default)(_this);
        return _this;
    }
    return Group;
}($0b755fd053383bf4$export$1f44aaf2ec115b54);

});
parcelRegister("kcMVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb5ae1570903eba6$export$2e2bcd8739ae039; });
function $eb5ae1570903eba6$export$2e2bcd8739ae039(obj) {
    var proto = obj.constructor.prototype;
    for(var _i = 0, _a = Object.getOwnPropertyNames(proto); _i < _a.length; _i++){
        var key = _a[_i];
        if (key !== 'constructor') {
            var desc = Object.getOwnPropertyDescriptor(obj.constructor.prototype, key);
            if (!!desc && typeof desc.value === 'function') obj[key] = obj[key].bind(obj);
        }
    }
    return obj;
}

});






parcelRegister("jgE2t", function(module, exports) {

$parcel$export(module.exports, "dispatch", function () { return $e06e91d6a4b82f20$export$635e15bbd66f01ea; });

var $l73V3 = parcelRequire("l73V3");

var $2eMTE = parcelRequire("2eMTE");
var $e06e91d6a4b82f20$export$621ec2f31bd1c7ec = function(startTimeInEpochMS, timeoutInMS) {
    var elapsedTime = Date.now() - startTimeInEpochMS;
    // increasing the timeout increases the delay by almost the same amount -- this is weird legacy behavior.
    return Math.max((timeoutInMS !== null && timeoutInMS !== void 0 ? timeoutInMS : 300) - elapsedTime, 0);
};
function $e06e91d6a4b82f20$export$635e15bbd66f01ea(ctx, queue, emitter, options) {
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var startTime, dispatched;
        return (0, $l73V3.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    emitter.emit('dispatch_start', ctx);
                    startTime = Date.now();
                    if (!queue.isEmpty()) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        queue.dispatchSingle(ctx)
                    ];
                case 1:
                    dispatched = _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        queue.dispatch(ctx)
                    ];
                case 3:
                    dispatched = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(options === null || options === void 0 ? void 0 : options.callback)) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $2eMTE.invokeCallback)(dispatched, options.callback, $e06e91d6a4b82f20$export$621ec2f31bd1c7ec(startTime, options.timeout))
                    ];
                case 5:
                    dispatched = _a.sent();
                    _a.label = 6;
                case 6:
                    if (options === null || options === void 0 ? void 0 : options.debug) dispatched.flush();
                    return [
                        2 /*return*/ ,
                        dispatched
                    ];
            }
        });
    });
}

});
parcelRegister("2eMTE", function(module, exports) {

$parcel$export(module.exports, "pTimeout", function () { return $1a12d169a2b9065c$export$f44073814b07054f; });
$parcel$export(module.exports, "invokeCallback", function () { return $1a12d169a2b9065c$export$31b1bbb9b2a737e6; });
function $1a12d169a2b9065c$export$f44073814b07054f(promise, timeout) {
    return new Promise(function(resolve, reject) {
        var timeoutId = setTimeout(function() {
            reject(Error('Promise timed out'));
        }, timeout);
        promise.then(function(val) {
            clearTimeout(timeoutId);
            return resolve(val);
        }).catch(reject);
    });
}
function $1a12d169a2b9065c$export$e772c8ff12451969(timeoutInMs) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, timeoutInMs);
    });
}
function $1a12d169a2b9065c$export$31b1bbb9b2a737e6(ctx, callback, delay) {
    var cb = function() {
        try {
            return Promise.resolve(callback(ctx));
        } catch (err) {
            return Promise.reject(err);
        }
    };
    return $1a12d169a2b9065c$export$e772c8ff12451969(delay)// pTimeout ensures that the callback can't cause the context to hang
    .then(function() {
        return $1a12d169a2b9065c$export$f44073814b07054f(cb(), 1000);
    }).catch(function(err) {
        ctx === null || ctx === void 0 || ctx.log('warn', 'Callback Error', {
            error: err
        });
        ctx === null || ctx === void 0 || ctx.stats.increment('callback_error');
    }).then(function() {
        return ctx;
    });
}

});


parcelRegister("j90yV", function(module, exports) {

$parcel$export(module.exports, "Emitter", function () { return $deff4b397f5e4d52$export$4293555f241ae35a; });
/**
 * Event Emitter that takes the expected contract as a generic
 * @example
 * ```ts
 *  type Contract = {
 *    delivery_success: [DeliverySuccessResponse, Metrics],
 *    delivery_failure: [DeliveryError]
 * }
 *  new Emitter<Contract>()
 *  .on('delivery_success', (res, metrics) => ...)
 *  .on('delivery_failure', (err) => ...)
 * ```
 */ var $deff4b397f5e4d52$export$4293555f241ae35a = /** @class */ function() {
    function Emitter() {
        this.callbacks = {};
    }
    Emitter.prototype.on = function(event, callback) {
        if (!this.callbacks[event]) this.callbacks[event] = [
            callback
        ];
        else this.callbacks[event].push(callback);
        return this;
    };
    Emitter.prototype.once = function(event, callback) {
        var _this = this;
        var on = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            _this.off(event, on);
            callback.apply(_this, args);
        };
        this.on(event, on);
        return this;
    };
    Emitter.prototype.off = function(event, callback) {
        var _a;
        var fns = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
        var without = fns.filter(function(fn) {
            return fn !== callback;
        });
        this.callbacks[event] = without;
        return this;
    };
    Emitter.prototype.emit = function(event) {
        var _this = this;
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var callbacks = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
        callbacks.forEach(function(callback) {
            callback.apply(_this, args);
        });
        return this;
    };
    return Emitter;
}();

});

parcelRegister("j5aZf", function(module, exports) {

$parcel$export(module.exports, "EventFactory", function () { return $de4701b3d326f408$export$e804247f9a3d5fd2; });

var $l73V3 = parcelRequire("l73V3");

var $fMO1n = parcelRequire("fMO1n");

var $7Hnuj = parcelRequire("7Hnuj");

var $gtwLb = parcelRequire("gtwLb");

var $de4701b3d326f408$export$e804247f9a3d5fd2 = /** @class */ function() {
    function EventFactory(user) {
        this.user = user;
    }
    EventFactory.prototype.track = function(event, properties, options, globalIntegrations) {
        return this.normalize((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.baseEvent()), {
            event: event,
            type: 'track',
            properties: properties,
            options: (0, $l73V3.__assign)({}, options),
            integrations: (0, $l73V3.__assign)({}, globalIntegrations)
        }));
    };
    EventFactory.prototype.page = function(category, page, properties, options, globalIntegrations) {
        var _a;
        var event = {
            type: 'page',
            properties: (0, $l73V3.__assign)({}, properties),
            options: (0, $l73V3.__assign)({}, options),
            integrations: (0, $l73V3.__assign)({}, globalIntegrations)
        };
        if (category !== null) {
            event.category = category;
            event.properties = (_a = event.properties) !== null && _a !== void 0 ? _a : {};
            event.properties.category = category;
        }
        if (page !== null) event.name = page;
        return this.normalize((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.baseEvent()), event));
    };
    EventFactory.prototype.screen = function(category, screen, properties, options, globalIntegrations) {
        var event = {
            type: 'screen',
            properties: (0, $l73V3.__assign)({}, properties),
            options: (0, $l73V3.__assign)({}, options),
            integrations: (0, $l73V3.__assign)({}, globalIntegrations)
        };
        if (category !== null) event.category = category;
        if (screen !== null) event.name = screen;
        return this.normalize((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.baseEvent()), event));
    };
    EventFactory.prototype.identify = function(userId, traits, options, globalIntegrations) {
        return this.normalize((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.baseEvent()), {
            type: 'identify',
            userId: userId,
            traits: traits,
            options: (0, $l73V3.__assign)({}, options),
            integrations: (0, $l73V3.__assign)({}, globalIntegrations)
        }));
    };
    EventFactory.prototype.group = function(groupId, traits, options, globalIntegrations) {
        return this.normalize((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.baseEvent()), {
            type: 'group',
            traits: traits,
            options: (0, $l73V3.__assign)({}, options),
            integrations: (0, $l73V3.__assign)({}, globalIntegrations),
            groupId: groupId
        }));
    };
    EventFactory.prototype.alias = function(to, from, options, globalIntegrations) {
        var base = {
            userId: to,
            type: 'alias',
            options: (0, $l73V3.__assign)({}, options),
            integrations: (0, $l73V3.__assign)({}, globalIntegrations)
        };
        if (from !== null) base.previousId = from;
        if (to === undefined) return this.normalize((0, $l73V3.__assign)((0, $l73V3.__assign)({}, base), this.baseEvent()));
        return this.normalize((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.baseEvent()), base));
    };
    EventFactory.prototype.baseEvent = function() {
        var base = {
            integrations: {},
            options: {}
        };
        var user = this.user;
        if (user.id()) base.userId = user.id();
        if (user.anonymousId()) base.anonymousId = user.anonymousId();
        return base;
    };
    /**
     * Builds the context part of an event based on "foreign" keys that
     * are provided in the `Options` parameter for an Event
     */ EventFactory.prototype.context = function(event) {
        var _a, _b, _c;
        var optionsKeys = [
            'integrations',
            'anonymousId',
            'timestamp',
            'userId'
        ];
        var options = (_a = event.options) !== null && _a !== void 0 ? _a : {};
        delete options['integrations'];
        var providedOptionsKeys = Object.keys(options);
        var context = (_c = (_b = event.options) === null || _b === void 0 ? void 0 : _b.context) !== null && _c !== void 0 ? _c : {};
        var overrides = {};
        providedOptionsKeys.forEach(function(key) {
            if (key === 'context') return;
            if (optionsKeys.includes(key)) (0, $7Hnuj.dset)(overrides, key, options[key]);
            else (0, $7Hnuj.dset)(context, key, options[key]);
        });
        return [
            context,
            overrides
        ];
    };
    EventFactory.prototype.normalize = function(event) {
        var _a, _b, _c;
        // set anonymousId globally if we encounter an override
        ((_a = event.options) === null || _a === void 0 ? void 0 : _a.anonymousId) && this.user.anonymousId(event.options.anonymousId);
        var integrationBooleans = Object.keys((_b = event.integrations) !== null && _b !== void 0 ? _b : {}).reduce(function(integrationNames, name) {
            var _a;
            var _b;
            return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, integrationNames), (_a = {}, _a[name] = Boolean((_b = event.integrations) === null || _b === void 0 ? void 0 : _b[name]), _a));
        }, {});
        // This is pretty trippy, but here's what's going on:
        // - a) We don't pass initial integration options as part of the event, only if they're true or false
        // - b) We do accept per integration overrides (like integrations.Amplitude.sessionId) at the event level
        // Hence the need to convert base integration options to booleans, but maintain per event integration overrides
        var allIntegrations = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, integrationBooleans), (_c = event.options) === null || _c === void 0 ? void 0 : _c.integrations);
        var _d = this.context(event), context = _d[0], overrides = _d[1];
        var options = event.options, rest = (0, $l73V3.__rest)(event, [
            "options"
        ]);
        var body = (0, $l73V3.__assign)((0, $l73V3.__assign)((0, $l73V3.__assign)({
            timestamp: new Date()
        }, rest), {
            context: context,
            integrations: allIntegrations
        }), overrides);
        var messageId = 'ajs-next-' + (0, (/*@__PURE__*/$parcel$interopDefault($gtwLb))).hash(JSON.stringify(body) + (0, $fMO1n.v4)());
        var evt = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, body), {
            messageId: messageId
        });
        return evt;
    };
    return EventFactory;
}();

});
parcelRegister("gtwLb", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    'use strict';
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f'
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = '', j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join('');
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') add32 = function(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = '';
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});


parcelRegister("iKTLf", function(module, exports) {

$parcel$export(module.exports, "EventQueue", function () { return $da77c6d93b151190$export$2fc6338444a158e6; });

var $l73V3 = parcelRequire("l73V3");

var $3r7RW = parcelRequire("3r7RW");

var $kFVnU = parcelRequire("kFVnU");
var $da77c6d93b151190$export$2fc6338444a158e6 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(EventQueue, _super);
    function EventQueue(priorityQueue) {
        return _super.call(this, priorityQueue !== null && priorityQueue !== void 0 ? priorityQueue : new (0, $3r7RW.PersistedPriorityQueue)(4, 'event-queue')) || this;
    }
    return EventQueue;
}((0, $kFVnU.CoreEventQueue));

});
parcelRegister("3r7RW", function(module, exports) {

$parcel$export(module.exports, "PersistedPriorityQueue", function () { return $2809ff56810385ed$export$9044de5abe0e38a8; });

var $l73V3 = parcelRequire("l73V3");

var $2H1l5 = parcelRequire("2H1l5");

var $jVL2A = parcelRequire("jVL2A");

var $acTDO = parcelRequire("acTDO");
var $2809ff56810385ed$var$loc = {
    getItem: function() {},
    setItem: function() {},
    removeItem: function() {}
};
try {
    $2809ff56810385ed$var$loc = (0, $acTDO.isBrowser)() && window.localStorage ? window.localStorage : $2809ff56810385ed$var$loc;
} catch (err) {
    console.warn('Unable to access localStorage', err);
}
function $2809ff56810385ed$var$persisted(key) {
    var items = $2809ff56810385ed$var$loc.getItem(key);
    return (items ? JSON.parse(items) : []).map(function(p) {
        return new (0, $jVL2A.Context)(p.event, p.id);
    });
}
function $2809ff56810385ed$var$persistItems(key, items) {
    var existing = $2809ff56810385ed$var$persisted(key);
    var all = (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([], items, true), existing, true);
    var merged = all.reduce(function(acc, item) {
        var _a;
        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, acc), (_a = {}, _a[item.id] = item, _a));
    }, {});
    $2809ff56810385ed$var$loc.setItem(key, JSON.stringify(Object.values(merged)));
}
function $2809ff56810385ed$var$seen(key) {
    var stored = $2809ff56810385ed$var$loc.getItem(key);
    return stored ? JSON.parse(stored) : {};
}
function $2809ff56810385ed$var$persistSeen(key, memory) {
    var stored = $2809ff56810385ed$var$seen(key);
    $2809ff56810385ed$var$loc.setItem(key, JSON.stringify((0, $l73V3.__assign)((0, $l73V3.__assign)({}, stored), memory)));
}
function $2809ff56810385ed$var$remove(key) {
    $2809ff56810385ed$var$loc.removeItem(key);
}
var $2809ff56810385ed$var$now = function() {
    return new Date().getTime();
};
function $2809ff56810385ed$var$mutex(key, onUnlock, attempt) {
    if (attempt === void 0) attempt = 0;
    var lockTimeout = 50;
    var lockKey = "persisted-queue:v1:".concat(key, ":lock");
    var expired = function(lock) {
        return new Date().getTime() > lock;
    };
    var rawLock = $2809ff56810385ed$var$loc.getItem(lockKey);
    var lock = rawLock ? JSON.parse(rawLock) : null;
    var allowed = lock === null || expired(lock);
    if (allowed) {
        $2809ff56810385ed$var$loc.setItem(lockKey, JSON.stringify($2809ff56810385ed$var$now() + lockTimeout));
        onUnlock();
        $2809ff56810385ed$var$loc.removeItem(lockKey);
        return;
    }
    if (!allowed && attempt < 3) setTimeout(function() {
        $2809ff56810385ed$var$mutex(key, onUnlock, attempt + 1);
    }, lockTimeout);
    else console.error('Unable to retrieve lock');
}
var $2809ff56810385ed$export$9044de5abe0e38a8 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(PersistedPriorityQueue, _super);
    function PersistedPriorityQueue(maxAttempts, key) {
        var _this = _super.call(this, maxAttempts, []) || this;
        var itemsKey = "persisted-queue:v1:".concat(key, ":items");
        var seenKey = "persisted-queue:v1:".concat(key, ":seen");
        var saved = [];
        var lastSeen = {};
        $2809ff56810385ed$var$mutex(key, function() {
            try {
                saved = $2809ff56810385ed$var$persisted(itemsKey);
                lastSeen = $2809ff56810385ed$var$seen(seenKey);
                $2809ff56810385ed$var$remove(itemsKey);
                $2809ff56810385ed$var$remove(seenKey);
                _this.queue = (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([], saved, true), _this.queue, true);
                _this.seen = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, lastSeen), _this.seen);
            } catch (err) {
                console.error(err);
            }
        });
        window.addEventListener('pagehide', function() {
            // we deliberately want to use the less powerful 'pagehide' API to only persist on events where the analytics instance gets destroyed, and not on tab away.
            if (_this.todo > 0) {
                var items_1 = (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([], _this.queue, true), _this.future, true);
                try {
                    $2809ff56810385ed$var$mutex(key, function() {
                        $2809ff56810385ed$var$persistItems(itemsKey, items_1);
                        $2809ff56810385ed$var$persistSeen(seenKey, _this.seen);
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        });
        return _this;
    }
    return PersistedPriorityQueue;
}((0, $2H1l5.PriorityQueue));

});
parcelRegister("2H1l5", function(module, exports) {

$parcel$export(module.exports, "ON_REMOVE_FROM_FUTURE", function () { return $1f60a2d1fc30991c$export$d589507f6228d567; });
$parcel$export(module.exports, "PriorityQueue", function () { return $1f60a2d1fc30991c$export$8fbd1ac8e83536df; });

var $l73V3 = parcelRequire("l73V3");

var $j90yV = parcelRequire("j90yV");

var $bez21 = parcelRequire("bez21");
var $1f60a2d1fc30991c$export$d589507f6228d567 = 'onRemoveFromFuture';
var $1f60a2d1fc30991c$export$8fbd1ac8e83536df = /** @class */ function(_super) {
    (0, $l73V3.__extends)(PriorityQueue, _super);
    function PriorityQueue(maxAttempts, queue, seen) {
        var _this = _super.call(this) || this;
        _this.future = [];
        _this.maxAttempts = maxAttempts;
        _this.queue = queue;
        _this.seen = seen !== null && seen !== void 0 ? seen : {};
        return _this;
    }
    PriorityQueue.prototype.push = function() {
        var _this = this;
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        var accepted = items.map(function(operation) {
            var attempts = _this.updateAttempts(operation);
            if (attempts > _this.maxAttempts || _this.includes(operation)) return false;
            _this.queue.push(operation);
            return true;
        });
        this.queue = this.queue.sort(function(a, b) {
            return _this.getAttempts(a) - _this.getAttempts(b);
        });
        return accepted;
    };
    PriorityQueue.prototype.pushWithBackoff = function(item) {
        var _this = this;
        if (this.getAttempts(item) === 0) return this.push(item)[0];
        var attempt = this.updateAttempts(item);
        if (attempt > this.maxAttempts || this.includes(item)) return false;
        var timeout = (0, $bez21.backoff)({
            attempt: attempt - 1
        });
        setTimeout(function() {
            _this.queue.push(item);
            // remove from future list
            _this.future = _this.future.filter(function(f) {
                return f.id !== item.id;
            });
            // Lets listeners know that a 'future' message is now available in the queue
            _this.emit($1f60a2d1fc30991c$export$d589507f6228d567);
        }, timeout);
        this.future.push(item);
        return true;
    };
    PriorityQueue.prototype.getAttempts = function(item) {
        var _a;
        return (_a = this.seen[item.id]) !== null && _a !== void 0 ? _a : 0;
    };
    PriorityQueue.prototype.updateAttempts = function(item) {
        this.seen[item.id] = this.getAttempts(item) + 1;
        return this.getAttempts(item);
    };
    PriorityQueue.prototype.includes = function(item) {
        return this.queue.includes(item) || this.future.includes(item) || Boolean(this.queue.find(function(i) {
            return i.id === item.id;
        })) || Boolean(this.future.find(function(i) {
            return i.id === item.id;
        }));
    };
    PriorityQueue.prototype.pop = function() {
        return this.queue.shift();
    };
    Object.defineProperty(PriorityQueue.prototype, "length", {
        get: function() {
            return this.queue.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriorityQueue.prototype, "todo", {
        get: function() {
            return this.queue.length + this.future.length;
        },
        enumerable: false,
        configurable: true
    });
    return PriorityQueue;
}((0, $j90yV.Emitter));

});
parcelRegister("bez21", function(module, exports) {

$parcel$export(module.exports, "backoff", function () { return $82dc2d16c01462bf$export$562bc4a862c31607; });
function $82dc2d16c01462bf$export$562bc4a862c31607(params) {
    var random = Math.random() + 1;
    var _a = params.minTimeout, minTimeout = _a === void 0 ? 500 : _a, _b = params.factor, factor = _b === void 0 ? 2 : _b, attempt = params.attempt, _c = params.maxTimeout, maxTimeout = _c === void 0 ? Infinity : _c;
    return Math.min(random * minTimeout * Math.pow(factor, attempt), maxTimeout);
}

});



parcelRegister("kFVnU", function(module, exports) {

$parcel$export(module.exports, "CoreEventQueue", function () { return $f0d4265d8c5a9df1$export$69928e7b2e73ecc6; });

var $l73V3 = parcelRequire("l73V3");

var $kWn5z = parcelRequire("kWn5z");

var $2H1l5 = parcelRequire("2H1l5");

var $bPxZD = parcelRequire("bPxZD");

var $j90yV = parcelRequire("j90yV");

var $j63iU = parcelRequire("j63iU");

var $8BSni = parcelRequire("8BSni");

var $3bRR1 = parcelRequire("3bRR1");
var $f0d4265d8c5a9df1$export$69928e7b2e73ecc6 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(CoreEventQueue, _super);
    function CoreEventQueue(priorityQueue) {
        var _this = _super.call(this) || this;
        /**
         * All event deliveries get suspended until all the tasks in this task group are complete.
         * For example: a middleware that augments the event object should be loaded safely as a
         * critical task, this way, event queue will wait for it to be ready before sending events.
         *
         * This applies to all the events already in the queue, and the upcoming ones
         */ _this.criticalTasks = (0, $j63iU.createTaskGroup)();
        _this.plugins = [];
        _this.failedInitializations = [];
        _this.flushing = false;
        _this.queue = priorityQueue;
        _this.queue.on((0, $2H1l5.ON_REMOVE_FROM_FUTURE), function() {
            _this.scheduleFlush(0);
        });
        return _this;
    }
    CoreEventQueue.prototype.register = function(ctx, plugin, instance) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(plugin.load(ctx, instance)).then(function() {
                                _this.plugins.push(plugin);
                            }).catch(function(err) {
                                if (plugin.type === 'destination') {
                                    _this.failedInitializations.push(plugin.name);
                                    console.warn(plugin.name, err);
                                    ctx.log('warn', 'Failed to load destination', {
                                        plugin: plugin.name,
                                        error: err
                                    });
                                    return;
                                }
                                throw err;
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CoreEventQueue.prototype.deregister = function(ctx, plugin, instance) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var e_1;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!plugin.unload) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(plugin.unload(ctx, instance))
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.plugins = this.plugins.filter(function(p) {
                            return p.name !== plugin.name;
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        ctx.log('warn', 'Failed to unload destination', {
                            plugin: plugin.name,
                            error: e_1
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CoreEventQueue.prototype.dispatch = function(ctx) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var willDeliver;
            return (0, $l73V3.__generator)(this, function(_a) {
                ctx.log('debug', 'Dispatching');
                ctx.stats.increment('message_dispatched');
                this.queue.push(ctx);
                willDeliver = this.subscribeToDelivery(ctx);
                this.scheduleFlush(0);
                return [
                    2 /*return*/ ,
                    willDeliver
                ];
            });
        });
    };
    CoreEventQueue.prototype.subscribeToDelivery = function(ctx) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        var onDeliver = function(flushed, delivered) {
                            if (flushed.isSame(ctx)) {
                                _this.off('flush', onDeliver);
                                if (delivered) resolve(flushed);
                                else resolve(flushed);
                            }
                        };
                        _this.on('flush', onDeliver);
                    })
                ];
            });
        });
    };
    CoreEventQueue.prototype.dispatchSingle = function(ctx) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                ctx.log('debug', 'Dispatching');
                ctx.stats.increment('message_dispatched');
                this.queue.updateAttempts(ctx);
                ctx.attempts = 1;
                return [
                    2 /*return*/ ,
                    this.deliver(ctx).catch(function(err) {
                        var accepted = _this.enqueuRetry(err, ctx);
                        if (!accepted) {
                            ctx.setFailedDelivery({
                                reason: err
                            });
                            return ctx;
                        }
                        return _this.subscribeToDelivery(ctx);
                    })
                ];
            });
        });
    };
    CoreEventQueue.prototype.isEmpty = function() {
        return this.queue.length === 0;
    };
    CoreEventQueue.prototype.scheduleFlush = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = 500;
        if (this.flushing) return;
        this.flushing = true;
        setTimeout(function() {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            _this.flush().then(function() {
                setTimeout(function() {
                    _this.flushing = false;
                    if (_this.queue.length) _this.scheduleFlush(0);
                }, 0);
            });
        }, timeout);
    };
    CoreEventQueue.prototype.deliver = function(ctx) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var start, done, err_1, error;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.criticalTasks.done()
                        ];
                    case 1:
                        _a.sent();
                        start = Date.now();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.flushOne(ctx)
                        ];
                    case 3:
                        ctx = _a.sent();
                        done = Date.now() - start;
                        this.emit('delivery_success', ctx);
                        ctx.stats.gauge('delivered', done);
                        ctx.log('debug', 'Delivered', ctx.event);
                        return [
                            2 /*return*/ ,
                            ctx
                        ];
                    case 4:
                        err_1 = _a.sent();
                        error = err_1;
                        ctx.log('error', 'Failed to deliver', error);
                        this.emit('delivery_failure', ctx, error);
                        ctx.stats.increment('delivery_failed');
                        throw err_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CoreEventQueue.prototype.enqueuRetry = function(err, ctx) {
        var retriable = !(err instanceof (0, $bPxZD.ContextCancelation)) || err.retry;
        if (!retriable) return false;
        return this.queue.pushWithBackoff(ctx);
    };
    CoreEventQueue.prototype.flush = function() {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var ctx, err_2, accepted;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.queue.length === 0 || (0, $3bRR1.isOffline)()) return [
                            2 /*return*/ ,
                            []
                        ];
                        ctx = this.queue.pop();
                        if (!ctx) return [
                            2 /*return*/ ,
                            []
                        ];
                        ctx.attempts = this.queue.getAttempts(ctx);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.deliver(ctx)
                        ];
                    case 2:
                        ctx = _a.sent();
                        this.emit('flush', ctx, true);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_2 = _a.sent();
                        accepted = this.enqueuRetry(err_2, ctx);
                        if (!accepted) {
                            ctx.setFailedDelivery({
                                reason: err_2
                            });
                            this.emit('flush', ctx, false);
                        }
                        return [
                            2 /*return*/ ,
                            []
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            [
                                ctx
                            ]
                        ];
                }
            });
        });
    };
    CoreEventQueue.prototype.isReady = function() {
        // return this.plugins.every((p) => p.isLoaded())
        // should we wait for every plugin to load?
        return true;
    };
    CoreEventQueue.prototype.availableExtensions = function(denyList) {
        var available = this.plugins.filter(function(p) {
            var _a, _b, _c;
            // Only filter out destination plugins or the Customer.io Data Pipeline plugin
            if (p.type !== 'destination' && p.name !== 'Customer.io Data Pipelines') return true;
            var alternativeNameMatch = undefined;
            (_a = p.alternativeNames) === null || _a === void 0 || _a.forEach(function(name) {
                if (denyList[name] !== undefined) alternativeNameMatch = denyList[name];
            });
            // Explicit integration option takes precedence, `All: false` does not apply to Customer.io Data Pipelines
            return (_c = (_b = denyList[p.name]) !== null && _b !== void 0 ? _b : alternativeNameMatch) !== null && _c !== void 0 ? _c : (p.name === 'Customer.io Data Pipelines' ? true : denyList.All) !== false;
        });
        var _a = (0, $kWn5z.groupBy)(available, 'type'), _b = _a.before, before = _b === void 0 ? [] : _b, _c = _a.enrichment, enrichment = _c === void 0 ? [] : _c, _d = _a.destination, destination = _d === void 0 ? [] : _d, _e = _a.after, after = _e === void 0 ? [] : _e;
        return {
            before: before,
            enrichment: enrichment,
            destinations: destination,
            after: after
        };
    };
    CoreEventQueue.prototype.flushOne = function(ctx) {
        var _a, _b;
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var _c, before, enrichment, _i, before_1, beforeWare, temp, _d, enrichment_1, enrichmentWare, temp, _e, destinations, after, afterCalls;
            return (0, $l73V3.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        if (!this.isReady()) throw new Error('Not ready');
                        if (ctx.attempts > 1) this.emit('delivery_retry', ctx);
                        _c = this.availableExtensions((_a = ctx.event.integrations) !== null && _a !== void 0 ? _a : {}), before = _c.before, enrichment = _c.enrichment;
                        _i = 0, before_1 = before;
                        _f.label = 1;
                    case 1:
                        if (!(_i < before_1.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        beforeWare = before_1[_i];
                        return [
                            4 /*yield*/ ,
                            (0, $8BSni.ensure)(ctx, beforeWare)
                        ];
                    case 2:
                        temp = _f.sent();
                        if (temp instanceof (0, $bPxZD.CoreContext)) ctx = temp;
                        this.emit('message_enriched', ctx, beforeWare);
                        _f.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        _d = 0, enrichment_1 = enrichment;
                        _f.label = 5;
                    case 5:
                        if (!(_d < enrichment_1.length)) return [
                            3 /*break*/ ,
                            8
                        ];
                        enrichmentWare = enrichment_1[_d];
                        return [
                            4 /*yield*/ ,
                            (0, $8BSni.attempt)(ctx, enrichmentWare)
                        ];
                    case 6:
                        temp = _f.sent();
                        if (temp instanceof (0, $bPxZD.CoreContext)) ctx = temp;
                        this.emit('message_enriched', ctx, enrichmentWare);
                        _f.label = 7;
                    case 7:
                        _d++;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        _e = this.availableExtensions((_b = ctx.event.integrations) !== null && _b !== void 0 ? _b : {}), destinations = _e.destinations, after = _e.after;
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                setTimeout(function() {
                                    var attempts = destinations.map(function(destination) {
                                        return (0, $8BSni.attempt)(ctx, destination);
                                    });
                                    Promise.all(attempts).then(resolve).catch(reject);
                                }, 0);
                            })
                        ];
                    case 9:
                        _f.sent();
                        ctx.stats.increment('message_delivered');
                        this.emit('message_delivered', ctx);
                        afterCalls = after.map(function(after) {
                            return (0, $8BSni.attempt)(ctx, after);
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(afterCalls)
                        ];
                    case 10:
                        _f.sent();
                        return [
                            2 /*return*/ ,
                            ctx
                        ];
                }
            });
        });
    };
    return CoreEventQueue;
}((0, $j90yV.Emitter));

});
parcelRegister("kWn5z", function(module, exports) {

$parcel$export(module.exports, "groupBy", function () { return $f3eb2263b8121425$export$3f063810d7bf01bd; });

var $l73V3 = parcelRequire("l73V3");
function $f3eb2263b8121425$export$3f063810d7bf01bd(collection, grouper) {
    var results = {};
    collection.forEach(function(item) {
        var _a;
        var key = undefined;
        if (typeof grouper === 'string') {
            var suggestedKey = item[grouper];
            key = typeof suggestedKey !== 'string' ? JSON.stringify(suggestedKey) : suggestedKey;
        } else if (grouper instanceof Function) key = grouper(item);
        if (key === undefined) return;
        results[key] = (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([], (_a = results[key]) !== null && _a !== void 0 ? _a : [], true), [
            item
        ], false);
    });
    return results;
}

});

parcelRegister("j63iU", function(module, exports) {

$parcel$export(module.exports, "createTaskGroup", function () { return $de7123f11280e937$export$82d36ba7472bceb7; });

var $f1kWU = parcelRequire("f1kWU");
var $de7123f11280e937$export$82d36ba7472bceb7 = function() {
    var taskCompletionPromise;
    var resolvePromise;
    var count = 0;
    return {
        done: function() {
            return taskCompletionPromise;
        },
        run: function(op) {
            var returnValue = op();
            if ((0, $f1kWU.isThenable)(returnValue)) {
                if (++count === 1) taskCompletionPromise = new Promise(function(res) {
                    return resolvePromise = res;
                });
                returnValue.finally(function() {
                    return --count === 0 && resolvePromise();
                });
            }
            return returnValue;
        }
    };
};

});
parcelRegister("f1kWU", function(module, exports) {

$parcel$export(module.exports, "isThenable", function () { return $aef7330f274e1b7f$export$f5b060c2914b97c8; });
/**
 *  Check if  thenable
 *  (instanceof Promise doesn't respect realms)
 */ var $aef7330f274e1b7f$export$f5b060c2914b97c8 = function(value) {
    return typeof value === 'object' && value !== null && 'then' in value && typeof value.then === 'function';
};

});


parcelRegister("8BSni", function(module, exports) {

$parcel$export(module.exports, "attempt", function () { return $644bf51b8ff79935$export$77f9e426014f6edd; });
$parcel$export(module.exports, "ensure", function () { return $644bf51b8ff79935$export$c291509e8e0abb43; });

var $l73V3 = parcelRequire("l73V3");

var $bPxZD = parcelRequire("bPxZD");
function $644bf51b8ff79935$var$tryAsync(fn) {
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var err_1;
        return (0, $l73V3.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        fn()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 2:
                    err_1 = _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.reject(err_1)
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $644bf51b8ff79935$export$77f9e426014f6edd(ctx, plugin) {
    ctx.log('debug', 'plugin', {
        plugin: plugin.name
    });
    var start = new Date().getTime();
    var hook = plugin[ctx.event.type];
    if (hook === undefined) return Promise.resolve(ctx);
    var newCtx = $644bf51b8ff79935$var$tryAsync(function() {
        return hook.apply(plugin, [
            ctx
        ]);
    }).then(function(ctx) {
        var done = new Date().getTime() - start;
        ctx.stats.gauge('plugin_time', done, [
            "plugin:".concat(plugin.name)
        ]);
        return ctx;
    }).catch(function(err) {
        if (err instanceof (0, $bPxZD.ContextCancelation) && err.type === 'middleware_cancellation') throw err;
        if (err instanceof (0, $bPxZD.ContextCancelation)) {
            ctx.log('warn', err.type, {
                plugin: plugin.name,
                error: err
            });
            return err;
        }
        ctx.log('error', 'plugin Error', {
            plugin: plugin.name,
            error: err
        });
        ctx.stats.increment('plugin_error', 1, [
            "plugin:".concat(plugin.name)
        ]);
        return err;
    });
    return newCtx;
}
function $644bf51b8ff79935$export$c291509e8e0abb43(ctx, plugin) {
    return $644bf51b8ff79935$export$77f9e426014f6edd(ctx, plugin).then(function(newContext) {
        if (newContext instanceof (0, $bPxZD.CoreContext)) return newContext;
        ctx.log('debug', 'Context canceled');
        ctx.stats.increment('context_canceled');
        ctx.cancel(newContext);
    });
}

});

parcelRegister("3bRR1", function(module, exports) {

$parcel$export(module.exports, "isOffline", function () { return $252c2c7e335b27ee$export$a81aa9769d155ec5; });

var $gog49 = parcelRequire("gog49");
function $252c2c7e335b27ee$export$53c2fd0173ad2b80() {
    if ((0, $gog49.isBrowser)()) return window.navigator.onLine;
    return true;
}
function $252c2c7e335b27ee$export$a81aa9769d155ec5() {
    return !$252c2c7e335b27ee$export$53c2fd0173ad2b80();
}

});
parcelRegister("gog49", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $beeb599acf987c38$export$4e09c449d6c407f7; });
function $beeb599acf987c38$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined';
}
function $beeb599acf987c38$export$6acf61af03e62db() {
    return !$beeb599acf987c38$export$4e09c449d6c407f7();
}

});




parcelRegister("6vhvp", function(module, exports) {
module.exports = $parcel$import("iIuAS").then(()=>parcelRequire('9pDGl'));

});

parcelRegister("5Z7Ne", function(module, exports) {

$parcel$export(module.exports, "applyDestinationMiddleware", function () { return $45b8b1ccbc21f2a0$export$2cddfecf382dd210; });
$parcel$export(module.exports, "sourceMiddlewarePlugin", function () { return $45b8b1ccbc21f2a0$export$d46ec0e1aa436948; });

var $l73V3 = parcelRequire("l73V3");

var $bPxZD = parcelRequire("bPxZD");

var $czukA = parcelRequire("czukA");
function $45b8b1ccbc21f2a0$export$2cddfecf382dd210(destination, evt, middleware) {
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        function applyMiddleware(event, fn) {
            return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
                var nextCalled, returnedEvent;
                var _a;
                return (0, $l73V3.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            nextCalled = false;
                            returnedEvent = null;
                            return [
                                4 /*yield*/ ,
                                fn({
                                    payload: (0, $czukA.toFacade)(event, {
                                        clone: true,
                                        traverse: false
                                    }),
                                    integration: destination,
                                    next: function(evt) {
                                        nextCalled = true;
                                        if (evt === null) returnedEvent = null;
                                        if (evt) returnedEvent = evt.obj;
                                    }
                                })
                            ];
                        case 1:
                            _b.sent();
                            if (!nextCalled && returnedEvent !== null) {
                                returnedEvent;
                                returnedEvent.integrations = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, event.integrations), (_a = {}, _a[destination] = false, _a));
                            }
                            return [
                                2 /*return*/ ,
                                returnedEvent
                            ];
                    }
                });
            });
        }
        var modifiedEvent, _i, middleware_1, md, result;
        return (0, $l73V3.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    modifiedEvent = (0, $czukA.toFacade)(evt, {
                        clone: true,
                        traverse: false
                    }).rawEvent();
                    _i = 0, middleware_1 = middleware;
                    _a.label = 1;
                case 1:
                    if (!(_i < middleware_1.length)) return [
                        3 /*break*/ ,
                        4
                    ];
                    md = middleware_1[_i];
                    return [
                        4 /*yield*/ ,
                        applyMiddleware(modifiedEvent, md)
                    ];
                case 2:
                    result = _a.sent();
                    if (result === null) return [
                        2 /*return*/ ,
                        null
                    ];
                    modifiedEvent = result;
                    _a.label = 3;
                case 3:
                    _i++;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        modifiedEvent
                    ];
            }
        });
    });
}
function $45b8b1ccbc21f2a0$export$d46ec0e1aa436948(fn, integrations) {
    function apply(ctx) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var nextCalled;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        nextCalled = false;
                        return [
                            4 /*yield*/ ,
                            fn({
                                payload: (0, $czukA.toFacade)(ctx.event, {
                                    clone: true,
                                    traverse: false
                                }),
                                integrations: integrations !== null && integrations !== void 0 ? integrations : {},
                                next: function(evt) {
                                    nextCalled = true;
                                    if (evt) ctx.event = evt.obj;
                                }
                            })
                        ];
                    case 1:
                        _a.sent();
                        if (!nextCalled) throw new (0, $bPxZD.ContextCancelation)({
                            retry: false,
                            type: 'middleware_cancellation',
                            reason: 'Middleware `next` function skipped'
                        });
                        return [
                            2 /*return*/ ,
                            ctx
                        ];
                }
            });
        });
    }
    return {
        name: "Source Middleware ".concat(fn.name),
        type: 'before',
        version: '0.1.0',
        isLoaded: function() {
            return true;
        },
        load: function(ctx) {
            return Promise.resolve(ctx);
        },
        track: apply,
        page: apply,
        identify: apply,
        alias: apply,
        group: apply
    };
}

});
parcelRegister("czukA", function(module, exports) {

$parcel$export(module.exports, "toFacade", function () { return $927048042550349e$export$386be345afd3756f; });

var $9oOko = parcelRequire("9oOko");
function $927048042550349e$export$386be345afd3756f(evt, options) {
    var fcd = new (0, $9oOko.Facade)(evt, options);
    if (evt.type === 'track') fcd = new (0, $9oOko.Track)(evt, options);
    if (evt.type === 'identify') fcd = new (0, $9oOko.Identify)(evt, options);
    if (evt.type === 'page') fcd = new (0, $9oOko.Page)(evt, options);
    if (evt.type === 'alias') fcd = new (0, $9oOko.Alias)(evt, options);
    if (evt.type === 'group') fcd = new (0, $9oOko.Group)(evt, options);
    if (evt.type === 'screen') fcd = new (0, $9oOko.Screen)(evt, options);
    Object.defineProperty(fcd, 'obj', {
        value: evt,
        writable: true
    });
    return fcd;
}

});
parcelRegister("9oOko", function(module, exports) {
"use strict";
var $6d7d65065549425b$var$__assign = module.exports && module.exports.__assign || function() {
    $6d7d65065549425b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d7d65065549425b$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Delete = module.exports.Screen = module.exports.Page = module.exports.Track = module.exports.Identify = module.exports.Group = module.exports.Alias = module.exports.Facade = void 0;

var $9LxGA = parcelRequire("9LxGA");
Object.defineProperty(module.exports, "Facade", {
    enumerable: true,
    get: function() {
        return $9LxGA.Facade;
    }
});

var $1HWHF = parcelRequire("1HWHF");
Object.defineProperty(module.exports, "Alias", {
    enumerable: true,
    get: function() {
        return $1HWHF.Alias;
    }
});

var $imXXI = parcelRequire("imXXI");
Object.defineProperty(module.exports, "Group", {
    enumerable: true,
    get: function() {
        return $imXXI.Group;
    }
});

var $5VZNI = parcelRequire("5VZNI");
Object.defineProperty(module.exports, "Identify", {
    enumerable: true,
    get: function() {
        return $5VZNI.Identify;
    }
});

var $jZqgJ = parcelRequire("jZqgJ");
Object.defineProperty(module.exports, "Track", {
    enumerable: true,
    get: function() {
        return $jZqgJ.Track;
    }
});

var $coatV = parcelRequire("coatV");
Object.defineProperty(module.exports, "Page", {
    enumerable: true,
    get: function() {
        return $coatV.Page;
    }
});

var $lFjWk = parcelRequire("lFjWk");
Object.defineProperty(module.exports, "Screen", {
    enumerable: true,
    get: function() {
        return $lFjWk.Screen;
    }
});

var $jtRVh = parcelRequire("jtRVh");
Object.defineProperty(module.exports, "Delete", {
    enumerable: true,
    get: function() {
        return $jtRVh.Delete;
    }
});
module.exports.default = $6d7d65065549425b$var$__assign($6d7d65065549425b$var$__assign({}, $9LxGA.Facade), {
    Alias: $1HWHF.Alias,
    Group: $imXXI.Group,
    Identify: $5VZNI.Identify,
    Track: $jZqgJ.Track,
    Page: $coatV.Page,
    Screen: $lFjWk.Screen,
    Delete: $jtRVh.Delete
});

});
parcelRegister("9LxGA", function(module, exports) {
"use strict";
var $71c2a22e20aec604$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Facade = void 0;

var $71c2a22e20aec604$var$address_1 = $71c2a22e20aec604$var$__importDefault((parcelRequire("fFyjw")));

var $76C5D = parcelRequire("76C5D");

var $71c2a22e20aec604$var$is_enabled_1 = $71c2a22e20aec604$var$__importDefault((parcelRequire("gzmrK")));

var $71c2a22e20aec604$var$new_date_1 = $71c2a22e20aec604$var$__importDefault((parcelRequire("gZtpK")));

var $71c2a22e20aec604$var$obj_case_1 = $71c2a22e20aec604$var$__importDefault((parcelRequire("4fFDP")));

var $71c2a22e20aec604$var$isodate_traverse_1 = $71c2a22e20aec604$var$__importDefault((parcelRequire("17s7K")));
function $71c2a22e20aec604$var$Facade(obj, opts) {
    opts = opts || {};
    this.raw = $76C5D.clone(obj);
    if (!("clone" in opts)) opts.clone = true;
    if (opts.clone) obj = $76C5D.clone(obj);
    if (!("traverse" in opts)) opts.traverse = true;
    if (!("timestamp" in obj)) obj.timestamp = new Date();
    else obj.timestamp = $71c2a22e20aec604$var$new_date_1.default(obj.timestamp);
    if (opts.traverse) $71c2a22e20aec604$var$isodate_traverse_1.default(obj);
    this.opts = opts;
    this.obj = obj;
}
module.exports.Facade = $71c2a22e20aec604$var$Facade;
var $71c2a22e20aec604$var$f = $71c2a22e20aec604$var$Facade.prototype;
$71c2a22e20aec604$var$f.proxy = function(field) {
    var fields = field.split(".");
    field = fields.shift();
    var obj = this[field] || this.obj[field];
    if (!obj) return obj;
    if (typeof obj === "function") obj = obj.call(this) || {};
    if (fields.length === 0) return this.opts.clone ? $71c2a22e20aec604$var$transform(obj) : obj;
    obj = $71c2a22e20aec604$var$obj_case_1.default(obj, fields.join("."));
    return this.opts.clone ? $71c2a22e20aec604$var$transform(obj) : obj;
};
$71c2a22e20aec604$var$f.field = function(field) {
    var obj = this.obj[field];
    return this.opts.clone ? $71c2a22e20aec604$var$transform(obj) : obj;
};
$71c2a22e20aec604$var$Facade.proxy = function(field) {
    return function() {
        return this.proxy(field);
    };
};
$71c2a22e20aec604$var$Facade.field = function(field) {
    return function() {
        return this.field(field);
    };
};
$71c2a22e20aec604$var$Facade.multi = function(path) {
    return function() {
        var multi = this.proxy(path + "s");
        if (Array.isArray(multi)) return multi;
        var one = this.proxy(path);
        if (one) one = [
            this.opts.clone ? $76C5D.clone(one) : one
        ];
        return one || [];
    };
};
$71c2a22e20aec604$var$Facade.one = function(path) {
    return function() {
        var one = this.proxy(path);
        if (one) return one;
        var multi = this.proxy(path + "s");
        if (Array.isArray(multi)) return multi[0];
    };
};
$71c2a22e20aec604$var$f.json = function() {
    var ret = this.opts.clone ? $76C5D.clone(this.obj) : this.obj;
    if (this.type) ret.type = this.type();
    return ret;
};
$71c2a22e20aec604$var$f.rawEvent = function() {
    return this.raw;
};
$71c2a22e20aec604$var$f.options = function(integration) {
    var obj = this.obj.options || this.obj.context || {};
    var options = this.opts.clone ? $76C5D.clone(obj) : obj;
    if (!integration) return options;
    if (!this.enabled(integration)) return;
    var integrations = this.integrations();
    var value = integrations[integration] || $71c2a22e20aec604$var$obj_case_1.default(integrations, integration);
    if (typeof value !== "object") value = $71c2a22e20aec604$var$obj_case_1.default(this.options(), integration);
    return typeof value === "object" ? value : {};
};
$71c2a22e20aec604$var$f.context = $71c2a22e20aec604$var$f.options;
$71c2a22e20aec604$var$f.enabled = function(integration) {
    var allEnabled = this.proxy("options.providers.all");
    if (typeof allEnabled !== "boolean") allEnabled = this.proxy("options.all");
    if (typeof allEnabled !== "boolean") allEnabled = this.proxy("integrations.all");
    if (typeof allEnabled !== "boolean") allEnabled = true;
    var enabled = allEnabled && $71c2a22e20aec604$var$is_enabled_1.default(integration);
    var options = this.integrations();
    if (options.providers && options.providers.hasOwnProperty(integration)) enabled = options.providers[integration];
    if (options.hasOwnProperty(integration)) {
        var settings = options[integration];
        if (typeof settings === "boolean") enabled = settings;
        else enabled = true;
    }
    return !!enabled;
};
$71c2a22e20aec604$var$f.integrations = function() {
    return this.obj.integrations || this.proxy("options.providers") || this.options();
};
$71c2a22e20aec604$var$f.active = function() {
    var active = this.proxy("options.active");
    if (active === null || active === undefined) active = true;
    return active;
};
$71c2a22e20aec604$var$f.anonymousId = function() {
    return this.field("anonymousId") || this.field("sessionId");
};
$71c2a22e20aec604$var$f.sessionId = $71c2a22e20aec604$var$f.anonymousId;
$71c2a22e20aec604$var$f.groupId = $71c2a22e20aec604$var$Facade.proxy("options.groupId");
$71c2a22e20aec604$var$f.traits = function(aliases) {
    var ret = this.proxy("options.traits") || {};
    var id = this.userId();
    aliases = aliases || {};
    if (id) ret.id = id;
    for(var alias in aliases)if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
        var value = this[alias] == null ? this.proxy("options.traits." + alias) : this[alias]();
        if (value == null) continue;
        ret[aliases[alias]] = value;
        delete ret[alias];
    }
    return ret;
};
$71c2a22e20aec604$var$f.library = function() {
    var library = this.proxy("options.library");
    if (!library) return {
        name: "unknown",
        version: null
    };
    if (typeof library === "string") return {
        name: library,
        version: null
    };
    return library;
};
$71c2a22e20aec604$var$f.device = function() {
    var device = this.proxy("context.device");
    if (typeof device !== "object" || device === null) device = {};
    var library = this.library().name;
    if (device.type) return device;
    if (library.indexOf("ios") > -1) device.type = "ios";
    if (library.indexOf("android") > -1) device.type = "android";
    return device;
};
$71c2a22e20aec604$var$f.userAgent = $71c2a22e20aec604$var$Facade.proxy("context.userAgent");
$71c2a22e20aec604$var$f.timezone = $71c2a22e20aec604$var$Facade.proxy("context.timezone");
$71c2a22e20aec604$var$f.timestamp = $71c2a22e20aec604$var$Facade.field("timestamp");
$71c2a22e20aec604$var$f.channel = $71c2a22e20aec604$var$Facade.field("channel");
$71c2a22e20aec604$var$f.ip = $71c2a22e20aec604$var$Facade.proxy("context.ip");
$71c2a22e20aec604$var$f.userId = $71c2a22e20aec604$var$Facade.field("userId");
$71c2a22e20aec604$var$address_1.default($71c2a22e20aec604$var$f);
function $71c2a22e20aec604$var$transform(obj) {
    return $76C5D.clone(obj);
}

});
parcelRegister("fFyjw", function(module, exports) {
"use strict";
var $b6854d5de67256b4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $b6854d5de67256b4$var$obj_case_1 = $b6854d5de67256b4$var$__importDefault((parcelRequire("4fFDP")));
function $b6854d5de67256b4$var$trait(a, b) {
    return function() {
        var traits = this.traits();
        var props = this.properties ? this.properties() : {};
        return $b6854d5de67256b4$var$obj_case_1.default(traits, "address." + a) || $b6854d5de67256b4$var$obj_case_1.default(traits, a) || (b ? $b6854d5de67256b4$var$obj_case_1.default(traits, "address." + b) : null) || (b ? $b6854d5de67256b4$var$obj_case_1.default(traits, b) : null) || $b6854d5de67256b4$var$obj_case_1.default(props, "address." + a) || $b6854d5de67256b4$var$obj_case_1.default(props, a) || (b ? $b6854d5de67256b4$var$obj_case_1.default(props, "address." + b) : null) || (b ? $b6854d5de67256b4$var$obj_case_1.default(props, b) : null);
    };
}
function $b6854d5de67256b4$var$default_1(proto) {
    proto.zip = $b6854d5de67256b4$var$trait("postalCode", "zip");
    proto.country = $b6854d5de67256b4$var$trait("country");
    proto.street = $b6854d5de67256b4$var$trait("street");
    proto.state = $b6854d5de67256b4$var$trait("state");
    proto.city = $b6854d5de67256b4$var$trait("city");
    proto.region = $b6854d5de67256b4$var$trait("region");
}
module.exports.default = $b6854d5de67256b4$var$default_1;

});
parcelRegister("4fFDP", function(module, exports) {
var $3188dd421dfd5e41$var$identity = function(_) {
    return _;
};
/**
 * Module exports, export
 */ module.exports = $3188dd421dfd5e41$var$multiple($3188dd421dfd5e41$var$find);
module.exports.find = module.exports;
/**
 * Export the replacement function, return the modified object
 */ module.exports.replace = function(obj, key, val, options) {
    $3188dd421dfd5e41$var$multiple($3188dd421dfd5e41$var$replace).call(this, obj, key, val, options);
    return obj;
};
/**
 * Export the delete function, return the modified object
 */ module.exports.del = function(obj, key, options) {
    $3188dd421dfd5e41$var$multiple($3188dd421dfd5e41$var$del).call(this, obj, key, null, options);
    return obj;
};
/**
 * Compose applying the function to a nested key
 */ function $3188dd421dfd5e41$var$multiple(fn) {
    return function(obj, path, val, options) {
        var normalize = options && $3188dd421dfd5e41$var$isFunction(options.normalizer) ? options.normalizer : $3188dd421dfd5e41$var$defaultNormalize;
        path = normalize(path);
        var key;
        var finished = false;
        while(!finished)loop();
        function loop() {
            for(key in obj){
                var normalizedKey = normalize(key);
                if (0 === path.indexOf(normalizedKey)) {
                    var temp = path.substr(normalizedKey.length);
                    if (temp.charAt(0) === '.' || temp.length === 0) {
                        path = temp.substr(1);
                        var child = obj[key];
                        // we're at the end and there is nothing.
                        if (null == child) {
                            finished = true;
                            return;
                        }
                        // we're at the end and there is something.
                        if (!path.length) {
                            finished = true;
                            return;
                        }
                        // step into child
                        obj = child;
                        // but we're done here
                        return;
                    }
                }
            }
            key = undefined;
            // if we found no matching properties
            // on the current object, there's no match.
            finished = true;
        }
        if (!key) return;
        if (null == obj) return obj;
        // the `obj` and `key` is one above the leaf object and key, so
        // start object: { a: { 'b.c': 10 } }
        // end object: { 'b.c': 10 }
        // end key: 'b.c'
        // this way, you can do `obj[key]` and get `10`.
        return fn(obj, key, val);
    };
}
/**
 * Find an object by its key
 *
 * find({ first_name : 'Calvin' }, 'firstName')
 */ function $3188dd421dfd5e41$var$find(obj, key) {
    if (obj.hasOwnProperty(key)) return obj[key];
}
/**
 * Delete a value for a given key
 *
 * del({ a : 'b', x : 'y' }, 'X' }) -> { a : 'b' }
 */ function $3188dd421dfd5e41$var$del(obj, key) {
    if (obj.hasOwnProperty(key)) delete obj[key];
    return obj;
}
/**
 * Replace an objects existing value with a new one
 *
 * replace({ a : 'b' }, 'a', 'c') -> { a : 'c' }
 */ function $3188dd421dfd5e41$var$replace(obj, key, val) {
    if (obj.hasOwnProperty(key)) obj[key] = val;
    return obj;
}
/**
 * Normalize a `dot.separated.path`.
 *
 * A.HELL(!*&#(!)O_WOR   LD.bar => ahelloworldbar
 *
 * @param {String} path
 * @return {String}
 */ function $3188dd421dfd5e41$var$defaultNormalize(path) {
    return path.replace(/[^a-zA-Z0-9\.]+/g, '').toLowerCase();
}
/**
 * Check if a value is a function.
 *
 * @param {*} val
 * @return {boolean} Returns `true` if `val` is a function, otherwise `false`.
 */ function $3188dd421dfd5e41$var$isFunction(val) {
    return typeof val === 'function';
}

});


parcelRegister("76C5D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = void 0;
function $52c6a3d20bd2b106$var$clone(properties) {
    if (typeof properties !== 'object') return properties;
    if (Object.prototype.toString.call(properties) === '[object Object]') {
        var temp = {};
        for(var key in properties)if (Object.prototype.hasOwnProperty.call(properties, key)) temp[key] = $52c6a3d20bd2b106$var$clone(properties[key]);
        return temp;
    } else if (Array.isArray(properties)) return properties.map($52c6a3d20bd2b106$var$clone);
    else return properties;
}
module.exports.clone = $52c6a3d20bd2b106$var$clone;

});

parcelRegister("gzmrK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c10153aad53b7c05$var$disabled = {
    Salesforce: true
};
function $c10153aad53b7c05$var$default_1(integration) {
    return !$c10153aad53b7c05$var$disabled[integration];
}
module.exports.default = $c10153aad53b7c05$var$default_1;

});

parcelRegister("gZtpK", function(module, exports) {
"use strict";

var $1SzXO = parcelRequire("1SzXO");

var $j1kEf = parcelRequire("j1kEf");

var $d26zL = parcelRequire("d26zL");
var $c5e928e4470e7df6$var$objProto = Object.prototype;
var $c5e928e4470e7df6$var$toStr = $c5e928e4470e7df6$var$objProto.toString;
function $c5e928e4470e7df6$var$isDate(value) {
    return $c5e928e4470e7df6$var$toStr.call(value) === "[object Date]";
}
function $c5e928e4470e7df6$var$isNumber(value) {
    return $c5e928e4470e7df6$var$toStr.call(value) === "[object Number]";
}
/**
 * Returns a new Javascript Date object, allowing a variety of extra input types
 * over the native Date constructor.
 *
 * @param {Date|string|number} val
 */ module.exports = function newDate(val) {
    if ($c5e928e4470e7df6$var$isDate(val)) return val;
    if ($c5e928e4470e7df6$var$isNumber(val)) return new Date($c5e928e4470e7df6$var$toMs(val));
    // date strings
    if ($1SzXO.is(val)) return $1SzXO.parse(val);
    if ($j1kEf.is(val)) return $j1kEf.parse(val);
    if ($d26zL.is(val)) return $d26zL.parse(val);
    // fallback to Date.parse
    return new Date(val);
};
/**
 * If the number passed val is seconds from the epoch, turn it into milliseconds.
 * Milliseconds would be greater than 31557600000 (December 31, 1970).
 *
 * @param {number} num
 */ function $c5e928e4470e7df6$var$toMs(num) {
    if (num < 31557600000) return num * 1000;
    return num;
}

});
parcelRegister("1SzXO", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $15e6bb36e95cf0dd$export$98e6a39c04603d36; }, function (v) { return $15e6bb36e95cf0dd$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $15e6bb36e95cf0dd$export$226b3eccf92c9ed9; }, function (v) { return $15e6bb36e95cf0dd$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $15e6bb36e95cf0dd$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $15e6bb36e95cf0dd$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $15e6bb36e95cf0dd$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$15e6bb36e95cf0dd$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $15e6bb36e95cf0dd$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$15e6bb36e95cf0dd$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $15e6bb36e95cf0dd$var$matcher.test(string);
};

});

parcelRegister("j1kEf", function(module, exports) {

$parcel$export(module.exports, "is", function () { return $dd8e209f9b29b770$export$226b3eccf92c9ed9; }, function (v) { return $dd8e209f9b29b770$export$226b3eccf92c9ed9 = v; });
$parcel$export(module.exports, "parse", function () { return $dd8e209f9b29b770$export$98e6a39c04603d36; }, function (v) { return $dd8e209f9b29b770$export$98e6a39c04603d36 = v; });
/**
 * Check whether a string is a millisecond date string.
 *
 * @param {string} string
 * @return {boolean}
 */ var $dd8e209f9b29b770$export$226b3eccf92c9ed9;
/**
 * Convert a millisecond string to a date.
 *
 * @param {string} millis
 * @return {Date}
 */ var $dd8e209f9b29b770$export$98e6a39c04603d36;
"use strict";
/**
 * Matcher.
 */ var $dd8e209f9b29b770$var$matcher = /\d{13}/;
$dd8e209f9b29b770$export$226b3eccf92c9ed9 = function(string) {
    return $dd8e209f9b29b770$var$matcher.test(string);
};
$dd8e209f9b29b770$export$98e6a39c04603d36 = function(millis) {
    millis = parseInt(millis, 10);
    return new Date(millis);
};

});

parcelRegister("d26zL", function(module, exports) {

$parcel$export(module.exports, "is", function () { return $97d0901a3c4127a7$export$226b3eccf92c9ed9; }, function (v) { return $97d0901a3c4127a7$export$226b3eccf92c9ed9 = v; });
$parcel$export(module.exports, "parse", function () { return $97d0901a3c4127a7$export$98e6a39c04603d36; }, function (v) { return $97d0901a3c4127a7$export$98e6a39c04603d36 = v; });
/**
 * Check whether a string is a second date string.
 *
 * @param {string} string
 * @return {Boolean}
 */ var $97d0901a3c4127a7$export$226b3eccf92c9ed9;
/**
 * Convert a second string to a date.
 *
 * @param {string} seconds
 * @return {Date}
 */ var $97d0901a3c4127a7$export$98e6a39c04603d36;
"use strict";
/**
 * Matcher.
 */ var $97d0901a3c4127a7$var$matcher = /\d{10}/;
$97d0901a3c4127a7$export$226b3eccf92c9ed9 = function(string) {
    return $97d0901a3c4127a7$var$matcher.test(string);
};
$97d0901a3c4127a7$export$98e6a39c04603d36 = function(seconds) {
    var millis = parseInt(seconds, 10) * 1000;
    return new Date(millis);
};

});


parcelRegister("17s7K", function(module, exports) {
'use strict';

var $1SzXO = parcelRequire("1SzXO");
/**
 * Expose `traverse`.
 */ module.exports = $0d0c42bd7bada81a$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $0d0c42bd7bada81a$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $0d0c42bd7bada81a$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $0d0c42bd7bada81a$var$traverseArray(input, strict);
    else if ($1SzXO.is(input, strict)) return $1SzXO.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $0d0c42bd7bada81a$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $0d0c42bd7bada81a$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $0d0c42bd7bada81a$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $0d0c42bd7bada81a$var$traverse(value, strict);
    });
    return arr;
}

});


parcelRegister("1HWHF", function(module, exports) {
"use strict";
var $13e757d730b695b5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Alias = void 0;

var $13e757d730b695b5$var$inherits_1 = $13e757d730b695b5$var$__importDefault((parcelRequire("eSHUL")));

var $9LxGA = parcelRequire("9LxGA");
function $13e757d730b695b5$var$Alias(dictionary, opts) {
    $9LxGA.Facade.call(this, dictionary, opts);
}
module.exports.Alias = $13e757d730b695b5$var$Alias;
$13e757d730b695b5$var$inherits_1.default($13e757d730b695b5$var$Alias, $9LxGA.Facade);
$13e757d730b695b5$var$Alias.prototype.action = function() {
    return "alias";
};
$13e757d730b695b5$var$Alias.prototype.type = $13e757d730b695b5$var$Alias.prototype.action;
$13e757d730b695b5$var$Alias.prototype.previousId = function() {
    return this.field("previousId") || this.field("from");
};
$13e757d730b695b5$var$Alias.prototype.from = $13e757d730b695b5$var$Alias.prototype.previousId;
$13e757d730b695b5$var$Alias.prototype.userId = function() {
    return this.field("userId") || this.field("to");
};
$13e757d730b695b5$var$Alias.prototype.to = $13e757d730b695b5$var$Alias.prototype.userId;

});
parcelRegister("eSHUL", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("imXXI", function(module, exports) {
"use strict";
var $d5f8cb48b0b5ad21$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Group = void 0;

var $d5f8cb48b0b5ad21$var$inherits_1 = $d5f8cb48b0b5ad21$var$__importDefault((parcelRequire("eSHUL")));

var $d5f8cb48b0b5ad21$var$is_email_1 = $d5f8cb48b0b5ad21$var$__importDefault((parcelRequire("7sZQq")));

var $d5f8cb48b0b5ad21$var$new_date_1 = $d5f8cb48b0b5ad21$var$__importDefault((parcelRequire("gZtpK")));

var $9LxGA = parcelRequire("9LxGA");
function $d5f8cb48b0b5ad21$var$Group(dictionary, opts) {
    $9LxGA.Facade.call(this, dictionary, opts);
}
module.exports.Group = $d5f8cb48b0b5ad21$var$Group;
$d5f8cb48b0b5ad21$var$inherits_1.default($d5f8cb48b0b5ad21$var$Group, $9LxGA.Facade);
var $d5f8cb48b0b5ad21$var$g = $d5f8cb48b0b5ad21$var$Group.prototype;
$d5f8cb48b0b5ad21$var$g.action = function() {
    return "group";
};
$d5f8cb48b0b5ad21$var$g.type = $d5f8cb48b0b5ad21$var$g.action;
$d5f8cb48b0b5ad21$var$g.groupId = $9LxGA.Facade.field("groupId");
$d5f8cb48b0b5ad21$var$g.created = function() {
    var created = this.proxy("traits.createdAt") || this.proxy("traits.created") || this.proxy("properties.createdAt") || this.proxy("properties.created");
    if (created) return $d5f8cb48b0b5ad21$var$new_date_1.default(created);
};
$d5f8cb48b0b5ad21$var$g.email = function() {
    var email = this.proxy("traits.email");
    if (email) return email;
    var groupId = this.groupId();
    if ($d5f8cb48b0b5ad21$var$is_email_1.default(groupId)) return groupId;
};
$d5f8cb48b0b5ad21$var$g.traits = function(aliases) {
    var ret = this.properties();
    var id = this.groupId();
    aliases = aliases || {};
    if (id) ret.id = id;
    for(var alias in aliases)if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
        var value = this[alias] == null ? this.proxy("traits." + alias) : this[alias]();
        if (value == null) continue;
        ret[aliases[alias]] = value;
        delete ret[alias];
    }
    return ret;
};
$d5f8cb48b0b5ad21$var$g.name = $9LxGA.Facade.proxy("traits.name");
$d5f8cb48b0b5ad21$var$g.industry = $9LxGA.Facade.proxy("traits.industry");
$d5f8cb48b0b5ad21$var$g.employees = $9LxGA.Facade.proxy("traits.employees");
$d5f8cb48b0b5ad21$var$g.properties = function() {
    return this.field("traits") || this.field("properties") || {};
};

});
parcelRegister("7sZQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $56fb1ef5a62b73f8$var$matcher = /.+\@.+\..+/;
function $56fb1ef5a62b73f8$var$isEmail(string) {
    return $56fb1ef5a62b73f8$var$matcher.test(string);
}
module.exports.default = $56fb1ef5a62b73f8$var$isEmail;

});


parcelRegister("5VZNI", function(module, exports) {
"use strict";
var $452236fa43c25f8a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Identify = void 0;

var $9LxGA = parcelRequire("9LxGA");

var $452236fa43c25f8a$var$obj_case_1 = $452236fa43c25f8a$var$__importDefault((parcelRequire("4fFDP")));

var $452236fa43c25f8a$var$inherits_1 = $452236fa43c25f8a$var$__importDefault((parcelRequire("eSHUL")));

var $452236fa43c25f8a$var$is_email_1 = $452236fa43c25f8a$var$__importDefault((parcelRequire("7sZQq")));

var $452236fa43c25f8a$var$new_date_1 = $452236fa43c25f8a$var$__importDefault((parcelRequire("gZtpK")));
var $452236fa43c25f8a$var$trim = function(str) {
    return str.trim();
};
function $452236fa43c25f8a$var$Identify(dictionary, opts) {
    $9LxGA.Facade.call(this, dictionary, opts);
}
module.exports.Identify = $452236fa43c25f8a$var$Identify;
$452236fa43c25f8a$var$inherits_1.default($452236fa43c25f8a$var$Identify, $9LxGA.Facade);
var $452236fa43c25f8a$var$i = $452236fa43c25f8a$var$Identify.prototype;
$452236fa43c25f8a$var$i.action = function() {
    return "identify";
};
$452236fa43c25f8a$var$i.type = $452236fa43c25f8a$var$i.action;
$452236fa43c25f8a$var$i.traits = function(aliases) {
    var ret = this.field("traits") || {};
    var id = this.userId();
    aliases = aliases || {};
    if (id) ret.id = id;
    for(var alias in aliases){
        var value = this[alias] == null ? this.proxy("traits." + alias) : this[alias]();
        if (value == null) continue;
        ret[aliases[alias]] = value;
        if (alias !== aliases[alias]) delete ret[alias];
    }
    return ret;
};
$452236fa43c25f8a$var$i.email = function() {
    var email = this.proxy("traits.email");
    if (email) return email;
    var userId = this.userId();
    if ($452236fa43c25f8a$var$is_email_1.default(userId)) return userId;
};
$452236fa43c25f8a$var$i.created = function() {
    var created = this.proxy("traits.created") || this.proxy("traits.createdAt");
    if (created) return $452236fa43c25f8a$var$new_date_1.default(created);
};
$452236fa43c25f8a$var$i.companyCreated = function() {
    var created = this.proxy("traits.company.created") || this.proxy("traits.company.createdAt");
    if (created) return $452236fa43c25f8a$var$new_date_1.default(created);
};
$452236fa43c25f8a$var$i.companyName = function() {
    return this.proxy("traits.company.name");
};
$452236fa43c25f8a$var$i.name = function() {
    var name = this.proxy("traits.name");
    if (typeof name === "string") return $452236fa43c25f8a$var$trim(name);
    var firstName = this.firstName();
    var lastName = this.lastName();
    if (firstName && lastName) return $452236fa43c25f8a$var$trim(firstName + " " + lastName);
};
$452236fa43c25f8a$var$i.firstName = function() {
    var firstName = this.proxy("traits.firstName");
    if (typeof firstName === "string") return $452236fa43c25f8a$var$trim(firstName);
    var name = this.proxy("traits.name");
    if (typeof name === "string") return $452236fa43c25f8a$var$trim(name).split(" ")[0];
};
$452236fa43c25f8a$var$i.lastName = function() {
    var lastName = this.proxy("traits.lastName");
    if (typeof lastName === "string") return $452236fa43c25f8a$var$trim(lastName);
    var name = this.proxy("traits.name");
    if (typeof name !== "string") return;
    var space = $452236fa43c25f8a$var$trim(name).indexOf(" ");
    if (space === -1) return;
    return $452236fa43c25f8a$var$trim(name.substr(space + 1));
};
$452236fa43c25f8a$var$i.uid = function() {
    return this.userId() || this.username() || this.email();
};
$452236fa43c25f8a$var$i.description = function() {
    return this.proxy("traits.description") || this.proxy("traits.background");
};
$452236fa43c25f8a$var$i.age = function() {
    var date = this.birthday();
    var age = $452236fa43c25f8a$var$obj_case_1.default(this.traits(), "age");
    if (age != null) return age;
    if (!(date instanceof Date)) return;
    var now = new Date();
    return now.getFullYear() - date.getFullYear();
};
$452236fa43c25f8a$var$i.avatar = function() {
    var traits = this.traits();
    return $452236fa43c25f8a$var$obj_case_1.default(traits, "avatar") || $452236fa43c25f8a$var$obj_case_1.default(traits, "photoUrl") || $452236fa43c25f8a$var$obj_case_1.default(traits, "avatarUrl");
};
$452236fa43c25f8a$var$i.position = function() {
    var traits = this.traits();
    return $452236fa43c25f8a$var$obj_case_1.default(traits, "position") || $452236fa43c25f8a$var$obj_case_1.default(traits, "jobTitle");
};
$452236fa43c25f8a$var$i.username = $9LxGA.Facade.proxy("traits.username");
$452236fa43c25f8a$var$i.website = $9LxGA.Facade.one("traits.website");
$452236fa43c25f8a$var$i.websites = $9LxGA.Facade.multi("traits.website");
$452236fa43c25f8a$var$i.phone = $9LxGA.Facade.one("traits.phone");
$452236fa43c25f8a$var$i.phones = $9LxGA.Facade.multi("traits.phone");
$452236fa43c25f8a$var$i.address = $9LxGA.Facade.proxy("traits.address");
$452236fa43c25f8a$var$i.gender = $9LxGA.Facade.proxy("traits.gender");
$452236fa43c25f8a$var$i.birthday = $9LxGA.Facade.proxy("traits.birthday");

});

parcelRegister("jZqgJ", function(module, exports) {
"use strict";
var $e8d81742503e215c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $e8d81742503e215c$var$inherits_1 = $e8d81742503e215c$var$__importDefault((parcelRequire("eSHUL")));

var $9LxGA = parcelRequire("9LxGA");

var $5VZNI = parcelRequire("5VZNI");

var $e8d81742503e215c$var$is_email_1 = $e8d81742503e215c$var$__importDefault((parcelRequire("7sZQq")));

var $e8d81742503e215c$var$obj_case_1 = $e8d81742503e215c$var$__importDefault((parcelRequire("4fFDP")));
function $e8d81742503e215c$var$Track(dictionary, opts) {
    $9LxGA.Facade.call(this, dictionary, opts);
}
module.exports.Track = $e8d81742503e215c$var$Track;
$e8d81742503e215c$var$inherits_1.default($e8d81742503e215c$var$Track, $9LxGA.Facade);
var $e8d81742503e215c$var$t = $e8d81742503e215c$var$Track.prototype;
$e8d81742503e215c$var$t.action = function() {
    return "track";
};
$e8d81742503e215c$var$t.type = $e8d81742503e215c$var$t.action;
$e8d81742503e215c$var$t.event = $9LxGA.Facade.field("event");
$e8d81742503e215c$var$t.value = $9LxGA.Facade.proxy("properties.value");
$e8d81742503e215c$var$t.category = $9LxGA.Facade.proxy("properties.category");
$e8d81742503e215c$var$t.id = $9LxGA.Facade.proxy("properties.id");
$e8d81742503e215c$var$t.productId = function() {
    return this.proxy("properties.product_id") || this.proxy("properties.productId");
};
$e8d81742503e215c$var$t.promotionId = function() {
    return this.proxy("properties.promotion_id") || this.proxy("properties.promotionId");
};
$e8d81742503e215c$var$t.cartId = function() {
    return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
};
$e8d81742503e215c$var$t.checkoutId = function() {
    return this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId");
};
$e8d81742503e215c$var$t.paymentId = function() {
    return this.proxy("properties.payment_id") || this.proxy("properties.paymentId");
};
$e8d81742503e215c$var$t.couponId = function() {
    return this.proxy("properties.coupon_id") || this.proxy("properties.couponId");
};
$e8d81742503e215c$var$t.wishlistId = function() {
    return this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId");
};
$e8d81742503e215c$var$t.reviewId = function() {
    return this.proxy("properties.review_id") || this.proxy("properties.reviewId");
};
$e8d81742503e215c$var$t.orderId = function() {
    return this.proxy("properties.id") || this.proxy("properties.order_id") || this.proxy("properties.orderId");
};
$e8d81742503e215c$var$t.sku = $9LxGA.Facade.proxy("properties.sku");
$e8d81742503e215c$var$t.tax = $9LxGA.Facade.proxy("properties.tax");
$e8d81742503e215c$var$t.name = $9LxGA.Facade.proxy("properties.name");
$e8d81742503e215c$var$t.price = $9LxGA.Facade.proxy("properties.price");
$e8d81742503e215c$var$t.total = $9LxGA.Facade.proxy("properties.total");
$e8d81742503e215c$var$t.repeat = $9LxGA.Facade.proxy("properties.repeat");
$e8d81742503e215c$var$t.coupon = $9LxGA.Facade.proxy("properties.coupon");
$e8d81742503e215c$var$t.shipping = $9LxGA.Facade.proxy("properties.shipping");
$e8d81742503e215c$var$t.discount = $9LxGA.Facade.proxy("properties.discount");
$e8d81742503e215c$var$t.shippingMethod = function() {
    return this.proxy("properties.shipping_method") || this.proxy("properties.shippingMethod");
};
$e8d81742503e215c$var$t.paymentMethod = function() {
    return this.proxy("properties.payment_method") || this.proxy("properties.paymentMethod");
};
$e8d81742503e215c$var$t.description = $9LxGA.Facade.proxy("properties.description");
$e8d81742503e215c$var$t.plan = $9LxGA.Facade.proxy("properties.plan");
$e8d81742503e215c$var$t.subtotal = function() {
    var subtotal = $e8d81742503e215c$var$obj_case_1.default(this.properties(), "subtotal");
    var total = this.total() || this.revenue();
    if (subtotal) return subtotal;
    if (!total) return 0;
    if (this.total()) {
        var n = this.tax();
        if (n) total -= n;
        n = this.shipping();
        if (n) total -= n;
        n = this.discount();
        if (n) total += n;
    }
    return total;
};
$e8d81742503e215c$var$t.products = function() {
    var props = this.properties();
    var products = $e8d81742503e215c$var$obj_case_1.default(props, "products");
    if (Array.isArray(products)) return products.filter(function(item) {
        return item !== null;
    });
    return [];
};
$e8d81742503e215c$var$t.quantity = function() {
    var props = this.obj.properties || {};
    return props.quantity || 1;
};
$e8d81742503e215c$var$t.currency = function() {
    var props = this.obj.properties || {};
    return props.currency || "USD";
};
$e8d81742503e215c$var$t.referrer = function() {
    return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
$e8d81742503e215c$var$t.query = $9LxGA.Facade.proxy("options.query");
$e8d81742503e215c$var$t.properties = function(aliases) {
    var ret = this.field("properties") || {};
    aliases = aliases || {};
    for(var alias in aliases)if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
        var value = this[alias] == null ? this.proxy("properties." + alias) : this[alias]();
        if (value == null) continue;
        ret[aliases[alias]] = value;
        delete ret[alias];
    }
    return ret;
};
$e8d81742503e215c$var$t.username = function() {
    return this.proxy("traits.username") || this.proxy("properties.username") || this.userId() || this.sessionId();
};
$e8d81742503e215c$var$t.email = function() {
    var email = this.proxy("traits.email") || this.proxy("properties.email") || this.proxy("options.traits.email");
    if (email) return email;
    var userId = this.userId();
    if ($e8d81742503e215c$var$is_email_1.default(userId)) return userId;
};
$e8d81742503e215c$var$t.revenue = function() {
    var revenue = this.proxy("properties.revenue");
    var event = this.event();
    var orderCompletedRegExp = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
    if (!revenue && event && event.match(orderCompletedRegExp)) revenue = this.proxy("properties.total");
    return $e8d81742503e215c$var$currency(revenue);
};
$e8d81742503e215c$var$t.cents = function() {
    var revenue = this.revenue();
    return typeof revenue !== "number" ? this.value() || 0 : revenue * 100;
};
$e8d81742503e215c$var$t.identify = function() {
    var json = this.json();
    json.traits = this.traits();
    return new $5VZNI.Identify(json, this.opts);
};
function $e8d81742503e215c$var$currency(val) {
    if (!val) return;
    if (typeof val === "number") return val;
    if (typeof val !== "string") return;
    val = val.replace(/\$/g, "");
    val = parseFloat(val);
    if (!isNaN(val)) return val;
}

});

parcelRegister("coatV", function(module, exports) {
"use strict";
var $904fdb5daf80db97$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Page = void 0;

var $904fdb5daf80db97$var$inherits_1 = $904fdb5daf80db97$var$__importDefault((parcelRequire("eSHUL")));

var $9LxGA = parcelRequire("9LxGA");

var $jZqgJ = parcelRequire("jZqgJ");

var $904fdb5daf80db97$var$is_email_1 = $904fdb5daf80db97$var$__importDefault((parcelRequire("7sZQq")));
function $904fdb5daf80db97$var$Page(dictionary, opts) {
    $9LxGA.Facade.call(this, dictionary, opts);
}
module.exports.Page = $904fdb5daf80db97$var$Page;
$904fdb5daf80db97$var$inherits_1.default($904fdb5daf80db97$var$Page, $9LxGA.Facade);
var $904fdb5daf80db97$var$p = $904fdb5daf80db97$var$Page.prototype;
$904fdb5daf80db97$var$p.action = function() {
    return "page";
};
$904fdb5daf80db97$var$p.type = $904fdb5daf80db97$var$p.action;
$904fdb5daf80db97$var$p.category = $9LxGA.Facade.field("category");
$904fdb5daf80db97$var$p.name = $9LxGA.Facade.field("name");
$904fdb5daf80db97$var$p.title = $9LxGA.Facade.proxy("properties.title");
$904fdb5daf80db97$var$p.path = $9LxGA.Facade.proxy("properties.path");
$904fdb5daf80db97$var$p.url = $9LxGA.Facade.proxy("properties.url");
$904fdb5daf80db97$var$p.referrer = function() {
    return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
$904fdb5daf80db97$var$p.properties = function(aliases) {
    var props = this.field("properties") || {};
    var category = this.category();
    var name = this.name();
    aliases = aliases || {};
    if (category) props.category = category;
    if (name) props.name = name;
    for(var alias in aliases)if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
        var value = this[alias] == null ? this.proxy("properties." + alias) : this[alias]();
        if (value == null) continue;
        props[aliases[alias]] = value;
        if (alias !== aliases[alias]) delete props[alias];
    }
    return props;
};
$904fdb5daf80db97$var$p.email = function() {
    var email = this.proxy("context.traits.email") || this.proxy("properties.email");
    if (email) return email;
    var userId = this.userId();
    if ($904fdb5daf80db97$var$is_email_1.default(userId)) return userId;
};
$904fdb5daf80db97$var$p.fullName = function() {
    var category = this.category();
    var name = this.name();
    return name && category ? category + " " + name : name;
};
$904fdb5daf80db97$var$p.event = function(name) {
    return name ? "Viewed " + name + " Page" : "Loaded a Page";
};
$904fdb5daf80db97$var$p.track = function(name) {
    var json = this.json();
    json.event = this.event(name);
    json.timestamp = this.timestamp();
    json.properties = this.properties();
    return new $jZqgJ.Track(json, this.opts);
};

});

parcelRegister("lFjWk", function(module, exports) {
"use strict";
var $fc5ce4f12d5672ae$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Screen = void 0;

var $fc5ce4f12d5672ae$var$inherits_1 = $fc5ce4f12d5672ae$var$__importDefault((parcelRequire("eSHUL")));

var $coatV = parcelRequire("coatV");

var $jZqgJ = parcelRequire("jZqgJ");
function $fc5ce4f12d5672ae$var$Screen(dictionary, opts) {
    $coatV.Page.call(this, dictionary, opts);
}
module.exports.Screen = $fc5ce4f12d5672ae$var$Screen;
$fc5ce4f12d5672ae$var$inherits_1.default($fc5ce4f12d5672ae$var$Screen, $coatV.Page);
$fc5ce4f12d5672ae$var$Screen.prototype.action = function() {
    return "screen";
};
$fc5ce4f12d5672ae$var$Screen.prototype.type = $fc5ce4f12d5672ae$var$Screen.prototype.action;
$fc5ce4f12d5672ae$var$Screen.prototype.event = function(name) {
    return name ? "Viewed " + name + " Screen" : "Loaded a Screen";
};
$fc5ce4f12d5672ae$var$Screen.prototype.track = function(name) {
    var json = this.json();
    json.event = this.event(name);
    json.timestamp = this.timestamp();
    json.properties = this.properties();
    return new $jZqgJ.Track(json, this.opts);
};

});

parcelRegister("jtRVh", function(module, exports) {
"use strict";
var $e2ea8db7ceba7fb4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Delete = void 0;

var $e2ea8db7ceba7fb4$var$inherits_1 = $e2ea8db7ceba7fb4$var$__importDefault((parcelRequire("eSHUL")));

var $9LxGA = parcelRequire("9LxGA");
function $e2ea8db7ceba7fb4$var$Delete(dictionary, opts) {
    $9LxGA.Facade.call(this, dictionary, opts);
}
module.exports.Delete = $e2ea8db7ceba7fb4$var$Delete;
$e2ea8db7ceba7fb4$var$inherits_1.default($e2ea8db7ceba7fb4$var$Delete, $9LxGA.Facade);
$e2ea8db7ceba7fb4$var$Delete.prototype.type = function() {
    return "delete";
};

});




parcelRegister("6YNh1", function(module, exports) {
module.exports = $parcel$import("dkehO").then(()=>parcelRequire('ih0kg'));

});


parcelRegister("4r2Y5", function(module, exports) {

$parcel$export(module.exports, "mergedOptions", function () { return $33abfc71e72b9229$export$7b2d153f93cbbd8d; });

var $l73V3 = parcelRequire("l73V3");
function $33abfc71e72b9229$export$7b2d153f93cbbd8d(settings, options) {
    var _a;
    var optionOverrides = Object.entries((_a = options.integrations) !== null && _a !== void 0 ? _a : {}).reduce(function(overrides, _a) {
        var _b, _c;
        var integration = _a[0], options = _a[1];
        if (typeof options === 'object') return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, overrides), (_b = {}, _b[integration] = options, _b));
        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, overrides), (_c = {}, _c[integration] = {}, _c));
    }, {});
    return Object.entries(settings.integrations).reduce(function(integrationSettings, _a) {
        var _b;
        var integration = _a[0], settings = _a[1];
        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, integrationSettings), (_b = {}, _b[integration] = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, settings), optionOverrides[integration]), _b));
    }, {});
}

});

parcelRegister("2maFQ", function(module, exports) {

$parcel$export(module.exports, "createDeferred", function () { return $1b75ea751e9e1849$export$e673efccd97e4223; });
/**
 * Return a promise that can be externally resolved
 */ var $1b75ea751e9e1849$export$e673efccd97e4223 = function() {
    var resolve;
    var reject;
    var promise = new Promise(function(_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
};

});

parcelRegister("31dco", function(module, exports) {

$parcel$export(module.exports, "pageEnrichment", function () { return $232bb423b5d0d731$export$4d10c7b10b721b5f; });
/**
 * Get the current page's canonical URL.
 *
 * @return {string|undefined}
 */ function $232bb423b5d0d731$var$canonical() {
    var tags = document.getElementsByTagName('link');
    var canon = '';
    Array.prototype.slice.call(tags).forEach(function(tag) {
        if (tag.getAttribute('rel') === 'canonical') canon = tag.getAttribute('href');
    });
    return canon;
}
/**
 * Return the canonical path for the page.
 */ function $232bb423b5d0d731$var$canonicalPath() {
    var canon = $232bb423b5d0d731$var$canonical();
    if (!canon) return window.location.pathname;
    var a = document.createElement('a');
    a.href = canon;
    var pathname = !a.pathname.startsWith('/') ? '/' + a.pathname : a.pathname;
    return pathname;
}
function $232bb423b5d0d731$export$4a68843152603124(search) {
    if (search === void 0) search = '';
    var canon = $232bb423b5d0d731$var$canonical();
    if (canon) return canon.includes('?') ? canon : "".concat(canon).concat(search);
    var url = window.location.href;
    var i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
}
function $232bb423b5d0d731$export$b255f37afd2ff5f6() {
    return {
        path: $232bb423b5d0d731$var$canonicalPath(),
        referrer: document.referrer,
        search: location.search,
        title: document.title,
        url: $232bb423b5d0d731$export$4a68843152603124(location.search)
    };
}
function $232bb423b5d0d731$var$enrichPageContext(ctx) {
    var _a;
    var event = ctx.event;
    event.context = event.context || {};
    var pageContext = $232bb423b5d0d731$export$b255f37afd2ff5f6();
    var pageProps = (_a = event.properties) !== null && _a !== void 0 ? _a : {};
    Object.keys(pageContext).forEach(function(key) {
        if (pageProps[key]) pageContext[key] = pageProps[key];
    });
    if (event.context.page) pageContext = Object.assign({}, pageContext, event.context.page);
    event.context = Object.assign({}, event.context, {
        page: pageContext
    });
    ctx.event = event;
    return ctx;
}
var $232bb423b5d0d731$export$4d10c7b10b721b5f = {
    name: 'Page Enrichment',
    version: '0.1.0',
    isLoaded: function() {
        return true;
    },
    load: function() {
        return Promise.resolve();
    },
    type: 'before',
    page: function(ctx) {
        ctx.event.properties = Object.assign({}, $232bb423b5d0d731$export$b255f37afd2ff5f6(), ctx.event.properties);
        if (ctx.event.name) ctx.event.properties.name = ctx.event.name;
        return $232bb423b5d0d731$var$enrichPageContext(ctx);
    },
    alias: $232bb423b5d0d731$var$enrichPageContext,
    track: $232bb423b5d0d731$var$enrichPageContext,
    identify: $232bb423b5d0d731$var$enrichPageContext,
    group: $232bb423b5d0d731$var$enrichPageContext
};

});

parcelRegister("dHQJ4", function(module, exports) {

$parcel$export(module.exports, "remoteLoader", function () { return $9fa830c4d1611e2a$export$a694cc8f9917442a; });

var $l73V3 = parcelRequire("l73V3");

var $91159 = parcelRequire("91159");

var $9yWXi = parcelRequire("9yWXi");

var $5Z7Ne = parcelRequire("5Z7Ne");

var $jVL2A = parcelRequire("jVL2A");
var $bPxZD = parcelRequire("bPxZD");
var $9fa830c4d1611e2a$export$ce16b611207a75d = /** @class */ function() {
    function ActionDestination(name, action) {
        this.version = '1.0.0';
        this.alternativeNames = [];
        this.middleware = [];
        this.alias = this._createMethod('alias');
        this.group = this._createMethod('group');
        this.identify = this._createMethod('identify');
        this.page = this._createMethod('page');
        this.screen = this._createMethod('screen');
        this.track = this._createMethod('track');
        this.action = action;
        this.name = name;
        this.type = action.type;
        this.alternativeNames.push(action.name);
    }
    ActionDestination.prototype.addMiddleware = function() {
        var _a;
        var fn = [];
        for(var _i = 0; _i < arguments.length; _i++)fn[_i] = arguments[_i];
        if (this.type === 'destination') (_a = this.middleware).push.apply(_a, fn);
    };
    ActionDestination.prototype.transform = function(ctx) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var modifiedEvent;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $5Z7Ne.applyDestinationMiddleware)(this.name, ctx.event, this.middleware)
                        ];
                    case 1:
                        modifiedEvent = _a.sent();
                        if (modifiedEvent === null) ctx.cancel(new (0, $bPxZD.ContextCancelation)({
                            retry: false,
                            reason: 'dropped by destination middleware'
                        }));
                        return [
                            2 /*return*/ ,
                            new (0, $jVL2A.Context)(modifiedEvent)
                        ];
                }
            });
        });
    };
    ActionDestination.prototype._createMethod = function(methodName) {
        var _this = this;
        return function(ctx) {
            return (0, $l73V3.__awaiter)(_this, void 0, void 0, function() {
                var transformedContext;
                return (0, $l73V3.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!this.action[methodName]) return [
                                2 /*return*/ ,
                                ctx
                            ];
                            transformedContext = ctx;
                            if (!(this.type === 'destination')) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.transform(ctx)
                            ];
                        case 1:
                            transformedContext = _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                this.action[methodName](transformedContext)
                            ];
                        case 3:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                ctx
                            ];
                    }
                });
            });
        };
    };
    /* --- PASSTHROUGH METHODS --- */ ActionDestination.prototype.isLoaded = function() {
        return this.action.isLoaded();
    };
    ActionDestination.prototype.ready = function() {
        return this.action.ready ? this.action.ready() : Promise.resolve();
    };
    ActionDestination.prototype.load = function(ctx, analytics) {
        return this.action.load(ctx, analytics);
    };
    ActionDestination.prototype.unload = function(ctx, analytics) {
        var _a, _b;
        return (_b = (_a = this.action).unload) === null || _b === void 0 ? void 0 : _b.call(_a, ctx, analytics);
    };
    return ActionDestination;
}();
function $9fa830c4d1611e2a$var$validate(pluginLike) {
    if (!Array.isArray(pluginLike)) throw new Error('Not a valid list of plugins');
    var required = [
        'load',
        'isLoaded',
        'name',
        'version',
        'type'
    ];
    pluginLike.forEach(function(plugin) {
        required.forEach(function(method) {
            var _a;
            if (plugin[method] === undefined) throw new Error("Plugin: ".concat((_a = plugin.name) !== null && _a !== void 0 ? _a : 'unknown', " missing required function ").concat(method));
        });
    });
    return true;
}
function $9fa830c4d1611e2a$var$isPluginDisabled(userIntegrations, remotePlugin) {
    var creationNameEnabled = userIntegrations[remotePlugin.creationName];
    var currentNameEnabled = userIntegrations[remotePlugin.name];
    // Check that the plugin isn't explicitly enabled when All: false
    if (userIntegrations.All === false && !creationNameEnabled && !currentNameEnabled) return true;
    // Check that the plugin isn't explicitly disabled
    if (creationNameEnabled === false || currentNameEnabled === false) return true;
    return false;
}
function $9fa830c4d1611e2a$export$a694cc8f9917442a(settings, userIntegrations, mergedIntegrations, obfuscate, routingMiddleware) {
    var _a, _b, _c;
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var allPlugins, cdn, routingRules, pluginPromises;
        var _this = this;
        return (0, $l73V3.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    allPlugins = [];
                    cdn = (0, $9yWXi.getCDN)();
                    routingRules = (_b = (_a = settings.middlewareSettings) === null || _a === void 0 ? void 0 : _a.routingRules) !== null && _b !== void 0 ? _b : [];
                    pluginPromises = ((_c = settings.remotePlugins) !== null && _c !== void 0 ? _c : []).map(function(remotePlugin) {
                        return (0, $l73V3.__awaiter)(_this, void 0, void 0, function() {
                            var defaultCdn, urlSplit, name_1, obfuscatedURL, error_1, libraryName, pluginFactory, plugin, plugins, routing_1, error_2;
                            return (0, $l73V3.__generator)(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ($9fa830c4d1611e2a$var$isPluginDisabled(userIntegrations, remotePlugin)) return [
                                            2 /*return*/ 
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            12,
                                            ,
                                            13
                                        ]);
                                        defaultCdn = new RegExp('https://cdp.customer.io');
                                        if (!obfuscate) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        urlSplit = remotePlugin.url.split('/');
                                        name_1 = urlSplit[urlSplit.length - 2];
                                        obfuscatedURL = remotePlugin.url.replace(name_1, btoa(name_1).replace(/=/g, ''));
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([
                                            2,
                                            4,
                                            ,
                                            6
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            (0, $91159.loadScript)(obfuscatedURL.replace(defaultCdn, cdn))
                                        ];
                                    case 3:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            6
                                        ];
                                    case 4:
                                        error_1 = _a.sent();
                                        // Due to syncing concerns it is possible that the obfuscated action destination (or requested version) might not exist.
                                        // We should use the unobfuscated version as a fallback.
                                        return [
                                            4 /*yield*/ ,
                                            (0, $91159.loadScript)(remotePlugin.url.replace(defaultCdn, cdn))
                                        ];
                                    case 5:
                                        // Due to syncing concerns it is possible that the obfuscated action destination (or requested version) might not exist.
                                        // We should use the unobfuscated version as a fallback.
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            6
                                        ];
                                    case 6:
                                        return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                    case 7:
                                        return [
                                            4 /*yield*/ ,
                                            (0, $91159.loadScript)(remotePlugin.url.replace(defaultCdn, cdn))
                                        ];
                                    case 8:
                                        _a.sent();
                                        _a.label = 9;
                                    case 9:
                                        libraryName = remotePlugin.libraryName;
                                        if (!(typeof window[libraryName] === 'function')) return [
                                            3 /*break*/ ,
                                            11
                                        ];
                                        pluginFactory = window[libraryName];
                                        return [
                                            4 /*yield*/ ,
                                            pluginFactory((0, $l73V3.__assign)((0, $l73V3.__assign)({}, remotePlugin.settings), mergedIntegrations[remotePlugin.name]))
                                        ];
                                    case 10:
                                        plugin = _a.sent();
                                        plugins = Array.isArray(plugin) ? plugin : [
                                            plugin
                                        ];
                                        $9fa830c4d1611e2a$var$validate(plugins);
                                        routing_1 = routingRules.filter(function(rule) {
                                            return rule.destinationName === remotePlugin.creationName;
                                        });
                                        plugins.forEach(function(plugin) {
                                            var wrapper = new $9fa830c4d1611e2a$export$ce16b611207a75d(remotePlugin.creationName, plugin);
                                            /** Make sure we only apply destination filters to actions of the "destination" type to avoid causing issues for hybrid destinations */ if (routing_1.length && routingMiddleware && plugin.type === 'destination') wrapper.addMiddleware(routingMiddleware);
                                            allPlugins.push(wrapper);
                                        });
                                        _a.label = 11;
                                    case 11:
                                        return [
                                            3 /*break*/ ,
                                            13
                                        ];
                                    case 12:
                                        error_2 = _a.sent();
                                        console.warn('Failed to load Remote Plugin', error_2);
                                        return [
                                            3 /*break*/ ,
                                            13
                                        ];
                                    case 13:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    });
                    return [
                        4 /*yield*/ ,
                        Promise.all(pluginPromises)
                    ];
                case 1:
                    _d.sent();
                    return [
                        2 /*return*/ ,
                        allPlugins.filter(Boolean)
                    ];
            }
        });
    });
}

});
parcelRegister("91159", function(module, exports) {

$parcel$export(module.exports, "loadScript", function () { return $69050be9052a63cf$export$2cb99e4be0dc4646; });
$parcel$export(module.exports, "unloadScript", function () { return $69050be9052a63cf$export$68e288e0bafc273c; });
function $69050be9052a63cf$var$findScript(src) {
    var scripts = Array.prototype.slice.call(window.document.querySelectorAll('script'));
    return scripts.find(function(s) {
        return s.src === src;
    });
}
function $69050be9052a63cf$export$2cb99e4be0dc4646(src, attributes) {
    var found = $69050be9052a63cf$var$findScript(src);
    if (found !== undefined) {
        var status_1 = found === null || found === void 0 ? void 0 : found.getAttribute('status');
        if (status_1 === 'loaded') return Promise.resolve(found);
        if (status_1 === 'loading') return new Promise(function(resolve, reject) {
            found.addEventListener('load', function() {
                return resolve(found);
            });
            found.addEventListener('error', function(err) {
                return reject(err);
            });
        });
    }
    return new Promise(function(resolve, reject) {
        var _a;
        var script = window.document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = true;
        script.setAttribute('status', 'loading');
        for(var _i = 0, _b = Object.entries(attributes !== null && attributes !== void 0 ? attributes : {}); _i < _b.length; _i++){
            var _c = _b[_i], k = _c[0], v = _c[1];
            script.setAttribute(k, v);
        }
        script.onload = function() {
            script.onerror = script.onload = null;
            script.setAttribute('status', 'loaded');
            resolve(script);
        };
        script.onerror = function() {
            script.onerror = script.onload = null;
            script.setAttribute('status', 'error');
            reject(new Error("Failed to load ".concat(src)));
        };
        var tag = window.document.getElementsByTagName('script')[0];
        (_a = tag.parentElement) === null || _a === void 0 || _a.insertBefore(script, tag);
    });
}
function $69050be9052a63cf$export$68e288e0bafc273c(src) {
    var found = $69050be9052a63cf$var$findScript(src);
    if (found !== undefined) found.remove();
    return Promise.resolve();
}

});


parcelRegister("6N780", function(module, exports) {

$parcel$export(module.exports, "customerio", function () { return $4f1cd929b29222cf$export$b8c6f37bbdb87899; });

var $l73V3 = parcelRequire("l73V3");

var $hs2LY = parcelRequire("hs2LY");

var $2H1l5 = parcelRequire("2H1l5");

var $3r7RW = parcelRequire("3r7RW");

var $czukA = parcelRequire("czukA");

var $3Q5Dg = parcelRequire("3Q5Dg");

var $kqbUC = parcelRequire("kqbUC");

var $eqNzp = parcelRequire("eqNzp");

var $By7es = parcelRequire("By7es");
function $4f1cd929b29222cf$var$onAlias(analytics, json) {
    var _a, _b, _c, _d;
    var user = analytics.user();
    json.previousId = (_c = (_b = (_a = json.previousId) !== null && _a !== void 0 ? _a : json.from) !== null && _b !== void 0 ? _b : user.id()) !== null && _c !== void 0 ? _c : user.anonymousId();
    json.userId = (_d = json.userId) !== null && _d !== void 0 ? _d : json.to;
    delete json.from;
    delete json.to;
    return json;
}
function $4f1cd929b29222cf$export$b8c6f37bbdb87899(analytics, settings, integrations) {
    var _a, _b;
    // Attach `pagehide` before buffer is created so that inflight events are added
    // to the buffer before the buffer persists events in its own `pagehide` handler.
    window.addEventListener('pagehide', function() {
        buffer.push.apply(buffer, Array.from(inflightEvents));
        inflightEvents.clear();
    });
    var buffer = analytics.options.disableClientPersistence ? new (0, $2H1l5.PriorityQueue)(analytics.queue.queue.maxAttempts, []) : new (0, $3r7RW.PersistedPriorityQueue)(analytics.queue.queue.maxAttempts, "dest-Customer.io-Data-Pipelines");
    var inflightEvents = new Set();
    var flushing = false;
    var apiHost = (_a = settings === null || settings === void 0 ? void 0 : settings.apiHost) !== null && _a !== void 0 ? _a : 'cdp.customer.io/v1';
    var protocol = (_b = settings === null || settings === void 0 ? void 0 : settings.protocol) !== null && _b !== void 0 ? _b : 'https';
    var remote = "".concat(protocol, "://").concat(apiHost);
    var deliveryStrategy = settings === null || settings === void 0 ? void 0 : settings.deliveryStrategy;
    var client = (deliveryStrategy === null || deliveryStrategy === void 0 ? void 0 : deliveryStrategy.strategy) === 'batching' ? (0, $3Q5Dg.default)(remote, deliveryStrategy.config) : (0, $kqbUC.default)(deliveryStrategy === null || deliveryStrategy === void 0 ? void 0 : deliveryStrategy.config);
    function send(ctx) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var path, json;
            return (0, $l73V3.__generator)(this, function(_a) {
                if ((0, $hs2LY.isOffline)()) {
                    buffer.push(ctx);
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    (0, $By7es.scheduleFlush)(flushing, buffer, customerio, (0, $By7es.scheduleFlush));
                    return [
                        2 /*return*/ ,
                        ctx
                    ];
                }
                inflightEvents.add(ctx);
                path = ctx.event.type.charAt(0);
                json = (0, $czukA.toFacade)(ctx.event).json();
                if (ctx.event.type === 'track') delete json.traits;
                if (ctx.event.type === 'alias') json = $4f1cd929b29222cf$var$onAlias(analytics, json);
                return [
                    2 /*return*/ ,
                    client.dispatch("".concat(remote, "/").concat(path), (0, $eqNzp.normalize)(analytics, json, settings, integrations)).then(function() {
                        return ctx;
                    }).catch(function() {
                        buffer.pushWithBackoff(ctx);
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        (0, $By7es.scheduleFlush)(flushing, buffer, customerio, (0, $By7es.scheduleFlush));
                        return ctx;
                    }).finally(function() {
                        inflightEvents.delete(ctx);
                    })
                ];
            });
        });
    }
    var customerio = {
        name: 'Customer.io Data Pipelines',
        type: 'after',
        version: '0.1.0',
        isLoaded: function() {
            return true;
        },
        load: function() {
            return Promise.resolve();
        },
        track: send,
        identify: send,
        page: send,
        alias: send,
        group: send,
        screen: send
    };
    // Buffer may already have items if they were previously stored in localStorage.
    // Start flushing them immediately.
    if (buffer.todo) (0, $By7es.scheduleFlush)(flushing, buffer, customerio, (0, $By7es.scheduleFlush));
    return customerio;
}

});
parcelRegister("3Q5Dg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cba98de003cac18$export$2e2bcd8739ae039; });

var $l73V3 = parcelRequire("l73V3");

var $llDp8 = parcelRequire("llDp8");

var $8ascV = parcelRequire("8ascV");
var $2cba98de003cac18$var$MAX_PAYLOAD_SIZE = 500;
function $2cba98de003cac18$var$kilobytes(buffer) {
    var size = encodeURI(JSON.stringify(buffer)).split(/%..|./).length - 1;
    return size / 1024;
}
/**
 * Checks if the payload is over or close to
 * the maximum payload size allowed by tracking
 * API.
 */ function $2cba98de003cac18$var$approachingTrackingAPILimit(buffer) {
    return $2cba98de003cac18$var$kilobytes(buffer) >= $2cba98de003cac18$var$MAX_PAYLOAD_SIZE - 50;
}
function $2cba98de003cac18$var$chunks(batch) {
    var result = [];
    var index = 0;
    batch.forEach(function(item) {
        var size = $2cba98de003cac18$var$kilobytes(result[index]);
        if (size >= 64) index++;
        if (result[index]) result[index].push(item);
        else result[index] = [
            item
        ];
    });
    return result;
}
function $2cba98de003cac18$export$2e2bcd8739ae039(remote, config) {
    var _a, _b;
    var buffer = [];
    var pageUnloaded = false;
    var limit = (_a = config === null || config === void 0 ? void 0 : config.size) !== null && _a !== void 0 ? _a : 10;
    var timeout = (_b = config === null || config === void 0 ? void 0 : config.timeout) !== null && _b !== void 0 ? _b : 5000;
    function sendBatch(batch) {
        var _a;
        if (batch.length === 0) return;
        var writeKey = (_a = batch[0]) === null || _a === void 0 ? void 0 : _a.writeKey;
        return (0, $llDp8.fetch)("".concat(remote, "/b"), {
            keepalive: pageUnloaded,
            headers: {
                'Content-Type': 'text/plain'
            },
            method: 'post',
            body: JSON.stringify({
                batch: batch,
                writeKey: writeKey
            })
        });
    }
    function flush() {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var batch_1;
            return (0, $l73V3.__generator)(this, function(_a) {
                if (buffer.length) {
                    batch_1 = buffer;
                    buffer = [];
                    return [
                        2 /*return*/ ,
                        sendBatch(batch_1)
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    }
    var schedule;
    function scheduleFlush() {
        if (schedule) return;
        schedule = setTimeout(function() {
            schedule = undefined;
            flush().catch(console.error);
        }, timeout);
    }
    (0, $8ascV.onPageLeave)(function() {
        pageUnloaded = true;
        if (buffer.length) {
            var reqs = $2cba98de003cac18$var$chunks(buffer).map(sendBatch);
            Promise.all(reqs).catch(console.error);
        }
    });
    function dispatch(_url, body) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var bufferOverflow;
            return (0, $l73V3.__generator)(this, function(_a) {
                buffer.push(body);
                bufferOverflow = buffer.length >= limit || $2cba98de003cac18$var$approachingTrackingAPILimit(buffer);
                return [
                    2 /*return*/ ,
                    bufferOverflow || pageUnloaded ? flush() : scheduleFlush()
                ];
            });
        });
    }
    return {
        dispatch: dispatch
    };
}

});
parcelRegister("8ascV", function(module, exports) {

$parcel$export(module.exports, "onPageLeave", function () { return $5f25234df3c443b3$export$95162f8dd35b9ceb; });
/**
 * Register event listener on document that fires when:
 * * tab change or tab close (in mobile or desktop)
 * * click back / forward button
 * * click any link or perform any other navigation action
 * * soft refresh / hard refresh
 *
 * adapted from https://stackoverflow.com/questions/3239834/window-onbeforeunload-not-working-on-the-ipad/52864508#52864508,
 */ var $5f25234df3c443b3$export$95162f8dd35b9ceb = function(cb) {
    var unloaded = false; // prevents double firing if both are supported
    window.addEventListener('pagehide', function() {
        if (unloaded) return;
        unloaded = true;
        cb();
    });
    // using document instead of window because of bug affecting browsers before safari 14 (detail in footnotes https://caniuse.com/?search=visibilitychange)
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState == 'hidden') {
            if (unloaded) return;
            unloaded = true;
            cb();
        } else unloaded = false;
    });
};

});


parcelRegister("kqbUC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eddf79e2932275a6$export$2e2bcd8739ae039; });

var $llDp8 = parcelRequire("llDp8");
function $eddf79e2932275a6$export$2e2bcd8739ae039(config) {
    function dispatch(url, body) {
        return (0, $llDp8.fetch)(url, {
            keepalive: config === null || config === void 0 ? void 0 : config.keepalive,
            headers: {
                'Content-Type': 'text/plain'
            },
            method: 'post',
            body: JSON.stringify(body)
        });
    }
    return {
        dispatch: dispatch
    };
}

});

parcelRegister("By7es", function(module, exports) {

$parcel$export(module.exports, "scheduleFlush", function () { return $070deb7914120fd5$export$cbcfa9bdb2fa49c6; });

var $l73V3 = parcelRequire("l73V3");

var $hs2LY = parcelRequire("hs2LY");

var $jVL2A = parcelRequire("jVL2A");

var $8BSni = parcelRequire("8BSni");

var $2PG5D = parcelRequire("2PG5D");
function $070deb7914120fd5$var$flushQueue(xt, queue) {
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var failedQueue;
        var _this = this;
        return (0, $l73V3.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    failedQueue = [];
                    if ((0, $hs2LY.isOffline)()) return [
                        2 /*return*/ ,
                        queue
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $2PG5D.pWhile)(function() {
                            return queue.length > 0 && !(0, $hs2LY.isOffline)();
                        }, function() {
                            return (0, $l73V3.__awaiter)(_this, void 0, void 0, function() {
                                var ctx, result, success;
                                return (0, $l73V3.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            ctx = queue.pop();
                                            if (!ctx) return [
                                                2 /*return*/ 
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, $8BSni.attempt)(ctx, xt)
                                            ];
                                        case 1:
                                            result = _a.sent();
                                            success = result instanceof (0, $jVL2A.Context);
                                            if (!success) failedQueue.push(ctx);
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 1:
                    _a.sent();
                    // re-add failed tasks
                    failedQueue.map(function(failed) {
                        return queue.pushWithBackoff(failed);
                    });
                    return [
                        2 /*return*/ ,
                        queue
                    ];
            }
        });
    });
}
function $070deb7914120fd5$export$cbcfa9bdb2fa49c6(flushing, buffer, xt, scheduleFlush) {
    var _this = this;
    if (flushing) return;
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    setTimeout(function() {
        return (0, $l73V3.__awaiter)(_this, void 0, void 0, function() {
            var isFlushing, newBuffer;
            return (0, $l73V3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        isFlushing = true;
                        return [
                            4 /*yield*/ ,
                            $070deb7914120fd5$var$flushQueue(xt, buffer)
                        ];
                    case 1:
                        newBuffer = _a.sent();
                        isFlushing = false;
                        if (buffer.todo > 0) scheduleFlush(isFlushing, newBuffer, xt, scheduleFlush);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, Math.random() * 5000);
}

});
parcelRegister("2PG5D", function(module, exports) {

$parcel$export(module.exports, "pWhile", function () { return $2100fe5f6677ba83$export$b93337342c1781e2; });

var $l73V3 = parcelRequire("l73V3");
var $2100fe5f6677ba83$export$b93337342c1781e2 = function(condition, action) {
    return (0, $l73V3.__awaiter)(void 0, void 0, void 0, function() {
        var loop;
        return (0, $l73V3.__generator)(this, function(_a) {
            loop = function(actionResult) {
                return (0, $l73V3.__awaiter)(void 0, void 0, void 0, function() {
                    var _a;
                    return (0, $l73V3.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!condition(actionResult)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                _a = loop;
                                return [
                                    4 /*yield*/ ,
                                    action()
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    _a.apply(void 0, [
                                        _b.sent()
                                    ])
                                ];
                            case 2:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            return [
                2 /*return*/ ,
                loop(undefined)
            ];
        });
    });
};

});



parcelRegister("l6Or6", function(module, exports) {

$parcel$export(module.exports, "flushAddSourceMiddleware", function () { return $f5e1480f32cd6800$export$db2766844cf30385; });
$parcel$export(module.exports, "flushOn", function () { return $f5e1480f32cd6800$export$b06f0b90a3e464ad; });
$parcel$export(module.exports, "flushSetAnonymousID", function () { return $f5e1480f32cd6800$export$110fe6d52dfc6707; });
$parcel$export(module.exports, "flushAnalyticsCallsInNewTask", function () { return $f5e1480f32cd6800$export$8194c26690ee9033; });
$parcel$export(module.exports, "AnalyticsBuffered", function () { return $f5e1480f32cd6800$export$8480aa2faa45c50e; });

var $l73V3 = parcelRequire("l73V3");

var $kui6t = parcelRequire("kui6t");

var $iZQWy = parcelRequire("iZQWy");
var $f5e1480f32cd6800$var$flushSyncAnalyticsCalls = function(name, analytics, buffer) {
    buffer.getCalls(name).forEach(function(c) {
        // While the underlying methods are synchronous, the callAnalyticsMethod returns a promise,
        // which normalizes success and error states between async and non-async methods, with no perf penalty.
        $f5e1480f32cd6800$export$4e15dba5b8d09c70(analytics, c).catch(console.error);
    });
};
var $f5e1480f32cd6800$export$db2766844cf30385 = function(analytics, buffer) {
    return (0, $l73V3.__awaiter)(void 0, void 0, void 0, function() {
        var _i, _a, c;
        return (0, $l73V3.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _i = 0, _a = buffer.getCalls('addSourceMiddleware');
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [
                        3 /*break*/ ,
                        4
                    ];
                    c = _a[_i];
                    return [
                        4 /*yield*/ ,
                        $f5e1480f32cd6800$export$4e15dba5b8d09c70(analytics, c).catch(console.error)
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _i++;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $f5e1480f32cd6800$export$b06f0b90a3e464ad = $f5e1480f32cd6800$var$flushSyncAnalyticsCalls.bind(undefined, 'on');
var $f5e1480f32cd6800$export$110fe6d52dfc6707 = $f5e1480f32cd6800$var$flushSyncAnalyticsCalls.bind(undefined, 'setAnonymousId');
var $f5e1480f32cd6800$export$8194c26690ee9033 = function(analytics, buffer) {
    buffer.toArray().forEach(function(m) {
        setTimeout(function() {
            $f5e1480f32cd6800$export$4e15dba5b8d09c70(analytics, m).catch(console.error);
        }, 0);
    });
};
/**
 *  Represents any and all the buffered method calls that occurred before initialization.
 */ var $f5e1480f32cd6800$export$339e4854760a3a83 = /** @class */ function() {
    function PreInitMethodCallBuffer() {
        this._value = {};
    }
    PreInitMethodCallBuffer.prototype.toArray = function() {
        var _a;
        return (_a = []).concat.apply(_a, Object.values(this._value));
    };
    PreInitMethodCallBuffer.prototype.getCalls = function(methodName) {
        var _a;
        return (_a = this._value[methodName]) !== null && _a !== void 0 ? _a : [];
    };
    PreInitMethodCallBuffer.prototype.push = function() {
        var _this = this;
        var calls = [];
        for(var _i = 0; _i < arguments.length; _i++)calls[_i] = arguments[_i];
        calls.forEach(function(call) {
            if (_this._value[call.method]) _this._value[call.method].push(call);
            else _this._value[call.method] = [
                call
            ];
        });
        return this;
    };
    PreInitMethodCallBuffer.prototype.clear = function() {
        this._value = {};
        return this;
    };
    return PreInitMethodCallBuffer;
}();
function $f5e1480f32cd6800$export$4e15dba5b8d09c70(analytics, call) {
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var result, err_1;
        return (0, $l73V3.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (call.called) return [
                        2 /*return*/ ,
                        undefined
                    ];
                    call.called = true;
                    result = analytics[call.method].apply(analytics, call.args);
                    if (!(0, $kui6t.isThenable)(result)) return [
                        3 /*break*/ ,
                        2
                    ];
                    // do not defer for non-async methods
                    return [
                        4 /*yield*/ ,
                        result
                    ];
                case 1:
                    // do not defer for non-async methods
                    _a.sent();
                    _a.label = 2;
                case 2:
                    call.resolve(result);
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    err_1 = _a.sent();
                    call.reject(err_1);
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var $f5e1480f32cd6800$export$8480aa2faa45c50e = /** @class */ function() {
    function AnalyticsBuffered(loader) {
        var _this = this;
        this._preInitBuffer = new $f5e1480f32cd6800$export$339e4854760a3a83();
        this.trackSubmit = this._createMethod('trackSubmit');
        this.trackClick = this._createMethod('trackClick');
        this.trackLink = this._createMethod('trackLink');
        this.pageView = this._createMethod('pageview');
        this.identify = this._createMethod('identify');
        this.reset = this._createMethod('reset');
        this.group = this._createMethod('group');
        this.track = this._createMethod('track');
        this.ready = this._createMethod('ready');
        this.alias = this._createMethod('alias');
        this.debug = this._createChainableMethod('debug');
        this.page = this._createMethod('page');
        this.once = this._createChainableMethod('once');
        this.off = this._createChainableMethod('off');
        this.on = this._createChainableMethod('on');
        this.addSourceMiddleware = this._createMethod('addSourceMiddleware');
        this.setAnonymousId = this._createMethod('setAnonymousId');
        this.addDestinationMiddleware = this._createMethod('addDestinationMiddleware');
        this.screen = this._createMethod('screen');
        this.register = this._createMethod('register');
        this.deregister = this._createMethod('deregister');
        this.user = this._createMethod('user');
        this.VERSION = (0, $iZQWy.version);
        this._promise = loader(this._preInitBuffer);
        this._promise.then(function(_a) {
            var ajs = _a[0], ctx = _a[1];
            _this.instance = ajs;
            _this.ctx = ctx;
        }).catch(function() {
        // intentionally do nothing...
        // this result of this promise will be caught by the 'catch' block on this class.
        });
    }
    AnalyticsBuffered.prototype.then = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (_a = this._promise).then.apply(_a, args);
    };
    AnalyticsBuffered.prototype.catch = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (_a = this._promise).catch.apply(_a, args);
    };
    AnalyticsBuffered.prototype.finally = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (_a = this._promise).finally.apply(_a, args);
    };
    AnalyticsBuffered.prototype._createMethod = function(methodName) {
        var _this = this;
        return function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (_this.instance) {
                var result = (_a = _this.instance)[methodName].apply(_a, args);
                return Promise.resolve(result);
            }
            return new Promise(function(resolve, reject) {
                _this._preInitBuffer.push({
                    method: methodName,
                    args: args,
                    resolve: resolve,
                    reject: reject,
                    called: false
                });
            });
        };
    };
    /**
     *  These are for methods that where determining when the method gets "flushed" is not important.
     *  These methods will resolve when analytics is fully initialized, and return type (other than Analytics)will not be available.
     */ AnalyticsBuffered.prototype._createChainableMethod = function(methodName) {
        var _this = this;
        return function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (_this.instance) {
                (_a = _this.instance)[methodName].apply(_a, args);
                return _this;
            } else _this._preInitBuffer.push({
                method: methodName,
                args: args,
                resolve: function() {},
                reject: console.error,
                called: false
            });
            return _this;
        };
    };
    return AnalyticsBuffered;
}();

});
parcelRegister("kui6t", function(module, exports) {

$parcel$export(module.exports, "isThenable", function () { return $eea4a6f5c4782e4e$export$f5b060c2914b97c8; });
/**
 *  Check if  thenable
 *  (instanceof Promise doesn't respect realms)
 */ var $eea4a6f5c4782e4e$export$f5b060c2914b97c8 = function(value) {
    return typeof value === 'object' && value !== null && 'then' in value && typeof value.then === 'function';
};

});


parcelRegister("dSmJd", function(module, exports) {

$parcel$export(module.exports, "popSnippetWindowBuffer", function () { return $a1a1f2e5193a4b6f$export$b2ec81699e17996d; });
function $a1a1f2e5193a4b6f$export$67665406a4657c85(_a) {
    var methodName = _a[0], args = _a.slice(1);
    return {
        method: methodName,
        resolve: function() {},
        reject: console.error,
        args: args,
        called: false
    };
}
var $a1a1f2e5193a4b6f$var$normalizeSnippetBuffer = function(buffer) {
    return buffer.map($a1a1f2e5193a4b6f$export$67665406a4657c85);
};
var $a1a1f2e5193a4b6f$export$b2ec81699e17996d = function() {
    var wa = window.analytics;
    if (!Array.isArray(wa)) return [];
    var buffered = wa.splice(0, wa.length);
    return $a1a1f2e5193a4b6f$var$normalizeSnippetBuffer(buffered);
};

});

parcelRegister("80xCC", function(module, exports) {

$parcel$export(module.exports, "attachInspector", function () { return $5d486767b80c83af$export$a6fb66bee7fac298; });

var $7IbEO = parcelRequire("7IbEO");
var $5d486767b80c83af$var$_a;
var $5d486767b80c83af$var$_b;
var $5d486767b80c83af$var$env = (0, $7IbEO.getGlobal)();
// The code below assumes the inspector extension will use Object.assign
// to add the inspect interface on to this object reference (unless the
// extension code ran first and has already set up the variable)
var $5d486767b80c83af$var$inspectorHost = ($5d486767b80c83af$var$_a = ($5d486767b80c83af$var$_b = $5d486767b80c83af$var$env)['__INSPECTOR__']) !== null && $5d486767b80c83af$var$_a !== void 0 ? $5d486767b80c83af$var$_a : $5d486767b80c83af$var$_b['__INSPECTOR__'] = {};
var $5d486767b80c83af$export$a6fb66bee7fac298 = function(analytics) {
    var _a;
    return (_a = $5d486767b80c83af$var$inspectorHost.attach) === null || _a === void 0 ? void 0 : _a.call($5d486767b80c83af$var$inspectorHost, analytics);
};

});

parcelRegister("eT0KK", function(module, exports) {
module.exports = $parcel$import("48fIQ").then(()=>parcelRequire('eRAyS'));

});

parcelRegister("jyswI", function(module, exports) {
module.exports = $parcel$import("au2HD").then(()=>parcelRequire('3vdvB'));

});

parcelRegister("4dLY2", function(module, exports) {
module.exports = $parcel$import("05bnd").then(()=>parcelRequire('jSbBN'));

});

parcelRegister("65aNf", function(module, exports) {
module.exports = $parcel$import("8Qq9l").then(()=>parcelRequire('5RkPn'));

});

parcelRegister("9uxFj", function(module, exports) {
module.exports = $parcel$import("cne3x").then(()=>parcelRequire('6XVVk'));

});

parcelRegister("il4VX", function(module, exports) {
module.exports = $parcel$import("gQH08").then(()=>parcelRequire('5DkmZ'));

});


var $18553f67021b91e2$exports = {};
$parcel$extendImportMap({
    "48fIQ": "routing-middleware.7dc32fdf.js",
    "au2HD": "ajs-destination.8e7ae2c9.js",
    "05bnd": "legacy-video-plugins.f459ebc5.js",
    "kYrMJ": "index.umd.8e036abf.js",
    "8Qq9l": "schema-filter.161d998d.js",
    "cne3x": "in-app-plugin.0e5f441c.js",
    "gQH08": "remote-middleware.a3e01167.js",
    "iIuAS": "auto-track.2ad771a2.js",
    "dkehO": "query-string.1ffc4b2f.js"
});


//# sourceMappingURL=hub.7cd2e4f6.js.map
